export const OverviewIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_549_2223)">
      <path
        d="M18 5.83329C16.6167 5.83329 15.5 6.94996 15.5 8.33329C15.5 8.39163 15.5 8.44996 15.5083 8.50829L13.8167 9.07496C13.2833 8.06663 12.3 7.33329 11.1333 7.14163V5.34163C12.2 5.05829 13 4.08329 13 2.91663C13 1.53329 11.8833 0.416626 10.5 0.416626C9.11667 0.416626 8 1.53329 8 2.91663C8 4.08329 8.8 5.05829 9.875 5.34163V7.14163C8.70833 7.33329 7.725 8.06663 7.19167 9.07496L5.49167 8.50829C5.5 8.44996 5.5 8.39163 5.5 8.33329C5.5 6.94996 4.38333 5.83329 3 5.83329C1.61667 5.83329 0.5 6.94996 0.5 8.33329C0.5 9.71663 1.61667 10.8333 3 10.8333C3.88333 10.8333 4.65 10.375 5.1 9.69163L6.79167 10.2583C6.625 11.3333 6.93333 12.475 7.7 13.3333L6.525 14.8083C6.20833 14.6583 5.86667 14.5833 5.5 14.5833C4.11667 14.5833 3 15.7 3 17.0833C3 18.4666 4.11667 19.5833 5.5 19.5833C6.88333 19.5833 8 18.4666 8 17.0833C8 16.5166 7.81667 16 7.5 15.5833L8.675 14.1083C9.80833 14.7416 11.1917 14.7333 12.3167 14.1083L13.4917 15.5833C13.1833 16 13 16.5166 13 17.0833C13 18.4666 14.1167 19.5833 15.5 19.5833C16.8833 19.5833 18 18.4666 18 17.0833C18 15.7 16.8833 14.5833 15.5 14.5833C15.1333 14.5833 14.7917 14.6583 14.475 14.8L13.3 13.325C14.075 12.4583 14.375 11.325 14.2083 10.25L15.9 9.68329C16.3417 10.3666 17.1167 10.825 18 10.825C19.3833 10.825 20.5 9.70829 20.5 8.32496C20.5 6.94163 19.3833 5.83329 18 5.83329ZM3 9.16663C2.54167 9.16663 2.16667 8.79163 2.16667 8.33329C2.16667 7.87496 2.54167 7.49996 3 7.49996C3.45833 7.49996 3.83333 7.87496 3.83333 8.33329C3.83333 8.79163 3.45833 9.16663 3 9.16663ZM5.5 17.9166C5.04167 17.9166 4.66667 17.5416 4.66667 17.0833C4.66667 16.625 5.04167 16.25 5.5 16.25C5.95833 16.25 6.33333 16.625 6.33333 17.0833C6.33333 17.5416 5.95833 17.9166 5.5 17.9166ZM9.66667 2.91663C9.66667 2.45829 10.0417 2.08329 10.5 2.08329C10.9583 2.08329 11.3333 2.45829 11.3333 2.91663C11.3333 3.37496 10.9583 3.74996 10.5 3.74996C10.0417 3.74996 9.66667 3.37496 9.66667 2.91663ZM10.5 12.9166C9.35 12.9166 8.41667 11.9833 8.41667 10.8333C8.41667 9.68329 9.35 8.74996 10.5 8.74996C11.65 8.74996 12.5833 9.68329 12.5833 10.8333C12.5833 11.9833 11.65 12.9166 10.5 12.9166ZM15.5 16.25C15.9583 16.25 16.3333 16.625 16.3333 17.0833C16.3333 17.5416 15.9583 17.9166 15.5 17.9166C15.0417 17.9166 14.6667 17.5416 14.6667 17.0833C14.6667 16.625 15.0417 16.25 15.5 16.25ZM18 9.16663C17.5417 9.16663 17.1667 8.79163 17.1667 8.33329C17.1667 7.87496 17.5417 7.49996 18 7.49996C18.4583 7.49996 18.8333 7.87496 18.8333 8.33329C18.8333 8.79163 18.4583 9.16663 18 9.16663Z"
        fill="#77838F"
      />
    </g>
    <defs>
      <clipPath id="clip0_549_2223">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const OverviewFillIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_552_6009)">
      <path
        d="M18 6.33366C16.6167 6.33366 15.5 7.45033 15.5 8.83366C15.5 8.89199 15.5 8.95033 15.5083 9.00866L13.8167 9.57533C13.2833 8.56699 12.3 7.83366 11.1333 7.64199V5.84199C12.2 5.55866 13 4.58366 13 3.41699C13 2.03366 11.8833 0.916992 10.5 0.916992C9.11667 0.916992 8 2.03366 8 3.41699C8 4.58366 8.8 5.55866 9.875 5.84199V7.64199C8.70833 7.83366 7.725 8.56699 7.19167 9.57533L5.49167 9.00866C5.5 8.95033 5.5 8.89199 5.5 8.83366C5.5 7.45033 4.38333 6.33366 3 6.33366C1.61667 6.33366 0.5 7.45033 0.5 8.83366C0.5 10.217 1.61667 11.3337 3 11.3337C3.88333 11.3337 4.65 10.8753 5.1 10.192L6.79167 10.7587C6.625 11.8337 6.93333 12.9753 7.7 13.8337L6.525 15.3087C6.20833 15.1587 5.86667 15.0837 5.5 15.0837C4.11667 15.0837 3 16.2003 3 17.5837C3 18.967 4.11667 20.0837 5.5 20.0837C6.88333 20.0837 8 18.967 8 17.5837C8 17.017 7.81667 16.5003 7.5 16.0837L8.675 14.6087C9.80833 15.242 11.1917 15.2337 12.3167 14.6087L13.4917 16.0837C13.1833 16.5003 13 17.017 13 17.5837C13 18.967 14.1167 20.0837 15.5 20.0837C16.8833 20.0837 18 18.967 18 17.5837C18 16.2003 16.8833 15.0837 15.5 15.0837C15.1333 15.0837 14.7917 15.1587 14.475 15.3003L13.3 13.8253C14.075 12.9587 14.375 11.8253 14.2083 10.7503L15.9 10.1837C16.3417 10.867 17.1167 11.3253 18 11.3253C19.3833 11.3253 20.5 10.2087 20.5 8.82533C20.5 7.44199 19.3833 6.33366 18 6.33366ZM3 9.66699C2.54167 9.66699 2.16667 9.29199 2.16667 8.83366C2.16667 8.37533 2.54167 8.00033 3 8.00033C3.45833 8.00033 3.83333 8.37533 3.83333 8.83366C3.83333 9.29199 3.45833 9.66699 3 9.66699ZM5.5 18.417C5.04167 18.417 4.66667 18.042 4.66667 17.5837C4.66667 17.1253 5.04167 16.7503 5.5 16.7503C5.95833 16.7503 6.33333 17.1253 6.33333 17.5837C6.33333 18.042 5.95833 18.417 5.5 18.417ZM9.66667 3.41699C9.66667 2.95866 10.0417 2.58366 10.5 2.58366C10.9583 2.58366 11.3333 2.95866 11.3333 3.41699C11.3333 3.87533 10.9583 4.25033 10.5 4.25033C10.0417 4.25033 9.66667 3.87533 9.66667 3.41699ZM10.5 13.417C9.35 13.417 8.41667 12.4837 8.41667 11.3337C8.41667 10.1837 9.35 9.25033 10.5 9.25033C11.65 9.25033 12.5833 10.1837 12.5833 11.3337C12.5833 12.4837 11.65 13.417 10.5 13.417ZM15.5 16.7503C15.9583 16.7503 16.3333 17.1253 16.3333 17.5837C16.3333 18.042 15.9583 18.417 15.5 18.417C15.0417 18.417 14.6667 18.042 14.6667 17.5837C14.6667 17.1253 15.0417 16.7503 15.5 16.7503ZM18 9.66699C17.5417 9.66699 17.1667 9.29199 17.1667 8.83366C17.1667 8.37533 17.5417 8.00033 18 8.00033C18.4583 8.00033 18.8333 8.37533 18.8333 8.83366C18.8333 9.29199 18.4583 9.66699 18 9.66699Z"
        fill="#C3222A"
      />
    </g>
    <defs>
      <clipPath id="clip0_552_6009">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PaymentLoungeIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_549_2463)">
      <path
        d="M10.5 0C4.97691 0 0.5 4.47691 0.5 10C0.5 15.5231 4.97691 20 10.5 20C16.0231 20 20.5 15.5231 20.5 10C20.5 4.47691 16.0231 0 10.5 0ZM10.5 18.4375C5.83996 18.4375 2.0625 14.66 2.0625 10C2.0625 5.33996 5.83996 1.5625 10.5 1.5625C15.16 1.5625 18.9375 5.33996 18.9375 10C18.9375 14.66 15.16 18.4375 10.5 18.4375Z"
        fill="#77838F"
      />
      <path
        d="M8.7843 11.1157H10.6709C12.4751 11.1157 13.9827 10.0036 14.3867 8.11215C14.8439 5.9723 13.3088 5 11.9886 5H7.49156L5.5 14.1467H8.13793L8.7843 11.1157ZM9.72789 6.86156H11.0206C11.667 6.86156 12.0985 7.4182 11.9087 8.11219C11.7469 8.80859 11.0749 9.36402 10.4011 9.36402H9.16148L9.72789 6.86156Z"
        fill="#77838F"
      />
      <path
        d="M14.9809 6.71924C15.1879 7.17943 15.2562 7.75744 15.1061 8.46607C14.7014 10.3576 13.1938 11.4696 11.3896 11.4696H9.50363L8.85727 14.5006H6.64047L6.53125 14.9999H9.1698L9.81617 11.9701H11.7021C13.5064 11.9701 15.0139 10.858 15.4186 8.96596C15.631 7.97045 15.4106 7.2301 14.9809 6.71924Z"
        fill="#77838F"
      />
    </g>
    <defs>
      <clipPath id="clip0_549_2463">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const PaymentLoungeFillIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_754_3149)">
      <path
        d="M10 0C4.47691 0 0 4.47691 0 10C0 15.5231 4.47691 20 10 20C15.5231 20 20 15.5231 20 10C20 4.47691 15.5231 0 10 0ZM10 18.4375C5.33996 18.4375 1.5625 14.66 1.5625 10C1.5625 5.33996 5.33996 1.5625 10 1.5625C14.66 1.5625 18.4375 5.33996 18.4375 10C18.4375 14.66 14.66 18.4375 10 18.4375Z"
        fill="#C3222A"
      />
      <path
        d="M8.2843 11.1157H10.1709C11.9751 11.1157 13.4827 10.0036 13.8867 8.11215C14.3439 5.9723 12.8088 5 11.4886 5H6.99156L5 14.1467H7.63793L8.2843 11.1157ZM9.22789 6.86156H10.5206C11.167 6.86156 11.5985 7.4182 11.4087 8.11219C11.2469 8.80859 10.5749 9.36402 9.90109 9.36402H8.66148L9.22789 6.86156Z"
        fill="#C3222A"
      />
      <path
        d="M14.4809 6.71875C14.6879 7.17895 14.7562 7.75695 14.6061 8.46559C14.2014 10.3571 12.6938 11.4691 10.8896 11.4691H9.00363L8.35727 14.5002H6.14047L6.03125 14.9994H8.6698L9.31617 11.9696H11.2021C13.0064 11.9696 14.5139 10.8575 14.9186 8.96547C15.131 7.96996 14.9106 7.22961 14.4809 6.71875Z"
        fill="#C3222A"
      />
    </g>
    <defs>
      <clipPath id="clip0_754_3149">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UpiIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.4165 5.41663V7.91663H5.9165V5.41663H8.4165ZM9.6665 4.16663H4.6665V9.16663H9.6665V4.16663ZM8.4165 12.0833V14.5833H5.9165V12.0833H8.4165ZM9.6665 10.8333H4.6665V15.8333H9.6665V10.8333ZM15.0832 5.41663V7.91663H12.5832V5.41663H15.0832ZM16.3332 4.16663H11.3332V9.16663H16.3332V4.16663ZM11.3332 10.8333H12.5832V12.0833H11.3332V10.8333ZM12.5832 12.0833H13.8332V13.3333H12.5832V12.0833ZM13.8332 10.8333H15.0832V12.0833H13.8332V10.8333ZM11.3332 13.3333H12.5832V14.5833H11.3332V13.3333ZM12.5832 14.5833H13.8332V15.8333H12.5832V14.5833ZM13.8332 13.3333H15.0832V14.5833H13.8332V13.3333ZM15.0832 12.0833H16.3332V13.3333H15.0832V12.0833ZM15.0832 14.5833H16.3332V15.8333H15.0832V14.5833ZM18.8332 5.83329H17.1665V3.33329H14.6665V1.66663H18.8332V5.83329ZM18.8332 18.3333V14.1666H17.1665V16.6666H14.6665V18.3333H18.8332ZM2.1665 18.3333H6.33317V16.6666H3.83317V14.1666H2.1665V18.3333ZM2.1665 1.66663V5.83329H3.83317V3.33329H6.33317V1.66663H2.1665Z"
      fill="#77838F"
    />
  </svg>
);

export const UpiFillIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.4165 5.41602V7.91602H5.9165V5.41602H8.4165ZM9.6665 4.16602H4.6665V9.16602H9.6665V4.16602ZM8.4165 12.0827V14.5827H5.9165V12.0827H8.4165ZM9.6665 10.8327H4.6665V15.8327H9.6665V10.8327ZM15.0832 5.41602V7.91602H12.5832V5.41602H15.0832ZM16.3332 4.16602H11.3332V9.16602H16.3332V4.16602ZM11.3332 10.8327H12.5832V12.0827H11.3332V10.8327ZM12.5832 12.0827H13.8332V13.3327H12.5832V12.0827ZM13.8332 10.8327H15.0832V12.0827H13.8332V10.8327ZM11.3332 13.3327H12.5832V14.5827H11.3332V13.3327ZM12.5832 14.5827H13.8332V15.8327H12.5832V14.5827ZM13.8332 13.3327H15.0832V14.5827H13.8332V13.3327ZM15.0832 12.0827H16.3332V13.3327H15.0832V12.0827ZM15.0832 14.5827H16.3332V15.8327H15.0832V14.5827ZM18.8332 5.83268H17.1665V3.33268H14.6665V1.66602H18.8332V5.83268ZM18.8332 18.3327V14.166H17.1665V16.666H14.6665V18.3327H18.8332ZM2.1665 18.3327H6.33317V16.666H3.83317V14.166H2.1665V18.3327ZM2.1665 1.66602V5.83268H3.83317V3.33268H6.33317V1.66602H2.1665Z"
      fill="#C3222A"
    />
  </svg>
);

export const Upi123Icon = () => (
  <svg
    width="15"
    height="21"
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.52651 0.5L14.5557 10.5L3.98273 20.5L9.52651 0.5Z"
      fill="#77838F"
    />
    <path
      d="M5.9953 0.5L11.0245 10.5L0.444336 20.5L5.9953 0.5Z"
      fill="#ababab"
    />
  </svg>
);

export const Upi123FillIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="21"
    viewBox="0 0 15 21"
    fill="none"
  >
    <path
      d="M9.52651 0.5L14.5557 10.5L3.98273 20.5L9.52651 0.5Z"
      fill="#8B151B"
    />
    <path
      d="M5.9953 0.5L11.0245 10.5L0.444336 20.5L5.9953 0.5Z"
      fill="#C3222A"
    />
  </svg>
);

export const BbpsIcon = () => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.14355 3.41734H8.63965C9.03217 3.41734 9.41047 3.4501 9.77415 3.51577C10.1384 3.5813 10.4607 3.69775 10.7407 3.86537C11.0212 4.03353 11.2448 4.26709 11.413 4.56591C11.5809 4.8642 11.6652 5.24751 11.6652 5.71368C11.6652 6.55504 11.413 7.16203 10.9092 7.53545C12.2066 7.7858 13.1686 8.05308 14.187 8.54443C14.6131 8.23167 14.965 7.87787 15.2366 7.47926C15.6939 6.80634 15.9227 5.96647 15.9227 4.95748C15.9227 4.02432 15.7686 3.24064 15.4608 2.60482C15.1523 1.97048 14.7186 1.46166 14.1579 1.07835C13.598 0.696392 12.9255 0.420451 12.1414 0.252288C11.3569 0.0845299 10.4885 4.19617e-05 9.53598 4.19617e-05H5.14355V3.41734Z"
      fill="#77838F"
    />
    <path
      d="M12.2116 15.2378C12.0339 15.5748 11.7958 15.8411 11.4972 16.0365C11.1983 16.2328 10.8531 16.3722 10.4609 16.4569C10.0685 16.5402 9.6573 16.5824 9.22823 16.5824H4.52222V11.0923H9.31204C10.2648 11.0923 11.0302 11.3129 11.6095 11.7506C12.188 12.1895 12.4771 12.9225 12.4771 13.9499C12.4771 14.4727 12.3892 14.9017 12.2116 15.2378ZM8.97612 8.09545H4.52222V3.41733H4.52425V3.62396e-05H0.124512V20H9.8168C10.7131 20 11.5852 19.8886 12.4359 19.6638C13.2856 19.4403 14.0415 19.0945 14.7045 18.6277C15.367 18.1612 15.8952 17.5588 16.2876 16.8213C16.6796 16.0832 16.8753 15.2099 16.8753 14.2013C16.8753 12.9513 16.5485 11.8978 15.9651 10.9942C14.838 9.24904 12.3942 8.09545 8.97612 8.09545Z"
      fill="#77838F"
    />
  </svg>
);
export const BbpsFillIcon = () => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.14355 3.41734H8.63965C9.03217 3.41734 9.41047 3.4501 9.77415 3.51577C10.1384 3.5813 10.4607 3.69775 10.7407 3.86537C11.0212 4.03353 11.2448 4.26709 11.413 4.56591C11.5809 4.8642 11.6652 5.24751 11.6652 5.71368C11.6652 6.55504 11.413 7.16203 10.9092 7.53545C12.2066 7.7858 13.1686 8.05308 14.187 8.54443C14.6131 8.23167 14.965 7.87787 15.2366 7.47926C15.6939 6.80634 15.9227 5.96647 15.9227 4.95748C15.9227 4.02432 15.7686 3.24064 15.4608 2.60482C15.1523 1.97048 14.7186 1.46166 14.1579 1.07835C13.598 0.696392 12.9255 0.420451 12.1414 0.252288C11.3569 0.0845299 10.4885 4.19617e-05 9.53598 4.19617e-05H5.14355V3.41734Z"
      fill="#C3222A"
    />
    <path
      d="M12.2116 15.2378C12.0339 15.5748 11.7958 15.8411 11.4972 16.0365C11.1983 16.2328 10.8531 16.3722 10.4609 16.4569C10.0685 16.5402 9.6573 16.5824 9.22823 16.5824H4.52222V11.0923H9.31204C10.2648 11.0923 11.0302 11.3129 11.6095 11.7506C12.188 12.1895 12.4771 12.9225 12.4771 13.9499C12.4771 14.4727 12.3892 14.9017 12.2116 15.2378ZM8.97612 8.09545H4.52222V3.41733H4.52425V3.62396e-05H0.124512V20H9.8168C10.7131 20 11.5852 19.8886 12.4359 19.6638C13.2856 19.4403 14.0415 19.0945 14.7045 18.6277C15.367 18.1612 15.8952 17.5588 16.2876 16.8213C16.6796 16.0832 16.8753 15.2099 16.8753 14.2013C16.8753 12.9513 16.5485 11.8978 15.9651 10.9942C14.838 9.24904 12.3942 8.09545 8.97612 8.09545Z"
      fill="#C3222A"
    />
  </svg>
);
export const PpiIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5835 6.06667V4.16667C17.5835 3.25 16.8335 2.5 15.9168 2.5H4.25016C3.32516 2.5 2.5835 3.25 2.5835 4.16667V15.8333C2.5835 16.75 3.32516 17.5 4.25016 17.5H15.9168C16.8335 17.5 17.5835 16.75 17.5835 15.8333V13.9333C18.0752 13.6417 18.4168 13.1167 18.4168 12.5V7.5C18.4168 6.88333 18.0752 6.35833 17.5835 6.06667ZM16.7502 7.5V12.5H10.9168V7.5H16.7502ZM4.25016 15.8333V4.16667H15.9168V5.83333H10.9168C10.0002 5.83333 9.25016 6.58333 9.25016 7.5V12.5C9.25016 13.4167 10.0002 14.1667 10.9168 14.1667H15.9168V15.8333H4.25016Z"
      fill="#77838F"
    />
    <path
      d="M13.4168 11.25C14.1072 11.25 14.6668 10.6904 14.6668 10C14.6668 9.30964 14.1072 8.75 13.4168 8.75C12.7265 8.75 12.1668 9.30964 12.1668 10C12.1668 10.6904 12.7265 11.25 13.4168 11.25Z"
      fill="#77838F"
    />
  </svg>
);
export const PpiFillIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5835 6.06667V4.16667C17.5835 3.25 16.8335 2.5 15.9168 2.5H4.25016C3.32516 2.5 2.5835 3.25 2.5835 4.16667V15.8333C2.5835 16.75 3.32516 17.5 4.25016 17.5H15.9168C16.8335 17.5 17.5835 16.75 17.5835 15.8333V13.9333C18.0752 13.6417 18.4168 13.1167 18.4168 12.5V7.5C18.4168 6.88333 18.0752 6.35833 17.5835 6.06667ZM16.7502 7.5V12.5H10.9168V7.5H16.7502ZM4.25016 15.8333V4.16667H15.9168V5.83333H10.9168C10.0002 5.83333 9.25016 6.58333 9.25016 7.5V12.5C9.25016 13.4167 10.0002 14.1667 10.9168 14.1667H15.9168V15.8333H4.25016Z"
      fill="#C3222A"
    />
    <path
      d="M13.4168 11.25C14.1072 11.25 14.6668 10.6904 14.6668 10C14.6668 9.30964 14.1072 8.75 13.4168 8.75C12.7265 8.75 12.1668 9.30964 12.1668 10C12.1668 10.6904 12.7265 11.25 13.4168 11.25Z"
      fill="#C3222A"
    />
  </svg>
);

export const PspIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4998 1.66663C5.89984 1.66663 2.1665 5.39996 2.1665 9.99996C2.1665 14.6 5.89984 18.3333 10.4998 18.3333C15.0998 18.3333 18.8332 14.6 18.8332 9.99996C18.8332 5.39996 15.0998 1.66663 10.4998 1.66663ZM10.4998 16.6666C6.8165 16.6666 3.83317 13.6833 3.83317 9.99996C3.83317 6.31663 6.8165 3.33329 10.4998 3.33329C14.1832 3.33329 17.1665 6.31663 17.1665 9.99996C17.1665 13.6833 14.1832 16.6666 10.4998 16.6666Z"
      fill="#77838F"
    />
    <path
      d="M6.4165 8.48329C6.63317 8.94996 6.7415 9.44996 6.74984 9.98329C6.75817 10.5083 6.6415 11.025 6.4165 11.5333L7.55817 12.05C7.8665 11.375 8.0165 10.675 8.00817 9.96663C7.99984 9.26663 7.84984 8.59163 7.55817 7.96663L6.4165 8.48329Z"
      fill="#77838F"
    />
    <path
      d="M11.6082 6.10829C12.2582 7.41663 12.5915 8.72496 12.5915 9.97496C12.5915 11.2333 12.2582 12.55 11.6082 13.8833L12.7332 14.4333C13.4665 12.925 13.8415 11.425 13.8415 9.97496C13.8415 8.52496 13.4665 7.03329 12.7332 5.54996L11.6082 6.10829Z"
      fill="#77838F"
    />
    <path
      d="M8.99984 7.26663C9.4415 8.15829 9.6665 9.10829 9.6665 10.1C9.6665 11.075 9.44984 11.9583 9.0165 12.725L10.0998 13.3416C10.6415 12.3833 10.9165 11.3 10.9165 10.1C10.9165 8.91663 10.6498 7.77496 10.1165 6.70829L8.99984 7.26663Z"
      fill="#77838F"
    />
  </svg>
);
export const PspFillIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4998 1.66663C5.89984 1.66663 2.1665 5.39996 2.1665 9.99996C2.1665 14.6 5.89984 18.3333 10.4998 18.3333C15.0998 18.3333 18.8332 14.6 18.8332 9.99996C18.8332 5.39996 15.0998 1.66663 10.4998 1.66663ZM10.4998 16.6666C6.8165 16.6666 3.83317 13.6833 3.83317 9.99996C3.83317 6.31663 6.8165 3.33329 10.4998 3.33329C14.1832 3.33329 17.1665 6.31663 17.1665 9.99996C17.1665 13.6833 14.1832 16.6666 10.4998 16.6666Z"
      fill="#C3222A"
    />
    <path
      d="M6.4165 8.48329C6.63317 8.94996 6.7415 9.44996 6.74984 9.98329C6.75817 10.5083 6.6415 11.025 6.4165 11.5333L7.55817 12.05C7.8665 11.375 8.0165 10.675 8.00817 9.96663C7.99984 9.26663 7.84984 8.59163 7.55817 7.96663L6.4165 8.48329Z"
      fill="#C3222A"
    />
    <path
      d="M11.6082 6.10829C12.2582 7.41663 12.5915 8.72496 12.5915 9.97496C12.5915 11.2333 12.2582 12.55 11.6082 13.8833L12.7332 14.4333C13.4665 12.925 13.8415 11.425 13.8415 9.97496C13.8415 8.52496 13.4665 7.03329 12.7332 5.54996L11.6082 6.10829Z"
      fill="#C3222A"
    />
    <path
      d="M8.99984 7.26663C9.4415 8.15829 9.6665 9.10829 9.6665 10.1C9.6665 11.075 9.44984 11.9583 9.0165 12.725L10.0998 13.3416C10.6415 12.3833 10.9165 11.3 10.9165 10.1C10.9165 8.91663 10.6498 7.77496 10.1165 6.70829L8.99984 7.26663Z"
      fill="#C3222A"
    />
  </svg>
);

export const SettingsIcon = () => (
  <svg
    className="setting-icon"
    width="18"
    height="19"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9323 12.98C19.9723 12.66 20.0023 12.34 20.0023 12C20.0023 11.66 19.9723 11.34 19.9323 11.02L22.0423 9.37C22.2323 9.22 22.2823 8.95 22.1623 8.73L20.1623 5.27C20.0723 5.11 19.9023 5.02 19.7223 5.02C19.6623 5.02 19.6023 5.03 19.5523 5.05L17.0623 6.05C16.5423 5.65 15.9823 5.32 15.3723 5.07L14.9923 2.42C14.9623 2.18 14.7523 2 14.5023 2H10.5023C10.2523 2 10.0423 2.18 10.0123 2.42L9.63228 5.07C9.02228 5.32 8.46228 5.66 7.94228 6.05L5.45228 5.05C5.39228 5.03 5.33228 5.02 5.27228 5.02C5.10228 5.02 4.93228 5.11 4.84228 5.27L2.84228 8.73C2.71228 8.95 2.77228 9.22 2.96228 9.37L5.07228 11.02C5.03228 11.34 5.00228 11.67 5.00228 12C5.00228 12.33 5.03228 12.66 5.07228 12.98L2.96228 14.63C2.77228 14.78 2.72228 15.05 2.84228 15.27L4.84228 18.73C4.93228 18.89 5.10228 18.98 5.28228 18.98C5.34228 18.98 5.40228 18.97 5.45228 18.95L7.94228 17.95C8.46228 18.35 9.02228 18.68 9.63228 18.93L10.0123 21.58C10.0423 21.82 10.2523 22 10.5023 22H14.5023C14.7523 22 14.9623 21.82 14.9923 21.58L15.3723 18.93C15.9823 18.68 16.5423 18.34 17.0623 17.95L19.5523 18.95C19.6123 18.97 19.6723 18.98 19.7323 18.98C19.9023 18.98 20.0723 18.89 20.1623 18.73L22.1623 15.27C22.2823 15.05 22.2323 14.78 22.0423 14.63L19.9323 12.98ZM17.9523 11.27C17.9923 11.58 18.0023 11.79 18.0023 12C18.0023 12.21 17.9823 12.43 17.9523 12.73L17.8123 13.86L18.7023 14.56L19.7823 15.4L19.0823 16.61L17.8123 16.1L16.7723 15.68L15.8723 16.36C15.4423 16.68 15.0323 16.92 14.6223 17.09L13.5623 17.52L13.4023 18.65L13.2023 20H11.8023L11.4523 17.52L10.3923 17.09C9.96228 16.91 9.56228 16.68 9.16228 16.38L8.25228 15.68L7.19228 16.11L5.92228 16.62L5.22228 15.41L6.30228 14.57L7.19228 13.87L7.05228 12.74C7.02228 12.43 7.00228 12.2 7.00228 12C7.00228 11.8 7.02228 11.57 7.05228 11.27L7.19228 10.14L6.30228 9.44L5.22228 8.6L5.92228 7.39L7.19228 7.9L8.23228 8.32L9.13228 7.64C9.56228 7.32 9.97228 7.08 10.3823 6.91L11.4423 6.48L11.6023 5.35L11.8023 4H13.1923L13.5423 6.48L14.6023 6.91C15.0323 7.09 15.4323 7.32 15.8323 7.62L16.7423 8.32L17.8023 7.89L19.0723 7.38L19.7723 8.59L18.7023 9.44L17.8123 10.14L17.9523 11.27ZM12.5023 8C10.2923 8 8.50228 9.79 8.50228 12C8.50228 14.21 10.2923 16 12.5023 16C14.7123 16 16.5023 14.21 16.5023 12C16.5023 9.79 14.7123 8 12.5023 8ZM12.5023 14C11.4023 14 10.5023 13.1 10.5023 12C10.5023 10.9 11.4023 10 12.5023 10C13.6023 10 14.5023 10.9 14.5023 12C14.5023 13.1 13.6023 14 12.5023 14Z"
      fill="#ABB9E8"
    />
  </svg>
);

export const SettingsFillIcon = () => (
  <svg
    className="setting-icon"
    width="18"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4323 12.98C19.4723 12.66 19.5023 12.34 19.5023 12C19.5023 11.66 19.4723 11.34 19.4323 11.02L21.5423 9.37C21.7323 9.22 21.7823 8.95 21.6623 8.73L19.6623 5.27C19.5723 5.11 19.4023 5.02 19.2223 5.02C19.1623 5.02 19.1023 5.03 19.0523 5.05L16.5623 6.05C16.0423 5.65 15.4823 5.32 14.8723 5.07L14.4923 2.42C14.4623 2.18 14.2523 2 14.0023 2H10.0023C9.75228 2 9.54228 2.18 9.51228 2.42L9.13228 5.07C8.52228 5.32 7.96228 5.66 7.44228 6.05L4.95228 5.05C4.89228 5.03 4.83228 5.02 4.77228 5.02C4.60228 5.02 4.43228 5.11 4.34228 5.27L2.34228 8.73C2.21228 8.95 2.27228 9.22 2.46228 9.37L4.57228 11.02C4.53228 11.34 4.50228 11.67 4.50228 12C4.50228 12.33 4.53228 12.66 4.57228 12.98L2.46228 14.63C2.27228 14.78 2.22228 15.05 2.34228 15.27L4.34228 18.73C4.43228 18.89 4.60228 18.98 4.78228 18.98C4.84228 18.98 4.90228 18.97 4.95228 18.95L7.44228 17.95C7.96228 18.35 8.52228 18.68 9.13228 18.93L9.51228 21.58C9.54228 21.82 9.75228 22 10.0023 22H14.0023C14.2523 22 14.4623 21.82 14.4923 21.58L14.8723 18.93C15.4823 18.68 16.0423 18.34 16.5623 17.95L19.0523 18.95C19.1123 18.97 19.1723 18.98 19.2323 18.98C19.4023 18.98 19.5723 18.89 19.6623 18.73L21.6623 15.27C21.7823 15.05 21.7323 14.78 21.5423 14.63L19.4323 12.98ZM17.4523 11.27C17.4923 11.58 17.5023 11.79 17.5023 12C17.5023 12.21 17.4823 12.43 17.4523 12.73L17.3123 13.86L18.2023 14.56L19.2823 15.4L18.5823 16.61L17.3123 16.1L16.2723 15.68L15.3723 16.36C14.9423 16.68 14.5323 16.92 14.1223 17.09L13.0623 17.52L12.9023 18.65L12.7023 20H11.3023L10.9523 17.52L9.89228 17.09C9.46228 16.91 9.06228 16.68 8.66228 16.38L7.75228 15.68L6.69228 16.11L5.42228 16.62L4.72228 15.41L5.80228 14.57L6.69228 13.87L6.55228 12.74C6.52228 12.43 6.50228 12.2 6.50228 12C6.50228 11.8 6.52228 11.57 6.55228 11.27L6.69228 10.14L5.80228 9.44L4.72228 8.6L5.42228 7.39L6.69228 7.9L7.73228 8.32L8.63228 7.64C9.06228 7.32 9.47228 7.08 9.88228 6.91L10.9423 6.48L11.1023 5.35L11.3023 4H12.6923L13.0423 6.48L14.1023 6.91C14.5323 7.09 14.9323 7.32 15.3323 7.62L16.2423 8.32L17.3023 7.89L18.5723 7.38L19.2723 8.59L18.2023 9.44L17.3123 10.14L17.4523 11.27ZM12.0023 8C9.79228 8 8.00228 9.79 8.00228 12C8.00228 14.21 9.79228 16 12.0023 16C14.2123 16 16.0023 14.21 16.0023 12C16.0023 9.79 14.2123 8 12.0023 8ZM12.0023 14C10.9023 14 10.0023 13.1 10.0023 12C10.0023 10.9 10.9023 10 12.0023 10C13.1023 10 14.0023 10.9 14.0023 12C14.0023 13.1 13.1023 14 12.0023 14Z"
      fill="#405189"
    />
  </svg>
);

export const ModuleDownArrow = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4425 6.22119L9 9.65619L5.5575 6.22119L4.5 7.27869L9 11.7787L13.5 7.27869L12.4425 6.22119Z"
      fill="#1D1D1D"
    />
  </svg>
);
export const ModuleRightArrow = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.22119 12.4425L9.65619 9L6.22119 5.5575L7.27869 4.5L11.7787 9L7.27869 13.5L6.22119 12.4425Z"
      fill="#1D1D1D"
    />
  </svg>
);
export const ListIcon = () => (
  <svg
    width="69"
    height="68"
    viewBox="0 0 69 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_549_2497)">
      <rect
        x="12.5"
        y="12"
        width="44"
        height="44"
        rx="22"
        fill="white"
        shapeRendering="crispEdges"
      />
      <path
        d="M39.1584 39L40.3334 37.825L36.5167 34L40.3334 30.175L39.1584 29L34.1584 34L39.1584 39Z"
        fill="#C7222A"
      />
      <path
        d="M33.6667 39L34.8417 37.825L31.0251 34L34.8417 30.175L33.6667 29L28.6667 34L33.6667 39Z"
        fill="#C7222A"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_549_2497"
        x="0.5"
        y="0"
        width="68"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_549_2497"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_549_2497"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const ListOpenIcon = () => (
  <svg
    width="69"
    height="69"
    viewBox="0 0 69 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_576_751)">
      <rect
        x="56.5339"
        y="56.9316"
        width="44"
        height="44"
        rx="22"
        transform="rotate(179.912 56.5339 56.9316)"
        fill="white"
        shapeRendering="crispEdges"
      />
      <path
        d="M29.834 29.9712L28.6608 31.148L32.4834 34.9672L28.6726 38.798L29.8494 39.9712L34.8417 34.9635L29.834 29.9712Z"
        fill="#1D1D1D"
      />
      <path
        d="M35.3257 29.9628L34.1525 31.1396L37.975 34.9587L34.1643 38.7896L35.3411 39.9628L40.3334 34.9551L35.3257 29.9628Z"
        fill="#1D1D1D"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_576_751"
        x="0.466309"
        y="0.931641"
        width="68.0676"
        height="68.0684"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_576_751"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_576_751"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const AccountIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99984 1.66699C5.39984 1.66699 1.6665 5.40033 1.6665 10.0003C1.6665 14.6003 5.39984 18.3337 9.99984 18.3337C14.5998 18.3337 18.3332 14.6003 18.3332 10.0003C18.3332 5.40033 14.5998 1.66699 9.99984 1.66699ZM5.8915 15.2337C6.24984 14.4837 8.43317 13.7503 9.99984 13.7503C11.5665 13.7503 13.7582 14.4837 14.1082 15.2337C12.9748 16.1337 11.5498 16.667 9.99984 16.667C8.44984 16.667 7.02484 16.1337 5.8915 15.2337ZM15.2998 14.0253C14.1082 12.5753 11.2165 12.0837 9.99984 12.0837C8.78317 12.0837 5.8915 12.5753 4.69984 14.0253C3.84984 12.9087 3.33317 11.517 3.33317 10.0003C3.33317 6.32533 6.32484 3.33366 9.99984 3.33366C13.6748 3.33366 16.6665 6.32533 16.6665 10.0003C16.6665 11.517 16.1498 12.9087 15.2998 14.0253ZM9.99984 5.00033C8.38317 5.00033 7.08317 6.30033 7.08317 7.91699C7.08317 9.53366 8.38317 10.8337 9.99984 10.8337C11.6165 10.8337 12.9165 9.53366 12.9165 7.91699C12.9165 6.30033 11.6165 5.00033 9.99984 5.00033ZM9.99984 9.16699C9.30817 9.16699 8.74984 8.60866 8.74984 7.91699C8.74984 7.22533 9.30817 6.66699 9.99984 6.66699C10.6915 6.66699 11.2498 7.22533 11.2498 7.91699C11.2498 8.60866 10.6915 9.16699 9.99984 9.16699Z"
      fill="white"
    />
  </svg>
);

export const BellIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 18.125C10.9168 18.125 11.6668 17.375 11.6668 16.4583H8.3335C8.3335 17.375 9.0835 18.125 10.0002 18.125ZM15.0002 13.125V8.95833C15.0002 6.4 13.6418 4.25833 11.2502 3.69167V3.125C11.2502 2.43333 10.6918 1.875 10.0002 1.875C9.3085 1.875 8.75016 2.43333 8.75016 3.125V3.69167C6.36683 4.25833 5.00016 6.39167 5.00016 8.95833V13.125L3.3335 14.7917V15.625H16.6668V14.7917L15.0002 13.125ZM13.3335 13.9583H6.66683V8.95833C6.66683 6.89167 7.92516 5.20833 10.0002 5.20833C12.0752 5.20833 13.3335 6.89167 13.3335 8.95833V13.9583Z"
      fill="white"
    />
  </svg>
);

export const LineIcon = () => (
  <svg
    width="1"
    height="32"
    viewBox="0 0 1 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="0.25"
      y1="1.09278e-08"
      x2="0.249999"
      y2="32"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const SwapIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.11315 9.87938L2.79648 12.2044C2.63815 12.371 2.63815 12.6294 2.79648 12.796L5.11315 15.121C5.37148 15.3877 5.82148 15.196 5.82148 14.8294V13.3294H10.8298C11.2882 13.3294 11.6632 12.9544 11.6632 12.496C11.6632 12.0377 11.2882 11.6627 10.8298 11.6627H5.82148V10.171C5.82148 9.79605 5.37148 9.61271 5.11315 9.87938ZM17.2048 7.20438L14.8882 4.87938C14.6298 4.61271 14.1798 4.80438 14.1798 5.17104V6.66271H9.16315C8.70482 6.66271 8.32982 7.03771 8.32982 7.49604C8.32982 7.95438 8.70482 8.32938 9.16315 8.32938H14.1715V9.82104C14.1715 10.196 14.6215 10.3794 14.8798 10.1127L17.1965 7.78771C17.3631 7.62938 17.3631 7.36271 17.2048 7.20438Z"
      fill="white"
    />
  </svg>
);

export const QrCodeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9165 5.41699V7.91699H5.4165V5.41699H7.9165ZM9.1665 4.16699H4.1665V9.16699H9.1665V4.16699ZM7.9165 12.0837V14.5837H5.4165V12.0837H7.9165ZM9.1665 10.8337H4.1665V15.8337H9.1665V10.8337ZM14.5832 5.41699V7.91699H12.0832V5.41699H14.5832ZM15.8332 4.16699H10.8332V9.16699H15.8332V4.16699ZM10.8332 10.8337H12.0832V12.0837H10.8332V10.8337ZM12.0832 12.0837H13.3332V13.3337H12.0832V12.0837ZM13.3332 10.8337H14.5832V12.0837H13.3332V10.8337ZM10.8332 13.3337H12.0832V14.5837H10.8332V13.3337ZM12.0832 14.5837H13.3332V15.8337H12.0832V14.5837ZM13.3332 13.3337H14.5832V14.5837H13.3332V13.3337ZM14.5832 12.0837H15.8332V13.3337H14.5832V12.0837ZM14.5832 14.5837H15.8332V15.8337H14.5832V14.5837ZM17.4998 5.83366C17.0415 5.83366 16.6665 5.45866 16.6665 5.00033V3.33366H14.9998C14.5415 3.33366 14.1665 2.95866 14.1665 2.50033C14.1665 2.04199 14.5415 1.66699 14.9998 1.66699H17.4998C17.9582 1.66699 18.3332 2.04199 18.3332 2.50033V5.00033C18.3332 5.45866 17.9582 5.83366 17.4998 5.83366ZM18.3332 17.5003V15.0003C18.3332 14.542 17.9582 14.167 17.4998 14.167C17.0415 14.167 16.6665 14.542 16.6665 15.0003V16.667H14.9998C14.5415 16.667 14.1665 17.042 14.1665 17.5003C14.1665 17.9587 14.5415 18.3337 14.9998 18.3337H17.4998C17.9582 18.3337 18.3332 17.9587 18.3332 17.5003ZM2.49984 18.3337H4.99984C5.45817 18.3337 5.83317 17.9587 5.83317 17.5003C5.83317 17.042 5.45817 16.667 4.99984 16.667H3.33317V15.0003C3.33317 14.542 2.95817 14.167 2.49984 14.167C2.0415 14.167 1.6665 14.542 1.6665 15.0003V17.5003C1.6665 17.9587 2.0415 18.3337 2.49984 18.3337ZM1.6665 2.50033V5.00033C1.6665 5.45866 2.0415 5.83366 2.49984 5.83366C2.95817 5.83366 3.33317 5.45866 3.33317 5.00033V3.33366H4.99984C5.45817 3.33366 5.83317 2.95866 5.83317 2.50033C5.83317 2.04199 5.45817 1.66699 4.99984 1.66699H2.49984C2.0415 1.66699 1.6665 2.04199 1.6665 2.50033Z"
      fill="white"
    />
  </svg>
);

export const PaypalIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_573_2923)">
      <path
        d="M10 0C4.47691 0 0 4.47691 0 10C0 15.5231 4.47691 20 10 20C15.5231 20 20 15.5231 20 10C20 4.47691 15.5231 0 10 0ZM10 18.4375C5.33996 18.4375 1.5625 14.66 1.5625 10C1.5625 5.33996 5.33996 1.5625 10 1.5625C14.66 1.5625 18.4375 5.33996 18.4375 10C18.4375 14.66 14.66 18.4375 10 18.4375Z"
        fill="white"
      />
      <path
        d="M8.2843 11.1157H10.1709C11.9751 11.1157 13.4827 10.0036 13.8867 8.11215C14.3439 5.9723 12.8088 5 11.4886 5H6.99156L5 14.1467H7.63793L8.2843 11.1157ZM9.22789 6.86156H10.5206C11.167 6.86156 11.5985 7.4182 11.4087 8.11219C11.2469 8.80859 10.5749 9.36402 9.90109 9.36402H8.66148L9.22789 6.86156Z"
        fill="white"
      />
      <path
        d="M14.4809 6.71973C14.6879 7.17992 14.7562 7.75793 14.6061 8.46656C14.2014 10.358 12.6938 11.4701 10.8896 11.4701H9.00363L8.35727 14.5011H6.14047L6.03125 15.0004H8.6698L9.31617 11.9706H11.2021C13.0064 11.9706 14.5139 10.8585 14.9186 8.96644C15.131 7.97094 14.9106 7.23059 14.4809 6.71973Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_573_2923">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.23263 12.6667C11.1781 12.6667 13.566 10.2789 13.566 7.33333C13.566 4.38781 11.1781 2 8.23263 2C5.28711 2 2.89929 4.38781 2.89929 7.33333C2.89929 10.2789 5.28711 12.6667 8.23263 12.6667Z"
      stroke="#0C2033"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8993 14.0001L11.9993 11.1001"
      stroke="#0C2033"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ActivitySearchIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.19059 7.3151H7.72976L7.56643 7.1576C8.13809 6.4926 8.48226 5.62927 8.48226 4.6901C8.48226 2.59594 6.78476 0.898438 4.69059 0.898438C2.59643 0.898438 0.898926 2.59594 0.898926 4.6901C0.898926 6.78427 2.59643 8.48177 4.69059 8.48177C5.62976 8.48177 6.49309 8.1376 7.15809 7.56594L7.31559 7.72927V8.1901L10.2323 11.1009L11.1014 10.2318L8.19059 7.3151ZM4.69059 7.3151C3.23809 7.3151 2.06559 6.1426 2.06559 4.6901C2.06559 3.2376 3.23809 2.0651 4.69059 2.0651C6.14309 2.0651 7.31559 3.2376 7.31559 4.6901C7.31559 6.1426 6.14309 7.3151 4.69059 7.3151Z"
      fill="#CCD6DE"
    />
  </svg>
);

export const SettingIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4323 10.98C17.4723 10.66 17.5023 10.34 17.5023 10C17.5023 9.66 17.4723 9.34 17.4323 9.02L19.5423 7.37C19.7323 7.22 19.7823 6.95 19.6623 6.73L17.6623 3.27C17.5723 3.11 17.4023 3.02 17.2223 3.02C17.1623 3.02 17.1023 3.03 17.0523 3.05L14.5623 4.05C14.0423 3.65 13.4823 3.32 12.8723 3.07L12.4923 0.42C12.4623 0.18 12.2523 0 12.0023 0H8.00228C7.75228 0 7.54228 0.18 7.51228 0.42L7.13228 3.07C6.52228 3.32 5.96228 3.66 5.44228 4.05L2.95228 3.05C2.89228 3.03 2.83228 3.02 2.77228 3.02C2.60228 3.02 2.43228 3.11 2.34228 3.27L0.342281 6.73C0.212281 6.95 0.272281 7.22 0.462281 7.37L2.57228 9.02C2.53228 9.34 2.50228 9.67 2.50228 10C2.50228 10.33 2.53228 10.66 2.57228 10.98L0.462281 12.63C0.272281 12.78 0.222281 13.05 0.342281 13.27L2.34228 16.73C2.43228 16.89 2.60228 16.98 2.78228 16.98C2.84228 16.98 2.90228 16.97 2.95228 16.95L5.44228 15.95C5.96228 16.35 6.52228 16.68 7.13228 16.93L7.51228 19.58C7.54228 19.82 7.75228 20 8.00228 20H12.0023C12.2523 20 12.4623 19.82 12.4923 19.58L12.8723 16.93C13.4823 16.68 14.0423 16.34 14.5623 15.95L17.0523 16.95C17.1123 16.97 17.1723 16.98 17.2323 16.98C17.4023 16.98 17.5723 16.89 17.6623 16.73L19.6623 13.27C19.7823 13.05 19.7323 12.78 19.5423 12.63L17.4323 10.98ZM15.4523 9.27C15.4923 9.58 15.5023 9.79 15.5023 10C15.5023 10.21 15.4823 10.43 15.4523 10.73L15.3123 11.86L16.2023 12.56L17.2823 13.4L16.5823 14.61L15.3123 14.1L14.2723 13.68L13.3723 14.36C12.9423 14.68 12.5323 14.92 12.1223 15.09L11.0623 15.52L10.9023 16.65L10.7023 18H9.30228L8.95228 15.52L7.89228 15.09C7.46228 14.91 7.06228 14.68 6.66228 14.38L5.75228 13.68L4.69228 14.11L3.42228 14.62L2.72228 13.41L3.80228 12.57L4.69228 11.87L4.55228 10.74C4.52228 10.43 4.50228 10.2 4.50228 10C4.50228 9.8 4.52228 9.57 4.55228 9.27L4.69228 8.14L3.80228 7.44L2.72228 6.6L3.42228 5.39L4.69228 5.9L5.73228 6.32L6.63228 5.64C7.06228 5.32 7.47228 5.08 7.88228 4.91L8.94228 4.48L9.10228 3.35L9.30228 2H10.6923L11.0423 4.48L12.1023 4.91C12.5323 5.09 12.9323 5.32 13.3323 5.62L14.2423 6.32L15.3023 5.89L16.5723 5.38L17.2723 6.59L16.2023 7.44L15.3123 8.14L15.4523 9.27ZM10.0023 6C7.79228 6 6.00228 7.79 6.00228 10C6.00228 12.21 7.79228 14 10.0023 14C12.2123 14 14.0023 12.21 14.0023 10C14.0023 7.79 12.2123 6 10.0023 6ZM10.0023 12C8.90228 12 8.00228 11.1 8.00228 10C8.00228 8.9 8.90228 8 10.0023 8C11.1023 8 12.0023 8.9 12.0023 10C12.0023 11.1 11.1023 12 10.0023 12Z"
      fill="#FFA500"
    />
  </svg>
);

export const PrintIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 6H13.5V2.25H4.5V6H3.75C2.505 6 1.5 7.005 1.5 8.25V12.75H4.5V15.75H13.5V12.75H16.5V8.25C16.5 7.005 15.495 6 14.25 6ZM6 3.75H12V6H6V3.75ZM12 14.25H6V11.25H12V14.25ZM13.5 11.25V9.75H4.5V11.25H3V8.25C3 7.8375 3.3375 7.5 3.75 7.5H14.25C14.6625 7.5 15 7.8375 15 8.25V11.25H13.5Z"
      fill="#1D1D1D"
    />
    <path
      d="M13.5 9.375C13.9142 9.375 14.25 9.03921 14.25 8.625C14.25 8.21079 13.9142 7.875 13.5 7.875C13.0858 7.875 12.75 8.21079 12.75 8.625C12.75 9.03921 13.0858 9.375 13.5 9.375Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const EditPrintIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 0.5C4.17157 0.5 3.5 1.17157 3.5 2V5H2C1.17157 5 0.5 5.67157 0.5 6.5V11C0.5 11.8284 1.17157 12.5 2 12.5H2.75V14C2.75 14.8284 3.42157 15.5 4.25 15.5H11.75C12.5784 15.5 13.25 14.8284 13.25 14V12.5H14C14.8284 12.5 15.5 11.8284 15.5 11V6.5C15.5 5.67157 14.8284 5 14 5H12.5V2C12.5 1.17157 11.8284 0.5 11 0.5H5ZM11 5V2H5V5H11ZM4.25 6.5H2V11H2.75V10.25C2.75 9.42157 3.42157 8.75 4.25 8.75H11.75C12.5784 8.75 13.25 9.42157 13.25 10.25V11H14V6.5H11.75H4.25ZM11.75 10.25H4.25V12.125V14H11.75V12.125V10.25Z"
      fill="#1F4E79"
    />
  </svg>
);

export const ThreedotIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 6C9.825 6 10.5 5.325 10.5 4.5C10.5 3.675 9.825 3 9 3C8.175 3 7.5 3.675 7.5 4.5C7.5 5.325 8.175 6 9 6ZM9 7.5C8.175 7.5 7.5 8.175 7.5 9C7.5 9.825 8.175 10.5 9 10.5C9.825 10.5 10.5 9.825 10.5 9C10.5 8.175 9.825 7.5 9 7.5ZM9 12C8.175 12 7.5 12.675 7.5 13.5C7.5 14.325 8.175 15 9 15C9.825 15 10.5 14.325 10.5 13.5C10.5 12.675 9.825 12 9 12Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const MainLogo = () => (
  <svg
    width="174"
    height="56"
    viewBox="0 0 174 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2826 12.0116C19.2501 12.0648 18.2106 12.3483 17.275 12.8303C15.0825 13.9608 13.5811 16.1154 13.2893 18.5548C13.2597 18.7946 13.2408 19.0368 13.2408 19.162C13.2408 19.2152 13.2373 19.2849 13.2338 19.3191L13.2255 19.3806L10.6786 19.3853C7.90374 19.3888 8.07148 19.3853 7.74781 19.4538C7.18197 19.5743 6.67046 19.8448 6.26055 20.2382C6.10817 20.3847 0.722626 26.44 0.603314 26.5971C0.25365 27.0637 0.051648 27.6154 0.0103025 28.2143C0.00085214 28.3454 -0.00151046 29.5799 0.000852141 32.317C0.00557734 36.6334 -0.000329153 36.2956 0.0764553 36.637C0.207579 37.2229 0.488728 37.7415 0.903364 38.1585C1.43495 38.6912 2.09293 38.996 2.87141 39.0681C2.96473 39.0775 2.9541 39.0515 2.97536 39.3232C3.02025 39.9139 3.19036 40.5388 3.45969 41.0999C3.88496 41.9871 4.59374 42.762 5.44428 43.2711C6.05264 43.635 6.73662 43.8701 7.44067 43.9575C7.89075 44.0142 8.54991 44.0142 8.99998 43.9575C10.6762 43.7484 12.1434 42.7207 12.9101 41.218C13.2172 40.6144 13.4027 39.9493 13.4535 39.263C13.4594 39.1756 13.4653 39.0964 13.4653 39.0882C13.4653 39.0775 14.369 39.074 17.9412 39.074H22.4172L22.4254 39.1661C22.468 39.7001 22.5412 40.0793 22.6841 40.5069C23.2842 42.3001 24.8447 43.6267 26.71 43.9291C27.2298 44.013 27.974 44.0224 28.5068 43.9516C29.2569 43.8523 29.9728 43.5877 30.6071 43.1778C31.1068 42.8553 31.5994 42.3887 31.9562 41.8997C32.2621 41.4803 32.5173 40.9806 32.6803 40.4821C32.7772 40.1844 32.8587 39.8135 32.8977 39.4863L32.9118 39.3729L33.239 39.3658C33.8675 39.3504 34.392 39.2819 34.9437 39.1437C37.4055 38.5282 39.3853 36.7043 40.1993 34.3027C40.4013 33.7062 40.5052 33.2006 40.5785 32.4528C40.5962 32.2603 40.6068 25.7832 40.5891 25.5824C40.5418 25.0591 40.1945 24.6362 39.6937 24.4909C39.3523 24.3916 38.979 24.4471 38.6718 24.6444C38.5525 24.7212 38.3647 24.9161 38.2915 25.0378C38.2277 25.1465 38.1674 25.2965 38.1355 25.43C38.1154 25.5139 38.1131 25.704 38.1072 28.9266C38.0989 32.6654 38.1048 32.3819 38.0304 32.7954C37.7918 34.1114 37.0251 35.282 35.9076 36.0345C35.2626 36.4692 34.5704 36.7315 33.7718 36.8425C33.6064 36.8661 33.5226 36.8685 32.9296 36.8732C32.3944 36.878 32.2668 36.8756 32.2515 36.8638C32.222 36.839 32.183 36.7705 32.1546 36.6937C32.1404 36.6547 32.1109 36.5956 32.0896 36.5637C32.0672 36.5306 32.0365 36.4669 32.02 36.4196C31.9762 36.2991 31.9325 36.2176 31.8806 36.1585C31.8557 36.1302 31.8239 36.0829 31.8109 36.0546C31.7813 35.9932 31.4317 35.6305 31.258 35.4793C30.5953 34.904 29.844 34.513 29.0088 34.3086C28.6403 34.2177 28.3638 34.1787 27.9516 34.1574C26.9805 34.109 26.0627 34.298 25.218 34.7221C24.6392 35.0115 24.149 35.3824 23.6575 35.9022C23.6032 35.9601 23.5276 36.0274 23.491 36.0499C23.4437 36.077 23.4 36.1207 23.3445 36.1916C23.302 36.2471 23.2571 36.3003 23.2464 36.3097C23.2169 36.3369 23.1082 36.5814 23.0669 36.7102C23.0468 36.7728 23.0267 36.8354 23.0208 36.8508L23.0102 36.878L21.6257 36.8732C20.2708 36.8697 20.2365 36.8685 20.0569 36.8437C19.3741 36.7456 18.787 36.5484 18.2259 36.2259C17.8148 35.9908 17.4746 35.725 17.1273 35.3694C16.5898 34.8189 16.2012 34.1775 15.959 33.4392C15.8633 33.145 15.7936 32.8273 15.7487 32.4764C15.7287 32.3193 15.7275 31.9815 15.7275 25.6781V19.0451L15.7535 18.849C15.8468 18.1626 16.0464 17.5637 16.3725 16.9955C16.6075 16.5844 16.8733 16.2442 17.2289 15.8969C17.9613 15.1834 18.8615 14.7239 19.8608 14.5561C20.2956 14.4829 20.0758 14.4876 23.7662 14.4793L27.1388 14.4723L27.2215 14.4475C27.4767 14.3707 27.661 14.262 27.8157 14.0954C28.1595 13.728 28.2504 13.1823 28.0437 12.7251C27.9055 12.4227 27.6208 12.1675 27.3018 12.0624C27.0963 11.9951 27.2664 11.9986 23.7249 12.001C21.9317 12.001 20.383 12.0069 20.2826 12.0116ZM13.229 24.4672V26.4695H9.02952H4.83L5.36985 25.8576C5.66754 25.5209 6.46374 24.6208 7.13944 23.8553L8.36799 22.4649H10.7979H13.229V24.4672ZM13.229 30.7482C13.229 31.9626 13.2373 32.3382 13.2704 32.6536C13.2846 32.7907 13.2881 33.0907 13.2881 34.4102V36.0026H12.779H12.271L12.0737 35.7994C11.8446 35.5643 11.6437 35.3848 11.4276 35.223C10.4447 34.4858 9.25633 34.1149 7.99706 34.1527C7.15598 34.1775 6.42593 34.3606 5.69826 34.7268C5.11706 35.0186 4.61855 35.3942 4.17911 35.8691L4.05625 36.0026H3.54593H3.03443V32.7659V29.5291H8.13173H13.229V30.7482ZM8.52746 37.2323C8.78263 37.2571 8.9799 37.315 9.21852 37.4332C9.77492 37.7072 10.1659 38.2057 10.3018 38.8165C10.3396 38.9878 10.3384 39.1744 10.2971 39.3516C10.1057 40.1679 9.43943 40.7845 8.61606 40.905C8.49084 40.9239 8.0136 40.9298 7.84349 40.9156C7.1229 40.8554 6.47791 40.4077 6.16959 39.7532C6.05383 39.5063 5.98059 39.2157 5.99122 39.0385C6.00303 38.8283 6.07036 38.6003 6.18968 38.3593C6.29363 38.1478 6.3964 38.0037 6.56651 37.8324C6.92208 37.4733 7.31545 37.2879 7.84822 37.2276C7.92973 37.2182 8.42351 37.2217 8.52746 37.2323ZM28.0425 37.2323C28.2941 37.2571 28.5115 37.3209 28.7454 37.4379C28.9521 37.5418 29.0951 37.6458 29.2652 37.8159C29.5298 38.0805 29.6987 38.3735 29.7979 38.7385C29.8275 38.8448 29.8298 38.8743 29.8298 39.0681C29.8298 39.2689 29.8286 39.2878 29.7932 39.4201C29.629 40.0379 29.1754 40.5482 28.5871 40.7798C28.3107 40.8885 28.1429 40.918 27.7649 40.9227C27.3432 40.9298 27.1412 40.905 26.8766 40.8164C26.7195 40.7632 26.4879 40.6451 26.3414 40.5412C26.1985 40.4396 25.9682 40.2104 25.8654 40.0663C25.7685 39.9292 25.635 39.6635 25.5878 39.5111C25.5252 39.3102 25.5086 39.2205 25.5086 39.0681C25.5086 38.9464 25.5145 38.9051 25.5464 38.7787C25.6398 38.4195 25.804 38.1183 26.0485 37.8632C26.4064 37.4875 26.8175 37.289 27.3633 37.2276C27.4448 37.2182 27.9386 37.2217 28.0425 37.2323Z"
      fill="#FFA500"
    />
    <path
      d="M36.6931 12.0068C35.4256 12.0552 34.1309 12.458 33.0429 13.142C31.4103 14.1697 30.2373 15.7869 29.7719 17.6546C29.6939 17.9641 29.6466 18.2228 29.6065 18.5429C29.551 18.9847 29.5521 18.9008 29.5521 22.4648C29.5521 26.2249 29.5451 25.8917 29.6325 26.1268C29.7116 26.3371 29.8664 26.5426 30.053 26.682C30.3436 26.9018 30.7594 26.9797 31.1174 26.8817C31.226 26.8521 31.3961 26.773 31.4966 26.7057C31.5934 26.6395 31.7482 26.4848 31.8143 26.3879C31.8817 26.2875 31.9596 26.1186 31.9939 26.0028L32.0211 25.9083L32.0281 22.5239C32.0329 20.6621 32.04 19.1158 32.0435 19.0863C32.0482 19.0568 32.06 18.9611 32.0695 18.8737C32.3057 16.7958 33.8769 15.0557 35.9252 14.6044C36.0977 14.5666 36.3222 14.53 36.5336 14.5052C36.6825 14.4887 37.3133 14.4863 43.0189 14.4828C47.196 14.4792 49.4334 14.4828 49.6165 14.4899C50.0335 14.5088 50.3395 14.5525 50.6986 14.6446C51.7889 14.9258 52.7422 15.5672 53.4345 16.4839C54.0015 17.2328 54.3417 18.1448 54.4126 19.0981C54.422 19.234 54.4244 20.9669 54.422 25.802C54.4173 32.9488 54.4232 32.3487 54.3523 32.7598C54.1869 33.7344 53.718 34.6511 53.0127 35.3752C52.4327 35.9706 51.7204 36.41 50.9266 36.6581C50.6714 36.7384 50.3997 36.7987 50.0831 36.8436L49.9059 36.8696L46.492 36.8766C43.43 36.8837 43.0697 36.8861 42.9953 36.9026C42.8217 36.9428 42.6787 37.0007 42.5405 37.0905C42.4283 37.1637 42.2393 37.3598 42.1696 37.4767C41.8731 37.9753 41.9475 38.5954 42.3539 39.0006C42.5571 39.2038 42.8075 39.3243 43.0957 39.3574C43.2587 39.3763 49.828 39.3668 50.024 39.3479C50.4363 39.3078 50.7588 39.2581 51.0789 39.1861C53.4238 38.6628 55.373 37.0385 56.318 34.8212C56.6133 34.1254 56.7917 33.4296 56.8779 32.624C56.898 32.4397 56.8992 32.0676 56.8992 25.6838C56.8992 19.3036 56.898 18.928 56.8779 18.7437C56.8496 18.4826 56.8165 18.2558 56.774 18.0349C56.3086 15.6416 54.6949 13.6216 52.4575 12.6329C51.6294 12.2667 50.7505 12.0599 49.8232 12.0103C49.6259 11.9997 36.9624 11.9961 36.6931 12.0068Z"
      fill="#FFA500"
    />
    <path
      d="M76.8592 29.58C76.8592 30.7 76.6258 31.7267 76.1592 32.66C75.7058 33.5933 75.0325 34.34 74.1392 34.9C73.2592 35.4467 72.2058 35.72 70.9792 35.72C70.7125 35.72 70.4325 35.6933 70.1392 35.64C69.8592 35.6 69.6325 35.5467 69.4592 35.48L69.5192 37.14V38.96L71.3792 39.2V40.34H65.4392V39.2L66.7392 38.96V26.28L65.4392 25.92V24.54L68.7392 24.12H68.7792L69.2792 24.52V25.64C69.6125 25.2267 70.0658 24.8667 70.6392 24.56C71.2125 24.2533 71.8392 24.1 72.5192 24.1C73.7858 24.1 74.8258 24.5533 75.6392 25.46C76.4525 26.3533 76.8592 27.7267 76.8592 29.58ZM71.4792 25.76C71.0792 25.76 70.6992 25.8467 70.3392 26.02C69.9792 26.1933 69.7058 26.3867 69.5192 26.6V34.02C69.6125 34.1533 69.7992 34.2667 70.0792 34.36C70.3725 34.4533 70.6925 34.5 71.0392 34.5C71.9058 34.5 72.5925 34.1267 73.0992 33.38C73.6192 32.62 73.8792 31.4333 73.8792 29.82C73.8792 28.46 73.6592 27.4467 73.2192 26.78C72.7792 26.1 72.1992 25.76 71.4792 25.76ZM79.0945 34.32L80.4145 34.16V26.28L79.1345 25.92V24.54L82.2345 24.12H82.2945L82.7945 24.52V24.96L82.7345 26.58H82.7945C82.8878 26.3133 83.1078 25.9867 83.4545 25.6C83.8011 25.2 84.2345 24.8533 84.7545 24.56C85.2878 24.2533 85.8612 24.1 86.4745 24.1C86.7678 24.1 87.0211 24.14 87.2345 24.22V27.22C86.8345 26.94 86.3478 26.8 85.7745 26.8C84.8011 26.8 83.9545 27.06 83.2345 27.58V34.14L85.5545 34.32V35.5H79.0945V34.32ZM89.1085 29.96C89.1085 28.7067 89.3552 27.64 89.8485 26.76C90.3552 25.88 91.0285 25.22 91.8685 24.78C92.7085 24.3267 93.6219 24.1 94.6085 24.1C96.2885 24.1 97.5819 24.62 98.4885 25.66C99.4085 26.6867 99.8685 28.0867 99.8685 29.86C99.8685 31.1267 99.6152 32.2067 99.1085 33.1C98.6152 33.98 97.9485 34.64 97.1085 35.08C96.2819 35.5067 95.3685 35.72 94.3685 35.72C92.7019 35.72 91.4085 35.2067 90.4885 34.18C89.5685 33.14 89.1085 31.7333 89.1085 29.96ZM94.5285 34.42C96.0352 34.42 96.7885 32.9667 96.7885 30.06C96.7885 28.54 96.6085 27.3867 96.2485 26.6C95.8885 25.8 95.3019 25.4 94.4885 25.4C92.9419 25.4 92.1685 26.8533 92.1685 29.76C92.1685 31.28 92.3552 32.44 92.7285 33.24C93.1152 34.0267 93.7152 34.42 94.5285 34.42ZM107.327 35.72C106.607 35.72 105.96 35.66 105.387 35.54C104.813 35.42 104.173 35.26 103.467 35.06C103 34.9267 102.687 34.8533 102.527 34.84L102.707 31.14H104.327L104.767 33.72C104.94 33.9067 105.247 34.0733 105.687 34.22C106.14 34.3667 106.653 34.44 107.227 34.44C108.12 34.44 108.787 34.2467 109.227 33.86C109.68 33.46 109.907 32.9067 109.907 32.2C109.907 31.7333 109.773 31.3333 109.507 31C109.24 30.6533 108.873 30.3467 108.407 30.08C107.94 29.8 107.3 29.48 106.487 29.12C105.38 28.6133 104.46 28.0133 103.727 27.32C103.007 26.6133 102.647 25.66 102.647 24.46C102.647 23.7133 102.84 23.04 103.227 22.44C103.613 21.8267 104.187 21.3467 104.947 21C105.72 20.64 106.66 20.46 107.767 20.46C108.42 20.46 108.993 20.5067 109.487 20.6C109.993 20.6933 110.54 20.82 111.127 20.98C111.473 21.0733 111.733 21.1333 111.907 21.16L111.787 24.66H110.187L109.767 22.2C109.647 22.08 109.407 21.9667 109.047 21.86C108.687 21.74 108.287 21.68 107.847 21.68C107.047 21.68 106.44 21.8667 106.027 22.24C105.627 22.6 105.427 23.0867 105.427 23.7C105.427 24.1933 105.573 24.62 105.867 24.98C106.173 25.34 106.54 25.6467 106.967 25.9C107.393 26.14 108.067 26.4867 108.987 26.94C109.733 27.3 110.373 27.6533 110.907 28C111.44 28.3467 111.9 28.8 112.287 29.36C112.673 29.9067 112.867 30.5533 112.867 31.3C112.867 32.0333 112.68 32.7333 112.307 33.4C111.947 34.0667 111.347 34.62 110.507 35.06C109.68 35.5 108.62 35.72 107.327 35.72ZM123.957 35.7C123.517 35.7 123.197 35.6067 122.997 35.42C122.797 35.2333 122.697 34.9533 122.697 34.58V34.04C122.337 34.48 121.831 34.8733 121.177 35.22C120.524 35.5533 119.871 35.72 119.217 35.72C117.937 35.72 117.024 35.3933 116.477 34.74C115.931 34.0733 115.657 32.98 115.657 31.46V25.82L114.657 25.54V24.4L118.057 24.14H118.077L118.477 24.42V31.46C118.477 32.4333 118.597 33.1133 118.837 33.5C119.077 33.8867 119.524 34.08 120.177 34.08C120.964 34.08 121.697 33.7733 122.377 33.16V25.82L121.037 25.52V24.4L124.657 24.14H124.697L125.177 24.42V34.26H126.297L126.277 35.4C126.224 35.4133 125.977 35.4667 125.537 35.56C125.097 35.6533 124.571 35.7 123.957 35.7ZM139.371 29.58C139.371 30.7 139.138 31.7267 138.671 32.66C138.218 33.5933 137.544 34.34 136.651 34.9C135.771 35.4467 134.718 35.72 133.491 35.72C133.224 35.72 132.944 35.6933 132.651 35.64C132.371 35.6 132.144 35.5467 131.971 35.48L132.031 37.14V38.96L133.891 39.2V40.34H127.951V39.2L129.251 38.96V26.28L127.951 25.92V24.54L131.251 24.12H131.291L131.791 24.52V25.64C132.124 25.2267 132.578 24.8667 133.151 24.56C133.724 24.2533 134.351 24.1 135.031 24.1C136.298 24.1 137.338 24.5533 138.151 25.46C138.964 26.3533 139.371 27.7267 139.371 29.58ZM133.991 25.76C133.591 25.76 133.211 25.8467 132.851 26.02C132.491 26.1933 132.218 26.3867 132.031 26.6V34.02C132.124 34.1533 132.311 34.2667 132.591 34.36C132.884 34.4533 133.204 34.5 133.551 34.5C134.418 34.5 135.104 34.1267 135.611 33.38C136.131 32.62 136.391 31.4333 136.391 29.82C136.391 28.46 136.171 27.4467 135.731 26.78C135.291 26.1 134.711 25.76 133.991 25.76ZM152.666 29.58C152.666 30.7 152.433 31.7267 151.966 32.66C151.513 33.5933 150.84 34.34 149.946 34.9C149.066 35.4467 148.013 35.72 146.786 35.72C146.52 35.72 146.24 35.6933 145.946 35.64C145.666 35.6 145.44 35.5467 145.266 35.48L145.326 37.14V38.96L147.186 39.2V40.34H141.246V39.2L142.546 38.96V26.28L141.246 25.92V24.54L144.546 24.12H144.586L145.086 24.52V25.64C145.42 25.2267 145.873 24.8667 146.446 24.56C147.02 24.2533 147.646 24.1 148.326 24.1C149.593 24.1 150.633 24.5533 151.446 25.46C152.26 26.3533 152.666 27.7267 152.666 29.58ZM147.286 25.76C146.886 25.76 146.506 25.8467 146.146 26.02C145.786 26.1933 145.513 26.3867 145.326 26.6V34.02C145.42 34.1533 145.606 34.2667 145.886 34.36C146.18 34.4533 146.5 34.5 146.846 34.5C147.713 34.5 148.4 34.1267 148.906 33.38C149.426 32.62 149.686 31.4333 149.686 29.82C149.686 28.46 149.466 27.4467 149.026 26.78C148.586 26.1 148.006 25.76 147.286 25.76ZM156.062 20.88L154.582 20.62V19.54L158.282 19.1H158.322L158.862 19.48V34.14L160.322 34.3V35.5H154.662V34.3L156.062 34.12V20.88ZM164.078 40.48C163.838 40.48 163.578 40.46 163.298 40.42C163.032 40.38 162.838 40.3333 162.718 40.28V38.14C162.812 38.1933 162.998 38.2467 163.278 38.3C163.558 38.3533 163.812 38.38 164.038 38.38C164.705 38.38 165.252 38.16 165.678 37.72C166.118 37.28 166.525 36.54 166.898 35.5H165.818L162.058 25.8L161.158 25.54V24.38H166.658V25.54L165.198 25.78L166.978 31.32L167.698 33.68L168.318 31.32L169.958 25.78L168.698 25.54V24.38H173.038V25.54L172.058 25.78C171.325 28.02 170.598 30.18 169.878 32.26C169.158 34.34 168.738 35.5067 168.618 35.76C168.192 36.88 167.785 37.7733 167.398 38.44C167.012 39.1067 166.552 39.6133 166.018 39.96C165.485 40.3067 164.838 40.48 164.078 40.48Z"
      fill="#1F4E79"
    />
  </svg>
);

export const CalenderIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6665 2.49998H14.8332V0.833313H13.1665V2.49998H4.83317V0.833313H3.1665V2.49998H2.33317C1.4165 2.49998 0.666504 3.24998 0.666504 4.16665V17.5C0.666504 18.4166 1.4165 19.1666 2.33317 19.1666H15.6665C16.5832 19.1666 17.3332 18.4166 17.3332 17.5V4.16665C17.3332 3.24998 16.5832 2.49998 15.6665 2.49998ZM15.6665 17.5H2.33317V8.33331H15.6665V17.5ZM15.6665 6.66665H2.33317V4.16665H15.6665V6.66665Z"
      fill="#1F4E79"
    />
  </svg>
);

export const BoxIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 13.3333V6.66666C17.4997 6.37438 17.4225 6.08733 17.2763 5.83429C17.13 5.58125 16.9198 5.37112 16.6667 5.22499L10.8333 1.89166C10.58 1.74538 10.2926 1.66837 10 1.66837C9.70744 1.66837 9.42003 1.74538 9.16667 1.89166L3.33333 5.22499C3.08022 5.37112 2.86998 5.58125 2.72372 5.83429C2.57745 6.08733 2.5003 6.37438 2.5 6.66666V13.3333C2.5003 13.6256 2.57745 13.9126 2.72372 14.1657C2.86998 14.4187 3.08022 14.6289 3.33333 14.775L9.16667 18.1083C9.42003 18.2546 9.70744 18.3316 10 18.3316C10.2926 18.3316 10.58 18.2546 10.8333 18.1083L16.6667 14.775C16.9198 14.6289 17.13 14.4187 17.2763 14.1657C17.4225 13.9126 17.4997 13.6256 17.5 13.3333Z"
      stroke="#0C2033"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.72498 5.79999L9.99998 10.0083L17.275 5.79999"
      stroke="#0C2033"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 18.4V10"
      stroke="#0C2033"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OpenMenuArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 5.53L4 9.53L4.94 10.47L8 7.41667L11.06 10.47L12 9.53L8 5.53Z"
      fill="#000"
    />
  </svg>
);

export const ClosedMenuArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 10.47L12 6.47L11.06 5.53L8 8.58333L4.94 5.53L4 6.47L8 10.47Z"
      fill="black"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M13.5 11.25V13.5H4.5V11.25H3V13.5C3 14.325 3.675 15 4.5 15H13.5C14.325 15 15 14.325 15 13.5V11.25H13.5ZM12.75 8.25L11.6925 7.1925L9.75 9.1275V3H8.25V9.1275L6.3075 7.1925L5.25 8.25L9 12L12.75 8.25Z"
      fill="#405189" // Change the color to white
    />
  </svg>
);

export const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M13.5 11.25V13.5H4.5V11.25H3V13.5C3 14.325 3.675 15 4.5 15H13.5C14.325 15 15 14.325 15 13.5V11.25H13.5ZM5.25 6.75L6.3075 7.8075L8.25 5.8725V12H9.75V5.8725L11.6925 7.8075L12.75 6.75L9 3L5.25 6.75Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.08335 5.08332H5.58335V8.58332H4.41669V5.08332H0.916687V3.91666H4.41669V0.416656H5.58335V3.91666H9.08335V5.08332Z"
      fill="white"
    />
  </svg>
);

export const AddIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M11.0837 7.58341H7.58366V11.0834H6.41699V7.58341H2.91699V6.41675H6.41699V2.91675H7.58366V6.41675H11.0837V7.58341Z"
      fill="#C7222A"
    />
  </svg>
);

export const BluePlusIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 10.25H9.75V14.75H8.25V10.25H3.75V8.75H8.25V4.25H9.75V8.75H14.25V10.25Z"
      fill="#1F4E79"
    />
  </svg>
);

export const GridIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 2.75H3.75C2.925 2.75 2.25 3.425 2.25 4.25V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V4.25C15.75 3.425 15.075 2.75 14.25 2.75ZM3.75 14.75V4.25H8.25V14.75H3.75ZM14.25 14.75H9.75V9.5H14.25V14.75ZM14.25 8H9.75V4.25H14.25V8Z"
      fill="#1D1D1D"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const ViewIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3.5H3C2.175 3.5 1.5 4.175 1.5 5V14C1.5 14.825 2.175 15.5 3 15.5H15C15.825 15.5 16.5 14.825 16.5 14V5C16.5 4.175 15.825 3.5 15 3.5ZM6 14H3V5H6V14ZM10.5 14H7.5V5H10.5V14ZM15 14H12V5H15V14Z"
      fill="#1D1D1D"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25392 5H12.7539L8.99642 9.725L5.25392 5ZM3.19142 4.7075C4.70642 6.65 7.50392 10.25 7.50392 10.25V14.75C7.50392 15.1625 7.84142 15.5 8.25392 15.5H9.75392C10.1664 15.5 10.5039 15.1625 10.5039 14.75V10.25C10.5039 10.25 13.2939 6.65 14.8089 4.7075C15.1914 4.2125 14.8389 3.5 14.2164 3.5H3.78392C3.16142 3.5 2.80892 4.2125 3.19142 4.7075Z"
      fill="#1D1D1D"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const DownArrowIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.6775 4.83875L7 7.51041L4.3225 4.83875L3.5 5.66125L7 9.16125L10.5 5.66125L9.6775 4.83875Z"
      fill="#1F4E79"
    />
  </svg>
);

export const DragIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 13.5C8.25 14.325 7.575 15 6.75 15C5.925 15 5.25 14.325 5.25 13.5C5.25 12.675 5.925 12 6.75 12C7.575 12 8.25 12.675 8.25 13.5ZM6.75 7.5C5.925 7.5 5.25 8.175 5.25 9C5.25 9.825 5.925 10.5 6.75 10.5C7.575 10.5 8.25 9.825 8.25 9C8.25 8.175 7.575 7.5 6.75 7.5ZM6.75 3C5.925 3 5.25 3.675 5.25 4.5C5.25 5.325 5.925 6 6.75 6C7.575 6 8.25 5.325 8.25 4.5C8.25 3.675 7.575 3 6.75 3ZM11.25 6C12.075 6 12.75 5.325 12.75 4.5C12.75 3.675 12.075 3 11.25 3C10.425 3 9.75 3.675 9.75 4.5C9.75 5.325 10.425 6 11.25 6ZM11.25 7.5C10.425 7.5 9.75 8.175 9.75 9C9.75 9.825 10.425 10.5 11.25 10.5C12.075 10.5 12.75 9.825 12.75 9C12.75 8.175 12.075 7.5 11.25 7.5ZM11.25 12C10.425 12 9.75 12.675 9.75 13.5C9.75 14.325 10.425 15 11.25 15C12.075 15 12.75 14.325 12.75 13.5C12.75 12.675 12.075 12 11.25 12Z"
      fill="#CCD6DE"
    />
  </svg>
);

export const FilterUpdateIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill="none" />
    <path
      d="M5.54584 6.67501C7.22918 8.83334 10.3375 12.8333 10.3375 12.8333V17.8333C10.3375 18.2917 10.7125 18.6667 11.1708 18.6667H12.8375C13.2958 18.6667 13.6708 18.2917 13.6708 17.8333V12.8333C13.6708 12.8333 16.7708 8.83334 18.4542 6.67501C18.8792 6.12501 18.4875 5.33334 17.7958 5.33334H6.20418C5.51251 5.33334 5.12084 6.12501 5.54584 6.67501Z"
      fill="#555"
      stroke="#FBFBFC"
      strokeWidth="0.5"
    />
  </svg>
);

export const ActivityLogIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.125 0.25C5.3975 0.25 2.375 3.2725 2.375 7H0.125L3.0425 9.9175L3.095 10.0225L6.125 7H3.875C3.875 4.0975 6.2225 1.75 9.125 1.75C12.0275 1.75 14.375 4.0975 14.375 7C14.375 9.9025 12.0275 12.25 9.125 12.25C7.6775 12.25 6.365 11.6575 5.42 10.705L4.355 11.77C5.5775 12.9925 7.2575 13.75 9.125 13.75C12.8525 13.75 15.875 10.7275 15.875 7C15.875 3.2725 12.8525 0.25 9.125 0.25ZM8.375 4V7.75L11.5625 9.64L12.14 8.68L9.5 7.1125V4H8.375Z"
      fill="#1F4E79"
    />
  </svg>
);

export const CancelIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
      fill="#0C2033"
    />
  </svg>
);
export const TrashIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66659 4V10.6667H2.33325V4H7.66659ZM6.66659 0H3.33325L2.66659 0.666667H0.333252V2H9.66659V0.666667H7.33325L6.66659 0ZM8.99992 2.66667H0.999919V10.6667C0.999919 11.4 1.59992 12 2.33325 12H7.66659C8.39992 12 8.99992 11.4 8.99992 10.6667V2.66667Z"
      fill="#FFA500"
    />
  </svg>
);
export const OrangePlusIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.66659 5.66667H5.66659V9.66667H4.33325V5.66667H0.333252V4.33333H4.33325V0.333334H5.66659V4.33333H9.66659V5.66667Z"
      fill="#FFA500"
    />
  </svg>
);
export const ActivityLogCommentBubble = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" fill="#FAFAFA" />
    <path
      d="M23 9.5H11C10.175 9.5 9.5 10.175 9.5 11V24.5L12.5 21.5H23C23.825 21.5 24.5 20.825 24.5 20V11C24.5 10.175 23.825 9.5 23 9.5ZM23 20H12.5L11 21.5V11H23V20Z"
      fill="#1F4E79"
    />
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#1F4E79" />
  </svg>
);

export const ActivityLogEditBubble = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" fill="#FAFAFA" />
    <path
      d="M18.544 14.765L19.234 15.455L12.439 22.25H11.749V21.56L18.544 14.765ZM21.244 10.25C21.0565 10.25 20.8615 10.325 20.719 10.4675L19.3465 11.84L22.159 14.6525L23.5315 13.28C23.824 12.9875 23.824 12.515 23.5315 12.2225L21.7765 10.4675C21.6265 10.3175 21.439 10.25 21.244 10.25ZM18.544 12.6425L10.249 20.9375V23.75H13.0615L21.3565 15.455L18.544 12.6425Z"
      fill="#1F4E79"
    />
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#1F4E79" />
  </svg>
);

export const ConnectionLogo = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66667 14.6666H14V9.99992H12V7.33325H8.66667V5.99992H10.6667V1.33325H5.33333V5.99992H7.33333V7.33325H4V9.99992H2V14.6666H7.33333V9.99992H5.33333V8.66659H10.6667V9.99992H8.66667V14.6666ZM6.66667 4.66659V2.66659H9.33333V4.66659H6.66667ZM6 11.3333V13.3333H3.33333V11.3333H6ZM12.6667 11.3333V13.3333H10V11.3333H12.6667Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const WorkflowProfileLogo = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00033 3.93341C8.77366 3.93341 9.40033 4.56008 9.40033 5.33341C9.40033 6.10675 8.77366 6.73341 8.00033 6.73341C7.22699 6.73341 6.60033 6.10675 6.60033 5.33341C6.60033 4.56008 7.22699 3.93341 8.00033 3.93341ZM8.00033 9.93341C9.98033 9.93341 12.067 10.9067 12.067 11.3334V12.0667H3.93366V11.3334C3.93366 10.9067 6.02033 9.93341 8.00033 9.93341ZM8.00033 2.66675C6.52699 2.66675 5.33366 3.86008 5.33366 5.33341C5.33366 6.80675 6.52699 8.00008 8.00033 8.00008C9.47366 8.00008 10.667 6.80675 10.667 5.33341C10.667 3.86008 9.47366 2.66675 8.00033 2.66675ZM8.00033 8.66675C6.22033 8.66675 2.66699 9.56008 2.66699 11.3334V13.3334H13.3337V11.3334C13.3337 9.56008 9.78032 8.66675 8.00033 8.66675Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const GreenCheckedCircle = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM7.5 12.75L3.75 9L4.8075 7.9425L7.5 10.6275L13.1925 4.935L14.25 6L7.5 12.75Z"
      fill="#009C06"
    />
  </svg>
);

export const GreenUncheckedCircle = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C12.315 3 15 5.685 15 9C15 12.315 12.315 15 9 15Z"
      fill="#BDBDBD"
    />
  </svg>
);

export const ActivityLogSettingBubble = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" fill="#FAFAFA" />
    <path
      d="M22.5741 17.735C22.6041 17.495 22.6266 17.255 22.6266 17C22.6266 16.745 22.6041 16.505 22.5741 16.265L24.1566 15.0275C24.2991 14.915 24.3366 14.7125 24.2466 14.5475L22.7466 11.9525C22.6791 11.8325 22.5516 11.765 22.4166 11.765C22.3716 11.765 22.3266 11.7725 22.2891 11.7875L20.4216 12.5375C20.0316 12.2375 19.6116 11.99 19.1541 11.8025L18.8691 9.815C18.8466 9.635 18.6891 9.5 18.5016 9.5H15.5016C15.3141 9.5 15.1566 9.635 15.1341 9.815L14.8491 11.8025C14.3916 11.99 13.9716 12.245 13.5816 12.5375L11.7141 11.7875C11.6691 11.7725 11.6241 11.765 11.5791 11.765C11.4516 11.765 11.3241 11.8325 11.2566 11.9525L9.75659 14.5475C9.65909 14.7125 9.70409 14.915 9.84659 15.0275L11.4291 16.265C11.3991 16.505 11.3766 16.7525 11.3766 17C11.3766 17.2475 11.3991 17.495 11.4291 17.735L9.84659 18.9725C9.70409 19.085 9.66659 19.2875 9.75659 19.4525L11.2566 22.0475C11.3241 22.1675 11.4516 22.235 11.5866 22.235C11.6316 22.235 11.6766 22.2275 11.7141 22.2125L13.5816 21.4625C13.9716 21.7625 14.3916 22.01 14.8491 22.1975L15.1341 24.185C15.1566 24.365 15.3141 24.5 15.5016 24.5H18.5016C18.6891 24.5 18.8466 24.365 18.8691 24.185L19.1541 22.1975C19.6116 22.01 20.0316 21.755 20.4216 21.4625L22.2891 22.2125C22.3341 22.2275 22.3791 22.235 22.4241 22.235C22.5516 22.235 22.6791 22.1675 22.7466 22.0475L24.2466 19.4525C24.3366 19.2875 24.2991 19.085 24.1566 18.9725L22.5741 17.735ZM21.0891 16.4525C21.1191 16.685 21.1266 16.8425 21.1266 17C21.1266 17.1575 21.1116 17.3225 21.0891 17.5475L20.9841 18.395L21.6516 18.92L22.4616 19.55L21.9366 20.4575L20.9841 20.075L20.2041 19.76L19.5291 20.27C19.2066 20.51 18.8991 20.69 18.5916 20.8175L17.7966 21.14L17.6766 21.9875L17.5266 23H16.4766L16.2141 21.14L15.4191 20.8175C15.0966 20.6825 14.7966 20.51 14.4966 20.285L13.8141 19.76L13.0191 20.0825L12.0666 20.465L11.5416 19.5575L12.3516 18.9275L13.0191 18.4025L12.9141 17.555C12.8916 17.3225 12.8766 17.15 12.8766 17C12.8766 16.85 12.8916 16.6775 12.9141 16.4525L13.0191 15.605L12.3516 15.08L11.5416 14.45L12.0666 13.5425L13.0191 13.925L13.7991 14.24L14.4741 13.73C14.7966 13.49 15.1041 13.31 15.4116 13.1825L16.2066 12.86L16.3266 12.0125L16.4766 11H17.5191L17.7816 12.86L18.5766 13.1825C18.8991 13.3175 19.1991 13.49 19.4991 13.715L20.1816 14.24L20.9766 13.9175L21.9291 13.535L22.4541 14.4425L21.6516 15.08L20.9841 15.605L21.0891 16.4525ZM17.0016 14C15.3441 14 14.0016 15.3425 14.0016 17C14.0016 18.6575 15.3441 20 17.0016 20C18.6591 20 20.0016 18.6575 20.0016 17C20.0016 15.3425 18.6591 14 17.0016 14ZM17.0016 18.5C16.1766 18.5 15.5016 17.825 15.5016 17C15.5016 16.175 16.1766 15.5 17.0016 15.5C17.8266 15.5 18.5016 16.175 18.5016 17C18.5016 17.825 17.8266 18.5 17.0016 18.5Z"
      fill="#1F4E79"
    />
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#1F4E79" />
  </svg>
);

export const ActivityLogDownloadBubble = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" fill="#FAFAFA" />
    <path
      d="M21.5 19.25V21.5H12.5V19.25H11V21.5C11 22.325 11.675 23 12.5 23H21.5C22.325 23 23 22.325 23 21.5V19.25H21.5ZM13.25 14.75L14.3075 15.8075L16.25 13.8725V20H17.75V13.8725L19.6925 15.8075L20.75 14.75L17 11L13.25 14.75Z"
      fill="#1F4E79"
    />
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#1F4E79" />
  </svg>
);

export const ActivityPlusIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 6.75H6.75V11.25H5.25V6.75H0.75V5.25H5.25V0.75H6.75V5.25H11.25V6.75Z"
      fill="#FFA500"
    />
  </svg>
);

export const AttachmentIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33366 3.50065V10.209C9.33366 11.4982 8.28949 12.5423 7.00033 12.5423C5.71116 12.5423 4.66699 11.4982 4.66699 10.209V2.91732C4.66699 2.11232 5.32033 1.45898 6.12533 1.45898C6.93033 1.45898 7.58366 2.11232 7.58366 2.91732V9.04232C7.58366 9.36315 7.32116 9.62565 7.00033 9.62565C6.67949 9.62565 6.41699 9.36315 6.41699 9.04232V3.50065H5.54199V9.04232C5.54199 9.84732 6.19533 10.5007 7.00033 10.5007C7.80533 10.5007 8.45866 9.84732 8.45866 9.04232V2.91732C8.45866 1.62815 7.41449 0.583984 6.12533 0.583984C4.83616 0.583984 3.79199 1.62815 3.79199 2.91732V10.209C3.79199 11.9823 5.22699 13.4173 7.00033 13.4173C8.77366 13.4173 10.2087 11.9823 10.2087 10.209V3.50065H9.33366Z"
      fill="#FFA500"
    />
  </svg>
);

export const AddMore = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99998 1.68347C4.31998 1.68347 1.33331 4.67014 1.33331 8.35014C1.33331 12.0301 4.31998 15.0168 7.99998 15.0168C11.68 15.0168 14.6666 12.0301 14.6666 8.35014C14.6666 4.67014 11.68 1.68347 7.99998 1.68347ZM11.3333 9.01681H8.66665V11.6835H7.33331V9.01681H4.66665V7.68347H7.33331V5.01681H8.66665V7.68347H11.3333V9.01681Z"
      fill="#0168FA"
    />
  </svg>
);

export const WebsiteIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM16.92 6H13.97C13.65 4.75 13.19 3.55 12.59 2.44C14.43 3.07 15.96 4.35 16.92 6ZM10 2.04C10.83 3.24 11.48 4.57 11.91 6H8.09C8.52 4.57 9.17 3.24 10 2.04ZM2.26 12C2.1 11.36 2 10.69 2 10C2 9.31 2.1 8.64 2.26 8H5.64C5.56 8.66 5.5 9.32 5.5 10C5.5 10.68 5.56 11.34 5.64 12H2.26ZM3.08 14H6.03C6.35 15.25 6.81 16.45 7.41 17.56C5.57 16.93 4.04 15.66 3.08 14ZM6.03 6H3.08C4.04 4.34 5.57 3.07 7.41 2.44C6.81 3.55 6.35 4.75 6.03 6ZM10 17.96C9.17 16.76 8.52 15.43 8.09 14H11.91C11.48 15.43 10.83 16.76 10 17.96ZM12.34 12H7.66C7.57 11.34 7.5 10.68 7.5 10C7.5 9.32 7.57 8.65 7.66 8H12.34C12.43 8.65 12.5 9.32 12.5 10C12.5 10.68 12.43 11.34 12.34 12ZM12.59 17.56C13.19 16.45 13.65 15.25 13.97 14H16.92C15.96 15.65 14.43 16.93 12.59 17.56ZM14.36 12C14.44 11.34 14.5 10.68 14.5 10C14.5 9.32 14.44 8.66 14.36 8H17.74C17.9 8.64 18 9.31 18 10C18 10.69 17.9 11.36 17.74 12H14.36Z"
      fill="#2B478B"
    />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4ZM4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V4C18 2.89543 17.1046 2 16 2H4ZM10 7C8.3431 7 7 8.3431 7 10C7 11.6569 8.3431 13 10 13C11.6569 13 13 11.6569 13 10C13 8.3431 11.6569 7 10 7ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10ZM15.5 6C16.3284 6 17 5.32843 17 4.5C17 3.67157 16.3284 3 15.5 3C14.6716 3 14 3.67157 14 4.5C14 5.32843 14.6716 6 15.5 6Z"
      fill="#1F4E79"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM19.4906 19.4859C18.5156 20.4609 17.3859 21.225 16.125 21.7547C14.8219 22.3078 13.4344 22.5844 12 22.5844C10.5703 22.5844 9.18281 22.3031 7.875 21.7547C6.61406 21.2203 5.47969 20.4563 4.50937 19.4859C3.53437 18.5109 2.77031 17.3812 2.24063 16.1203C1.6875 14.8172 1.40625 13.4297 1.40625 12C1.40625 10.5703 1.6875 9.18281 2.23594 7.875C2.77031 6.61406 3.53437 5.47969 4.50469 4.50937C5.48437 3.53437 6.61406 2.77031 7.875 2.23594C9.18281 1.6875 10.5703 1.40625 12 1.40625C13.4297 1.40625 14.8172 1.6875 16.125 2.23594C17.3859 2.77031 18.5203 3.53438 19.4906 4.50469C20.4656 5.47969 21.2297 6.60937 21.7594 7.87031C22.3125 9.17344 22.5891 10.5609 22.5891 11.9953C22.5891 13.425 22.3078 14.8125 21.7594 16.1203C21.225 17.3812 20.4609 18.5156 19.4906 19.4859Z"
      fill="#1F4E79"
    />
    <path
      d="M13.5844 7.9078C14.0672 7.9078 14.5828 8.0578 14.5828 8.0578L14.8922 6.2203C14.8922 6.2203 14.2359 5.9953 12.6703 5.9953C11.7094 5.9953 11.1516 6.36093 10.7437 6.89999C10.3594 7.41093 10.3453 8.23124 10.3453 8.76093V9.96561H9.10312V11.7609H10.3453V17.9953H12.6703V11.7609H14.5125L14.6484 9.96561H12.6703V8.56405C12.6703 8.08124 13.1016 7.9078 13.5844 7.9078Z"
      fill="#1F4E79"
    />
  </svg>
);

export const TwitterIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1272 1.53846C14.1594 1.53846 15.3306 2.04 15.9868 2.87538C16.8028 2.68154 17.5729 2.32692 18.265 1.83538C17.9978 2.83615 17.4276 3.67615 16.6871 4.20692C17.4119 4.10154 18.1059 3.87308 18.749 3.53077C18.2675 4.39 17.6596 5.14615 16.9581 5.75154C16.9643 5.93462 16.9681 6.11923 16.9681 6.30385C16.9681 11.9708 13.4843 18.4615 6.87993 18.4615C4.85324 18.4615 2.83661 17.7946 1.24933 16.5777C1.5297 16.6192 1.81572 16.6392 2.10489 16.6392C3.78709 16.6392 5.3354 15.9538 6.56562 14.8015C4.9928 14.7685 3.6664 13.5277 3.21127 11.8254C3.4294 11.8746 3.65571 11.9023 3.88704 11.9023C4.21267 11.9023 4.53139 11.8508 4.83187 11.7515C3.18927 11.36 1.95213 9.62615 1.95213 7.54846C1.95213 7.52846 1.95213 7.51077 1.95213 7.49231C2.4368 7.81385 2.98937 8.00769 3.57839 8.03077C2.6147 7.25923 1.98168 5.94923 1.98168 4.46077C1.98168 3.67462 2.15832 2.93692 2.46698 2.30615C4.23719 4.89769 6.8837 6.60615 9.86842 6.78615C9.80619 6.47231 9.77413 6.14154 9.77413 5.81C9.77413 3.44077 11.1433 1.53846 13.1272 1.53846ZM18.749 3.53077H18.7522H18.749ZM13.1272 0C10.7108 0 8.84187 2.11769 8.56151 5.04C6.55682 4.54231 4.73317 3.23385 3.42312 1.31615C3.18487 0.966923 2.8341 0.767692 2.46698 0.767692C2.43429 0.767692 2.4016 0.769231 2.36891 0.772308C1.96659 0.811538 1.6045 1.08692 1.39643 1.51231C0.962047 2.40154 0.73197 3.42077 0.73197 4.46077C0.73197 5.15385 0.833807 5.83 1.02491 6.46154C0.820606 6.74 0.703053 7.10615 0.703053 7.49231V7.54846C0.703053 9.05538 1.18647 10.4531 1.98985 11.5015C1.94396 11.7646 1.95402 12.0423 2.02442 12.3062C2.30228 13.3446 2.80644 14.2385 3.46021 14.92C3.0208 15.04 2.56756 15.1008 2.10489 15.1008C1.86035 15.1008 1.62336 15.0838 1.4002 15.05C1.34928 15.0431 1.29899 15.0392 1.2487 15.0392C0.725055 15.0392 0.249185 15.4446 0.0712838 16.0662C-0.12359 16.7462 0.0913998 17.5023 0.589272 17.8838C2.36954 19.2485 4.60368 20 6.87993 20C11.1791 20 13.8489 17.5715 15.3312 15.5346C17.129 13.0646 18.1751 9.78308 18.2159 6.50385C18.7987 5.90923 19.3129 5.22308 19.7485 4.45538C19.9063 4.19846 20 3.87769 20 3.53077C20 3.00692 19.7881 2.54462 19.4644 2.26615C19.6046 1.67385 19.4437 1.03231 19.0526 0.640769C18.8245 0.413077 18.5453 0.296923 18.2643 0.296923C18.05 0.296923 17.8344 0.364615 17.6401 0.503077C17.2221 0.8 16.7751 1.03385 16.3043 1.20154C15.4393 0.455385 14.2657 0 13.1272 0Z"
      fill="#1F4E79"
    />
  </svg>
);

export const GreenDot = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" fill="#5CD961" />
  </svg>
);

export const YellowDot = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" fill="#FFA047" />
  </svg>
);

export const RedDot = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" fill="#F94144" />
  </svg>
);

export const BlueDot = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
  >
    <circle cx="4" cy="4" r="4" fill="#04769A" />
  </svg>
);

export const EditListIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.544 6.765L11.234 7.455L4.43902 14.25H3.74902V13.56L10.544 6.765ZM13.244 2.25C13.0565 2.25 12.8615 2.325 12.719 2.4675L11.3465 3.84L14.159 6.6525L15.5315 5.28C15.824 4.9875 15.824 4.515 15.5315 4.2225L13.7765 2.4675C13.6265 2.3175 13.439 2.25 13.244 2.25ZM10.544 4.6425L2.24902 12.9375V15.75H5.06152L13.3565 7.455L10.544 4.6425Z"
      fill="#405189"
    />
  </svg>
);

export const DeleteListIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6.75V14.25H6V6.75H12ZM10.875 2.25H7.125L6.375 3H3.75V4.5H14.25V3H11.625L10.875 2.25ZM13.5 5.25H4.5V14.25C4.5 15.075 5.175 15.75 6 15.75H12C12.825 15.75 13.5 15.075 13.5 14.25V5.25Z"
      fill="#1D1D1D"
    />
  </svg>
);
export const CarrotIcon = () => (
  <svg
    width="26"
    height="29"
    viewBox="0 0 26 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.24785 16.3743C-0.149033 15.6179 -0.149036 13.6133 1.24785 12.8568L22.7977 1.18764C24.1303 0.466036 25.75 1.43092 25.75 2.94634L25.75 26.2848C25.75 27.8002 24.1303 28.7651 22.7977 28.0435L1.24785 16.3743Z"
      fill="white"
    />
  </svg>
);

export const ShowEye = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 1024 1024"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path>
  </svg>
);

export const CloseEye = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.42574 3.9833C10.9524 3.9833 13.2057 5.40331 14.3057 7.64997C13.9124 8.4633 13.3591 9.16331 12.6991 9.72997L13.6391 10.67C14.5657 9.84997 15.2991 8.82331 15.7591 7.64997C14.6057 4.72331 11.7591 2.64997 8.42574 2.64997C7.57907 2.64997 6.76574 2.7833 5.99907 3.02997L7.09907 4.12997C7.53241 4.0433 7.97241 3.9833 8.42574 3.9833ZM7.71241 4.7433L9.09241 6.12331C9.47241 6.28997 9.77907 6.59664 9.94574 6.97664L11.3257 8.35664C11.3791 8.12997 11.4191 7.88997 11.4191 7.6433C11.4257 5.98997 10.0791 4.64997 8.42574 4.64997C8.17907 4.64997 7.94574 4.6833 7.71241 4.7433ZM1.76574 2.5633L3.55241 4.34997C2.46574 5.20331 1.60574 6.33664 1.09241 7.64997C2.24574 10.5766 5.09241 12.65 8.42574 12.65C9.43907 12.65 10.4124 12.4566 11.3057 12.1033L13.5857 14.3833L14.5257 13.4433L2.70574 1.61664L1.76574 2.5633ZM6.76574 7.5633L8.50574 9.3033C8.47907 9.30997 8.45241 9.31664 8.42574 9.31664C7.50574 9.31664 6.75907 8.56997 6.75907 7.64997C6.75907 7.61664 6.76574 7.59664 6.76574 7.5633ZM4.49907 5.29664L5.66574 6.46331C5.51241 6.82997 5.42574 7.22997 5.42574 7.64997C5.42574 9.30331 6.77241 10.65 8.42574 10.65C8.84574 10.65 9.24574 10.5633 9.60574 10.41L10.2591 11.0633C9.67241 11.2233 9.05907 11.3166 8.42574 11.3166C5.89907 11.3166 3.64574 9.89664 2.54574 7.64997C3.01241 6.69664 3.69241 5.90997 4.49907 5.29664Z"
      fill="#495059"
    />
  </svg>
);
export const PaymentHubLogo = () => (
  <svg
    width="31"
    height="32"
    viewBox="0 0 31 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7859 15.8792C17.7859 17.9086 16.1407 19.5538 14.1113 19.5538C12.0819 19.5538 10.4368 17.9086 10.4368 15.8792C10.4368 13.8499 12.0819 12.2047 14.1113 12.2047C16.1407 12.2047 17.7859 13.8499 17.7859 15.8792Z"
      fill="#01A89E"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M30.7066 9.66036C30.7066 10.9228 29.6832 11.9462 28.4208 11.9462C27.1583 11.9462 26.1349 10.9228 26.1349 9.66036C26.1349 8.39792 27.1583 7.37451 28.4208 7.37451C29.6832 7.37451 30.7066 8.39792 30.7066 9.66036Z"
      fill="#FBB03B"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M25.7557 22.9434C25.7557 24.2059 24.7322 25.2293 23.4698 25.2293C22.2074 25.2293 21.184 24.2059 21.184 22.9434C21.184 21.681 22.2074 20.6576 23.4698 20.6576C24.7322 20.6576 25.7557 21.681 25.7557 22.9434Z"
      fill="#FB752A"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M9.9368 28.9811C9.9368 30.5104 8.69713 31.75 7.16793 31.75C5.63873 31.75 4.39906 30.5104 4.39906 28.9811C4.39906 27.4519 5.63873 26.2123 7.16793 26.2123C8.69713 26.2123 9.9368 27.4519 9.9368 28.9811Z"
      fill="#FBB03B"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M3.7783 12.9811C3.7783 13.9434 2.99818 14.7236 2.03585 14.7236C1.07352 14.7236 0.293396 13.9434 0.293396 12.9811C0.293396 12.0188 1.07352 11.2386 2.03585 11.2386C2.99818 11.2386 3.7783 12.0188 3.7783 12.9811Z"
      fill="#8CC63E"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M22.3745 8.27175C22.3745 9.23408 21.5944 10.0142 20.6321 10.0142C19.6697 10.0142 18.8896 9.23408 18.8896 8.27175C18.8896 7.30942 19.6697 6.5293 20.6321 6.5293C21.5944 6.5293 22.3745 7.30942 22.3745 8.27175Z"
      fill="#8CC63E"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M12.1104 1.63019C12.1104 2.39245 11.4925 3.01038 10.7302 3.01038C9.96794 3.01038 9.35001 2.39245 9.35001 1.63019C9.35001 0.867932 9.96794 0.25 10.7302 0.25C11.4925 0.25 12.1104 0.867932 12.1104 1.63019Z"
      fill="#FB752A"
      stroke="white"
      strokeWidth="0.5"
    />
    <line
      x1="18.2296"
      y1="14.1492"
      x2="25.4855"
      y2="10.8745"
      stroke="white"
      strokeWidth="0.5"
    />
    <line
      x1="11.3965"
      y1="4.17052"
      x2="13.0871"
      y2="11.5366"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M11.9688 20.0399L8.94994 25.5946"
      stroke="white"
      strokeWidth="0.5"
    />
    <line
      x1="9.44074"
      y1="14.8133"
      x2="4.82458"
      y2="13.8904"
      stroke="white"
      strokeWidth="0.5"
    />
    <line
      x1="20.784"
      y1="20.9698"
      x2="17.8858"
      y2="18.7962"
      stroke="white"
      strokeWidth="0.5"
    />
    <line
      x1="17.1232"
      y1="12.3938"
      x2="18.8137"
      y2="10.4618"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const BackArrowIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0876 6.675L11.9126 5.5L6.9126 10.5L11.9126 15.5L13.0876 14.325L9.27093 10.5L13.0876 6.675Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const EqualIcon = () => (
  <svg
    width="53"
    height="53"
    viewBox="0 0 53 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="52"
      height="52"
      rx="26"
      fill="#009C06"
      fillOpacity="0.2"
    />
    <path
      d="M17.5 20.5C16.6716 20.5 16 21.1716 16 22C16 22.8284 16.6716 23.5 17.5 23.5H35.5C36.3284 23.5 37 22.8284 37 22C37 21.1716 36.3284 20.5 35.5 20.5H17.5Z"
      fill="#009C06"
    />
    <path
      d="M17.5 29.5C16.6716 29.5 16 30.1716 16 31C16 31.8284 16.6716 32.5 17.5 32.5H35.5C36.3284 32.5 37 31.8284 37 31C37 30.1716 36.3284 29.5 35.5 29.5H17.5Z"
      fill="#009C06"
    />
  </svg>
);

export const NotEqualIcon = () => (
  <svg
    width="53"
    height="52"
    viewBox="0 0 53 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      width="52"
      height="52"
      rx="26"
      fill="#9C1C00"
      fillOpacity="0.2"
    />
    <path
      d="M18.4874 15.7318C19.1405 15.2222 20.0831 15.3385 20.5927 15.9916L23.9159 20.2503H37C37.8284 20.2503 38.5 20.9219 38.5 21.7503C38.5 22.5787 37.8284 23.2503 37 23.2503H26.2568L30.9388 29.2503H37C37.8284 29.2503 38.5 29.9219 38.5 30.7503C38.5 31.5787 37.8284 32.2503 37 32.2503H33.2797L34.7721 34.1629C35.2817 34.816 35.1654 35.7586 34.5123 36.2682C33.8592 36.7779 32.9166 36.6615 32.407 36.0084L29.4744 32.2503H16C15.1716 32.2503 14.5 31.5787 14.5 30.7503C14.5 29.9219 15.1716 29.2503 16 29.2503H27.1335L22.4516 23.2503H16C15.1716 23.2503 14.5 22.5787 14.5 21.7503C14.5 20.9219 15.1716 20.2503 16 20.2503H20.1106L18.2276 17.8372C17.7179 17.184 17.8343 16.2414 18.4874 15.7318Z"
      fill="#9C1C00"
    />
  </svg>
);

export const DisableIcon = () => (
  <svg
    width="53"
    height="52"
    viewBox="0 0 53 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      width="52"
      height="52"
      rx="26"
      fill="#A2A2A2"
      fillOpacity="0.2"
    />
    <path
      d="M17.5 20C16.6716 20 16 20.6716 16 21.5C16 22.3284 16.6716 23 17.5 23H35.5C36.3284 23 37 22.3284 37 21.5C37 20.6716 36.3284 20 35.5 20H17.5Z"
      fill="#A2A2A2"
    />
    <path
      d="M17.5 29C16.6716 29 16 29.6716 16 30.5C16 31.3284 16.6716 32 17.5 32H35.5C36.3284 32 37 31.3284 37 30.5C37 29.6716 36.3284 29 35.5 29H17.5Z"
      fill="#A2A2A2"
    />
  </svg>
);

export const DeleteButton = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6666 6V12.6667H5.33325V6H10.6666ZM9.66659 2H6.33325L5.66659 2.66667H3.33325V4H12.6666V2.66667H10.3333L9.66659 2ZM11.9999 4.66667H3.99992V12.6667C3.99992 13.4 4.59992 14 5.33325 14H10.6666C11.3999 14 11.9999 13.4 11.9999 12.6667V4.66667Z"
      fill="#C7222A"
    />
  </svg>
);

export const AddButton = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6666 8.66683H8.66659V12.6668H7.33325V8.66683H3.33325V7.3335H7.33325V3.3335H8.66659V7.3335H12.6666V8.66683Z"
      fill="#C7222A"
    />
  </svg>
);

export const ProfileSettingIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9547 9.15331C12.9814 8.93998 13.0014 8.72665 13.0014 8.49998C13.0014 8.27331 12.9814 8.05998 12.9547 7.84665L14.3614 6.74665C14.488 6.64665 14.5214 6.46665 14.4414 6.31998L13.108 4.01331C13.048 3.90665 12.9347 3.84665 12.8147 3.84665C12.7747 3.84665 12.7347 3.85331 12.7014 3.86665L11.0414 4.53331C10.6947 4.26665 10.3214 4.04665 9.91469 3.87998L9.66136 2.11331C9.64136 1.95331 9.50136 1.83331 9.33469 1.83331H6.66802C6.50136 1.83331 6.36136 1.95331 6.34136 2.11331L6.08802 3.87998C5.68136 4.04665 5.30802 4.27331 4.96136 4.53331L3.30136 3.86665C3.26136 3.85331 3.22136 3.84665 3.18136 3.84665C3.06802 3.84665 2.95469 3.90665 2.89469 4.01331L1.56136 6.31998C1.47469 6.46665 1.51469 6.64665 1.64136 6.74665L3.04802 7.84665C3.02136 8.05998 3.00136 8.27998 3.00136 8.49998C3.00136 8.71998 3.02136 8.93998 3.04802 9.15331L1.64136 10.2533C1.51469 10.3533 1.48136 10.5333 1.56136 10.68L2.89469 12.9866C2.95469 13.0933 3.06802 13.1533 3.18802 13.1533C3.22802 13.1533 3.26802 13.1466 3.30136 13.1333L4.96136 12.4666C5.30802 12.7333 5.68136 12.9533 6.08802 13.12L6.34136 14.8866C6.36136 15.0466 6.50136 15.1666 6.66802 15.1666H9.33469C9.50136 15.1666 9.64136 15.0466 9.66136 14.8866L9.91469 13.12C10.3214 12.9533 10.6947 12.7266 11.0414 12.4666L12.7014 13.1333C12.7414 13.1466 12.7814 13.1533 12.8214 13.1533C12.9347 13.1533 13.048 13.0933 13.108 12.9866L14.4414 10.68C14.5214 10.5333 14.488 10.3533 14.3614 10.2533L12.9547 9.15331ZM11.6347 8.01331C11.6614 8.21998 11.668 8.35998 11.668 8.49998C11.668 8.63998 11.6547 8.78665 11.6347 8.98665L11.5414 9.73998L12.1347 10.2066L12.8547 10.7666L12.388 11.5733L11.5414 11.2333L10.848 10.9533L10.248 11.4066C9.96136 11.62 9.68802 11.78 9.41469 11.8933L8.70802 12.18L8.60136 12.9333L8.46802 13.8333H7.53469L7.30136 12.18L6.59469 11.8933C6.30802 11.7733 6.04136 11.62 5.77469 11.42L5.16802 10.9533L4.46136 11.24L3.61469 11.58L3.14802 10.7733L3.86802 10.2133L4.46136 9.74665L4.36802 8.99331C4.34802 8.78665 4.33469 8.63331 4.33469 8.49998C4.33469 8.36665 4.34802 8.21331 4.36802 8.01331L4.46136 7.25998L3.86802 6.79331L3.14802 6.23331L3.61469 5.42665L4.46136 5.76665L5.15469 6.04665L5.75469 5.59331C6.04136 5.37998 6.31469 5.21998 6.58802 5.10665L7.29469 4.81998L7.40136 4.06665L7.53469 3.16665H8.46136L8.69469 4.81998L9.40136 5.10665C9.68803 5.22665 9.95469 5.37998 10.2214 5.57998L10.828 6.04665L11.5347 5.75998L12.3814 5.41998L12.848 6.22665L12.1347 6.79331L11.5414 7.25998L11.6347 8.01331ZM8.00136 5.83331C6.52802 5.83331 5.33469 7.02665 5.33469 8.49998C5.33469 9.97331 6.52802 11.1666 8.00136 11.1666C9.47469 11.1666 10.668 9.97331 10.668 8.49998C10.668 7.02665 9.47469 5.83331 8.00136 5.83331ZM8.00136 9.83331C7.26802 9.83331 6.66802 9.23331 6.66802 8.49998C6.66802 7.76665 7.26802 7.16665 8.00136 7.16665C8.73469 7.16665 9.33469 7.76665 9.33469 8.49998C9.33469 9.23331 8.73469 9.83331 8.00136 9.83331Z"
      fill="#2F2805"
    />
  </svg>
);

export const ProfileLogoutIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 5.83333L10.3933 6.77333L11.4467 7.83333H6V9.16667H11.4467L10.3933 10.22L11.3333 11.1667L14 8.5L11.3333 5.83333ZM3.33333 3.83333H8V2.5H3.33333C2.6 2.5 2 3.1 2 3.83333V13.1667C2 13.9 2.6 14.5 3.33333 14.5H8V13.1667H3.33333V3.83333Z"
      fill="#2F2805"
    />
  </svg>
);
export const OrangeDot = () => (
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4.16663" cy="4" r="4" fill="#FFA047" />
  </svg>
);

export const UploadButtonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
  >
    <path
      d="M25.8 13.8866C24.8933 9.28658 20.8533 5.83325 16 5.83325C12.1467 5.83325 8.8 8.01992 7.13333 11.2199C3.12 11.6466 0 15.0466 0 19.1666C0 23.5799 3.58667 27.1666 8 27.1666H25.3333C29.0133 27.1666 32 24.1799 32 20.4999C32 16.9799 29.2667 14.1266 25.8 13.8866ZM18.6667 17.8333V23.1666H13.3333V17.8333H9.33333L16 11.1666L22.6667 17.8333H18.6667Z"
      fill="#77838F"
    />
  </svg>
);
export const SettingSmallIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0021 7.57169C12.0255 7.38503 12.043 7.19836 12.043 7.00003C12.043 6.80169 12.0255 6.61503 12.0021 6.42836L13.233 5.46586C13.3438 5.37836 13.373 5.22086 13.303 5.09253L12.1363 3.07419C12.0838 2.98086 11.9846 2.92836 11.8796 2.92836C11.8446 2.92836 11.8096 2.93419 11.7805 2.94586L10.328 3.52919C10.0246 3.29586 9.69795 3.10336 9.34212 2.95753L9.12045 1.41169C9.10295 1.27169 8.98045 1.16669 8.83462 1.16669H6.50128C6.35545 1.16669 6.23295 1.27169 6.21545 1.41169L5.99378 2.95753C5.63795 3.10336 5.31128 3.30169 5.00795 3.52919L3.55545 2.94586C3.52045 2.93419 3.48545 2.92836 3.45045 2.92836C3.35128 2.92836 3.25212 2.98086 3.19962 3.07419L2.03295 5.09253C1.95712 5.22086 1.99212 5.37836 2.10295 5.46586L3.33378 6.42836C3.31045 6.61503 3.29295 6.80753 3.29295 7.00003C3.29295 7.19253 3.31045 7.38503 3.33378 7.57169L2.10295 8.53419C1.99212 8.62169 1.96295 8.77919 2.03295 8.90753L3.19962 10.9259C3.25212 11.0192 3.35128 11.0717 3.45628 11.0717C3.49128 11.0717 3.52628 11.0659 3.55545 11.0542L5.00795 10.4709C5.31128 10.7042 5.63795 10.8967 5.99378 11.0425L6.21545 12.5884C6.23295 12.7284 6.35545 12.8334 6.50128 12.8334H8.83462C8.98045 12.8334 9.10295 12.7284 9.12045 12.5884L9.34212 11.0425C9.69795 10.8967 10.0246 10.6984 10.328 10.4709L11.7805 11.0542C11.8155 11.0659 11.8505 11.0717 11.8855 11.0717C11.9846 11.0717 12.0838 11.0192 12.1363 10.9259L13.303 8.90753C13.373 8.77919 13.3438 8.62169 13.233 8.53419L12.0021 7.57169ZM10.8471 6.57419C10.8705 6.75503 10.8763 6.87753 10.8763 7.00003C10.8763 7.12253 10.8646 7.25086 10.8471 7.42586L10.7655 8.08503L11.2846 8.49336L11.9146 8.98336L11.5063 9.68919L10.7655 9.3917L10.1588 9.14669L9.63378 9.54336C9.38295 9.73003 9.14378 9.87003 8.90462 9.96919L8.28628 10.22L8.19295 10.8792L8.07628 11.6667H7.25962L7.05545 10.22L6.43712 9.96919C6.18628 9.86419 5.95295 9.73003 5.71962 9.55503L5.18878 9.14669L4.57045 9.39753L3.82962 9.69503L3.42128 8.98919L4.05128 8.49919L4.57045 8.09086L4.48878 7.43169C4.47128 7.25086 4.45962 7.11669 4.45962 7.00003C4.45962 6.88336 4.47128 6.74919 4.48878 6.57419L4.57045 5.91503L4.05128 5.50669L3.42128 5.01669L3.82962 4.31086L4.57045 4.60836L5.17712 4.85336L5.70212 4.45669C5.95295 4.27003 6.19212 4.13003 6.43128 4.03086L7.04962 3.78003L7.14295 3.12086L7.25962 2.33336H8.07045L8.27462 3.78003L8.89295 4.03086C9.14378 4.13586 9.37712 4.27003 9.61045 4.44503L10.1413 4.85336L10.7596 4.60253L11.5005 4.30503L11.9088 5.01086L11.2846 5.50669L10.7655 5.91503L10.8471 6.57419ZM7.66795 4.66669C6.37878 4.66669 5.33462 5.71086 5.33462 7.00003C5.33462 8.28919 6.37878 9.33336 7.66795 9.33336C8.95712 9.33336 10.0013 8.28919 10.0013 7.00003C10.0013 5.71086 8.95712 4.66669 7.66795 4.66669ZM7.66795 8.16669C7.02628 8.16669 6.50128 7.64169 6.50128 7.00003C6.50128 6.35836 7.02628 5.83336 7.66795 5.83336C8.30962 5.83336 8.83462 6.35836 8.83462 7.00003C8.83462 7.64169 8.30962 8.16669 7.66795 8.16669Z"
      fill="#77838F"
    />
  </svg>
);

export const ChatIcon = () => (
  <>
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 9.5H11C10.175 9.5 9.5 10.175 9.5 11V24.5L12.5 21.5H23C23.825 21.5 24.5 20.825 24.5 20V11C24.5 10.175 23.825 9.5 23 9.5ZM23 20H12.5L11 21.5V11H23V20Z"
        fill="#1D1D1D"
      />
      <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#1D1D1D" />
    </svg>
  </>
);
export const AddIconBlack = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z"
      fill="#326789"
    />
  </svg>
);
export const AttachmentIconblack = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33317 3.49992V10.2083C9.33317 11.4974 8.289 12.5416 6.99984 12.5416C5.71067 12.5416 4.6665 11.4974 4.6665 10.2083V2.91659C4.6665 2.11159 5.31984 1.45825 6.12484 1.45825C6.92984 1.45825 7.58317 2.11159 7.58317 2.91659V9.04159C7.58317 9.36242 7.32067 9.62492 6.99984 9.62492C6.679 9.62492 6.4165 9.36242 6.4165 9.04159V3.49992H5.5415V9.04159C5.5415 9.84659 6.19484 10.4999 6.99984 10.4999C7.80484 10.4999 8.45817 9.84659 8.45817 9.04159V2.91659C8.45817 1.62742 7.414 0.583252 6.12484 0.583252C4.83567 0.583252 3.7915 1.62742 3.7915 2.91659V10.2083C3.7915 11.9816 5.2265 13.4166 6.99984 13.4166C8.77317 13.4166 10.2082 11.9816 10.2082 10.2083V3.49992H9.33317Z"
      fill="#326789"
    />
  </svg>
);
export const AttachmentIconCircle = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 12.5V21.125C20 22.7825 18.6575 24.125 17 24.125C15.3425 24.125 14 22.7825 14 21.125V11.75C14 10.715 14.84 9.875 15.875 9.875C16.91 9.875 17.75 10.715 17.75 11.75V19.625C17.75 20.0375 17.4125 20.375 17 20.375C16.5875 20.375 16.25 20.0375 16.25 19.625V12.5H15.125V19.625C15.125 20.66 15.965 21.5 17 21.5C18.035 21.5 18.875 20.66 18.875 19.625V11.75C18.875 10.0925 17.5325 8.75 15.875 8.75C14.2175 8.75 12.875 10.0925 12.875 11.75V21.125C12.875 23.405 14.72 25.25 17 25.25C19.28 25.25 21.125 23.405 21.125 21.125V12.5H20Z"
      fill="#1D1D1D"
    />
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#1D1D1D" />
  </svg>
);

export const LongArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2.6325 4.5225L8.265 6.9375L2.625 6.1875L2.6325 4.5225ZM8.2575 11.0625L2.625 13.4775V11.8125L8.2575 11.0625ZM1.1325 2.25L1.125 7.5L12.375 9L1.125 10.5L1.1325 15.75L16.875 9L1.1325 2.25Z"
      fill="#1D1D1D"
    />
  </svg>
);
export const VerifiedIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" fill="#1E1E1E" />
    <g id="Reconciliation" clipPath="url(#clip0_1053_18095)">
      <rect
        width="1440"
        height="1016"
        transform="translate(-700 -373)"
        fill="#F5F5F5"
      />
      <g id="6">
        <g clipPath="url(#clip1_1053_18095)">
          <g id="Frame 27146">
            <g id="Frame 27286">
              <g id="Frame 27151" filter="url(#filter0_d_1053_18095)">
                <g id="Frame 27283">
                  <g id="Frame 27177">
                    <rect
                      x="-591"
                      y="-231"
                      width="609"
                      height="272"
                      rx="8"
                      fill="white"
                    />
                    <g id="Frame 26995">
                      <rect
                        width="609"
                        height="206"
                        transform="translate(-591 -198)"
                        fill="white"
                      />
                    </g>
                  </g>
                  <g id="Frame 27010">
                    <g id="Frame 26995_2">
                      <path
                        d="M30 -223C30 -227.418 33.5817 -231 38 -231H314C318.418 -231 322 -227.418 322 -223V41H38C33.5817 41 30 37.4183 30 33V-223Z"
                        fill="white"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <rect
        id="Rectangle 20"
        opacity="0.3"
        x="-700"
        y="-373"
        width="1440"
        height="1024"
        fill="#495059"
      />
      <g id="Frame 21531" filter="url(#filter1_d_1053_18095)">
        <rect
          width="578"
          height="523"
          transform="translate(-269 -126)"
          fill="white"
        />
        <g id="Frame 1565">
          <g id="Frame 77">
            <g id="Frame 79">
              <g id="verified-badge-svgrepo-com 2">
                <path
                  id="Vector"
                  d="M19.2131 2.66658C19.6136 2.15736 20.3849 2.15736 20.7854 2.66658L23.8001 6.50093C24.0508 6.81963 24.4689 6.9555 24.8589 6.84496L29.5516 5.51491C30.1749 5.33828 30.7991 5.79175 30.8236 6.43905L31.0088 11.3131C31.0243 11.7182 31.2826 12.074 31.6633 12.2138L36.2414 13.8961C36.8494 14.1195 37.0879 14.8532 36.7273 15.3914L34.0123 19.4434C33.7866 19.7802 33.7866 20.2199 34.0123 20.5567L36.7273 24.6087C37.0879 25.1469 36.8494 25.8806 36.2414 26.1041L31.6633 27.7864C31.2826 27.9262 31.0243 28.2819 31.0088 28.6871L30.8236 33.5611C30.7991 34.2084 30.1749 34.6619 29.5516 34.4852L24.8589 33.1552C24.4689 33.0446 24.0508 33.1806 23.8001 33.4992L20.7854 37.3336C20.3849 37.8428 19.6136 37.8428 19.2131 37.3336L16.1984 33.4992C15.9479 33.1806 15.5297 33.0446 15.1396 33.1552L10.4469 34.4852C9.82366 34.6619 9.19951 34.2084 9.17493 33.5611L8.98973 28.6871C8.97433 28.2819 8.71588 27.9262 8.33535 27.7864L3.75706 26.1041C3.14905 25.8806 2.91065 25.1469 3.27123 24.6087L5.9863 20.5567C6.21196 20.2199 6.21196 19.7802 5.9863 19.4434L3.27123 15.3914C2.91065 14.8532 3.14905 14.1195 3.75706 13.8961L8.33536 12.2138C8.71588 12.074 8.97433 11.7182 8.98973 11.3131L9.17493 6.43905C9.19951 5.79175 9.82366 5.33828 10.4469 5.51491L15.1396 6.84496C15.5297 6.9555 15.9479 6.81963 16.1984 6.50093L19.2131 2.66658Z"
                  fill="#CCEBCD"
                  stroke="#009C06"
                  strokeWidth="2"
                />
                <path
                  id="Vector_2"
                  d="M15 20.0001L18.3333 23.3334L25 16.6667"
                  stroke="#009C06"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <rect
              x="-228.9"
              y="-39.9"
              width="497.8"
              height="396.8"
              rx="19.9"
              stroke="#AAAFB3"
              strokeWidth="0.2"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_1053_18095"
        x="-603"
        y="-243"
        width="937"
        height="296"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1053_18095"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1053_18095"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1053_18095"
        x="-299"
        y="-146"
        width="618"
        height="563"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1053_18095"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1053_18095"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_1053_18095">
        <rect
          width="1440"
          height="1016"
          fill="white"
          transform="translate(-700 -373)"
        />
      </clipPath>
      <clipPath id="clip1_1053_18095">
        <rect x="-591" y="-289" width="1309" height="861" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhiteDownload = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 11.75V14H4.5V11.75H3V14C3 14.825 3.675 15.5 4.5 15.5H13.5C14.325 15.5 15 14.825 15 14V11.75H13.5ZM12.75 8.75L11.6925 7.6925L9.75 9.6275V3.5H8.25V9.6275L6.3075 7.6925L5.25 8.75L9 12.5L12.75 8.75Z"
      fill="white"
    />
  </svg>
);

export const MsgIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 3.99V8.5C11 9.05 10.55 9.5 10 9.5H3L1 11.5V2.5C1 1.95 1.45 1.5 2 1.5H7.05C7.02 1.66 7 1.83 7 2C7 2.17 7.02 2.34 7.05 2.5H2V8.5H10V4.45C10.37 4.375 10.71 4.21 11 3.99ZM8 2C8 2.83 8.67 3.5 9.5 3.5C10.33 3.5 11 2.83 11 2C11 1.17 10.33 0.5 9.5 0.5C8.67 0.5 8 1.17 8 2Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const AttachmentIconWorkflow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3V8.75C8 9.855 7.105 10.75 6 10.75C4.895 10.75 4 9.855 4 8.75V2.5C4 1.81 4.56 1.25 5.25 1.25C5.94 1.25 6.5 1.81 6.5 2.5V7.75C6.5 8.025 6.275 8.25 6 8.25C5.725 8.25 5.5 8.025 5.5 7.75V3H4.75V7.75C4.75 8.44 5.31 9 6 9C6.69 9 7.25 8.44 7.25 7.75V2.5C7.25 1.395 6.355 0.5 5.25 0.5C4.145 0.5 3.25 1.395 3.25 2.5V8.75C3.25 10.27 4.48 11.5 6 11.5C7.52 11.5 8.75 10.27 8.75 8.75V3H8Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const PlusRed = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0834 7.58366H7.58341V11.0837H6.41675V7.58366H2.91675V6.41699H6.41675V2.91699H7.58341V6.41699H11.0834V7.58366Z"
      fill="#C7222A"
    />
  </svg>
);

export const RedCalenderIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 1.99999H12.6667V0.666656H11.3333V1.99999H4.66668V0.666656H3.33334V1.99999H2.66668C1.93334 1.99999 1.33334 2.59999 1.33334 3.33332V14C1.33334 14.7333 1.93334 15.3333 2.66668 15.3333H13.3333C14.0667 15.3333 14.6667 14.7333 14.6667 14V3.33332C14.6667 2.59999 14.0667 1.99999 13.3333 1.99999ZM13.3333 14H2.66668V6.66666H13.3333V14ZM13.3333 5.33332H2.66668V3.33332H13.3333V5.33332Z"
      fill="#C7222A"
    />
  </svg>
);

export const GrayCalenderIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 1.99999H12.6667V0.666656H11.3333V1.99999H4.66668V0.666656H3.33334V1.99999H2.66668C1.93334 1.99999 1.33334 2.59999 1.33334 3.33332V14C1.33334 14.7333 1.93334 15.3333 2.66668 15.3333H13.3333C14.0667 15.3333 14.6667 14.7333 14.6667 14V3.33332C14.6667 2.59999 14.0667 1.99999 13.3333 1.99999ZM13.3333 14H2.66668V6.66666H13.3333V14ZM13.3333 5.33332H2.66668V3.33332H13.3333V5.33332Z"
      fill="#77838f"
    />
  </svg>
);

export const CalenderWhiteIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 1.99999H12.6667V0.666656H11.3333V1.99999H4.66668V0.666656H3.33334V1.99999H2.66668C1.93334 1.99999 1.33334 2.59999 1.33334 3.33332V14C1.33334 14.7333 1.93334 15.3333 2.66668 15.3333H13.3333C14.0667 15.3333 14.6667 14.7333 14.6667 14V3.33332C14.6667 2.59999 14.0667 1.99999 13.3333 1.99999ZM13.3333 14H2.66668V6.66666H13.3333V14ZM13.3333 5.33332H2.66668V3.33332H13.3333V5.33332Z"
      fill="#fff"
    />
  </svg>
);

export const BothDirectionArrow = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1696 11.3335C14.6299 11.3335 15.003 11.7066 15.003 12.1668C15.003 12.5942 14.6813 12.9464 14.2668 12.9946L14.1696 13.0002H4.51547L7.25889 15.7442C7.5593 16.0446 7.58241 16.5173 7.32822 16.8442L7.25889 16.9228C6.95849 17.2232 6.4858 17.2463 6.15889 16.9921L6.08038 16.9228L1.91372 12.7561C1.41157 12.2539 1.72992 11.4108 2.40828 11.3385L2.50297 11.3335H14.1696ZM13.8454 4.00825L13.9239 4.07757L18.0906 8.24424C18.5927 8.74639 18.2744 9.58948 17.596 9.66184L17.5013 9.66683H5.83464C5.3744 9.66683 5.0013 9.29373 5.0013 8.8335C5.0013 8.40613 5.323 8.05391 5.73745 8.00577L5.83464 8.00016H15.4888L12.7454 5.25609C12.445 4.95568 12.4219 4.48299 12.6761 4.15608L12.7454 4.07757C13.0458 3.77717 13.5185 3.75406 13.8454 4.00825Z"
      fill="#64C2DB"
    />
  </svg>
);
export const ManIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 5.41659C11.6333 5.41659 12.4167 6.19992 12.4167 7.16659C12.4167 8.13325 11.6333 8.91659 10.6667 8.91659C9.7 8.91659 8.91667 8.13325 8.91667 7.16659C8.91667 6.19992 9.7 5.41659 10.6667 5.41659ZM10.6667 12.9166C13.1417 12.9166 15.75 14.1333 15.75 14.6666V15.5833H5.58333V14.6666C5.58333 14.1333 8.19167 12.9166 10.6667 12.9166ZM10.6667 3.83325C8.825 3.83325 7.33333 5.32492 7.33333 7.16659C7.33333 9.00825 8.825 10.4999 10.6667 10.4999C12.5083 10.4999 14 9.00825 14 7.16659C14 5.32492 12.5083 3.83325 10.6667 3.83325ZM10.6667 11.3333C8.44167 11.3333 4 12.4499 4 14.6666V17.1666H17.3333V14.6666C17.3333 12.4499 12.8917 11.3333 10.6667 11.3333Z"
      fill="#FFA047"
    />
  </svg>
);
export const ThreeArrowIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 13.8333L11.1667 10.5V7.85C12.1334 7.5 12.8334 6.58333 12.8334 5.5C12.8334 4.11667 11.7167 3 10.3334 3C8.95004 3 7.83337 4.11667 7.83337 5.5C7.83337 6.58333 8.53337 7.5 9.50004 7.85V10.5L6.16671 13.8333H2.83337V18H7.00004V15.4583L10.3334 11.9583L13.6667 15.4583V18H17.8334V13.8333H14.5Z"
      fill="#F9C74F"
    />
  </svg>
);

export const ExpenseBookingPlusIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75 5.25H8.25V8.25H5.25V9.75H8.25V12.75H9.75V9.75H12.75V8.25H9.75V5.25ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const ChargebackAttachment = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 4.5V13.125C12.5 14.7825 11.1575 16.125 9.5 16.125C7.8425 16.125 6.5 14.7825 6.5 13.125V3.75C6.5 2.715 7.34 1.875 8.375 1.875C9.41 1.875 10.25 2.715 10.25 3.75V11.625C10.25 12.0375 9.9125 12.375 9.5 12.375C9.0875 12.375 8.75 12.0375 8.75 11.625V4.5H7.625V11.625C7.625 12.66 8.465 13.5 9.5 13.5C10.535 13.5 11.375 12.66 11.375 11.625V3.75C11.375 2.0925 10.0325 0.75 8.375 0.75C6.7175 0.75 5.375 2.0925 5.375 3.75V13.125C5.375 15.405 7.22 17.25 9.5 17.25C11.78 17.25 13.625 15.405 13.625 13.125V4.5H12.5Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const ReportDownload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M13.5 11.25V13.5H4.5V11.25H3V13.5C3 14.325 3.675 15 4.5 15H13.5C14.325 15 15 14.325 15 13.5V11.25H13.5ZM12.75 8.25L11.6925 7.1925L9.75 9.1275V3H8.25V9.1275L6.3075 7.1925L5.25 8.25L9 12L12.75 8.25Z"
      fill="white"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      d="M11.0833 4.23949L10.2608 3.41699L6.99996 6.67783L3.73913 3.41699L2.91663 4.23949L6.17746 7.50033L2.91663 10.7612L3.73913 11.5837L6.99996 8.32283L10.2608 11.5837L11.0833 10.7612L7.82246 7.50033L11.0833 4.23949Z"
      fill="#0C2033"
    />
  </svg>
);

export const CardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M14.25 2.75H3.75C2.925 2.75 2.25 3.425 2.25 4.25V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V4.25C15.75 3.425 15.075 2.75 14.25 2.75ZM3.75 14.75V4.25H8.25V14.75H3.75ZM14.25 14.75H9.75V9.5H14.25V14.75ZM14.25 8H9.75V4.25H14.25V8Z"
      fill="#1D1D1D"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const ErrorPageIcon = () => (
  <svg
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2524_12172)">
      <path
        d="M57.0763 25.6277H23.9244C22.89 25.6277 22.0513 26.4662 22.0513 27.5008C22.0513 28.5353 22.8899 29.3739 23.9244 29.3739H57.0763C58.1108 29.3739 58.9494 28.5352 58.9494 27.5008C58.9494 26.4662 58.1108 25.6277 57.0763 25.6277Z"
        fill="#1D1D1D"
      />
      <path
        d="M57.0763 36.9305H23.9244C22.89 36.9305 22.0513 37.7692 22.0513 38.8036C22.0513 39.8381 22.8899 40.6767 23.9244 40.6767H57.0763C58.1108 40.6767 58.9494 39.838 58.9494 38.8036C58.9494 37.7692 58.1108 36.9305 57.0763 36.9305Z"
        fill="#1D1D1D"
      />
      <path
        d="M70.4901 16.1623C70.4773 15.6923 70.2907 15.2336 69.9449 14.8877L55.6184 0.561097C55.2784 0.21516 54.8059 -0.000152588 54.2824 -0.000152588H14.4507C12.2757 -0.000152588 10.5059 1.76938 10.5059 3.94485L10.5066 50.7188C10.5066 50.7353 10.5087 50.7511 10.5091 50.7677C10.5348 51.7153 11.0252 52.5742 11.8348 53.0769L18.296 57.0873C20.4287 58.4106 23.078 58.4106 25.2104 57.0872L29.6449 54.335C30.5588 53.7677 31.6943 53.7678 32.6082 54.3349L37.0427 57.0872C38.109 57.7492 39.3043 58.0802 40.4999 58.08C41.6954 58.08 42.8912 57.7491 43.9571 57.0872L48.3916 54.3349C49.3055 53.7678 50.441 53.7678 51.3549 54.3349L55.7895 57.0872C57.9215 58.4109 60.5707 58.4109 62.7038 57.0872L69.1656 53.0767C69.9748 52.5744 70.4651 51.7153 70.4909 50.7678C70.4912 50.7516 70.4934 50.7355 70.4934 50.7189L70.4941 16.2119C70.4943 16.1938 70.4915 16.1786 70.4901 16.1623ZM56.1551 6.3961H56.1552L64.0981 14.3389H56.3523C56.2437 14.3389 56.1551 14.2503 56.1551 14.1417V6.3961ZM66.7473 50.1688L60.7285 53.9044C59.8146 54.4717 58.6791 54.4716 57.7652 53.9045L53.3307 51.152C51.1981 49.8288 48.5487 49.8289 46.4163 51.1522L41.9818 53.9045C41.0679 54.4716 39.9324 54.4716 39.0185 53.9045L34.584 51.1522C32.4518 49.8284 29.8024 49.8284 27.6696 51.1522L23.2351 53.9045C22.3212 54.4716 21.1857 54.4716 20.2718 53.9045L14.253 50.1688L14.2521 3.945C14.2521 3.83547 14.3413 3.74625 14.4507 3.74625H52.409V14.1419C52.409 16.3163 54.1779 18.0853 56.3524 18.0853H66.7481L66.7473 50.1688Z"
        fill="#1D1D1D"
      />
      <path
        d="M70.4937 61.8669C70.4938 61.862 70.493 61.8573 70.493 61.8525C70.493 61.8476 70.4938 61.843 70.4938 61.8381C70.4938 60.8192 69.9405 59.8781 69.0498 59.3828C68.1591 58.8878 67.0682 58.9136 66.2024 59.4509L60.6649 62.8875C59.7902 63.4302 58.7033 63.4301 57.829 62.8876L53.2669 60.0562C51.1737 58.7567 48.5729 58.7567 46.4799 60.0562L41.9179 62.8875C41.0432 63.4302 39.9565 63.4301 39.0818 62.8876L34.5197 60.0562C32.4266 58.757 29.8257 58.757 27.7327 60.0562L23.171 62.8875C22.2963 63.4302 21.2094 63.4303 20.3351 62.8875L14.7977 59.4509C13.9319 58.9137 12.841 58.8872 11.9502 59.3828C11.0596 59.8783 10.5062 60.8191 10.5062 61.8381C10.5062 61.843 10.5069 61.8476 10.5069 61.8525C10.5069 61.8573 10.5062 61.862 10.5062 61.8669L10.5054 76.055C10.5054 78.2303 12.2749 80 14.4502 80H66.5493C68.7243 80 70.4941 78.2305 70.4941 76.0548L70.4937 61.8669ZM66.5498 76.2537H14.451C14.3416 76.2537 14.2524 76.1645 14.2524 76.0551L14.253 63.5216L18.3601 66.0706C20.4535 67.3694 23.0541 67.3694 25.1469 66.0705L29.7087 63.2391C30.5832 62.6962 31.6697 62.6964 32.5447 63.2391L37.1065 66.0706C38.1532 66.72 39.3266 67.0448 40.5001 67.0448C41.6733 67.0448 42.8469 66.72 43.8937 66.0705L48.4554 63.2391C49.3299 62.6962 50.4165 62.6961 51.2915 63.2391L55.8535 66.0706C57.9472 67.3697 60.5476 67.3694 62.6404 66.0706L66.7474 63.5216L66.748 76.055C66.7483 76.1645 66.6593 76.2537 66.5498 76.2537Z"
        fill="#1D1D1D"
      />
    </g>
    <defs>
      <clipPath id="clip0_2524_12172">
        <rect width="80" height="80" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const SplitscreenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M8.25 5.25H9.75V6.75H8.25V5.25ZM8.25 8.25H9.75V12.75H8.25V8.25ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const TableFirstPageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
  >
    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
    <path fill="none" d="M24 24H0V0h24v24z"></path>
  </svg>
);

export const TablePreviousPageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
  >
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
    <path d="M0 0h24v24H0z" fill="none"></path>
  </svg>
);

export const TableNextPageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
  >
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
    <path d="M0 0h24v24H0z" fill="none"></path>
  </svg>
);

export const TableLastPageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
  >
    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
    <path fill="none" d="M0 0h24v24H0V0z"></path>
  </svg>
);

export const DownloadReportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M13.5 11.25V13.5H4.5V11.25H3V13.5C3 14.325 3.675 15 4.5 15H13.5C14.325 15 15 14.325 15 13.5V11.25H13.5ZM12.75 8.25L11.6925 7.1925L9.75 9.1275V3H8.25V9.1275L6.3075 7.1925L5.25 8.25L9 12L12.75 8.25Z"
      fill="#C7222A"
    />
  </svg>
);

export const ReportCalenderIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class=" react-datepicker__calendar-icon undefined false"
  >
    <mask id="ipSApplication0">
      <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="0.5">
        <path
          d="M15.6665 2.49998H14.8332V0.833313H13.1665V2.49998H4.83317V0.833313H3.1665V2.49998H2.33317C1.4165 2.49998 0.666504 3.24998 0.666504 4.16665V17.5C0.666504 18.4166 1.4165 19.1666 2.33317 19.1666H15.6665C16.5832 19.1666 17.3332 18.4166 17.3332 17.5V4.16665C17.3332 3.24998 16.5832 2.49998 15.6665 2.49998ZM15.6665 17.5H2.33317V8.33331H15.6665V17.5ZM15.6665 6.66665H2.33317V4.16665H15.6665V6.66665Z"
          fill="#1F4E79"
        ></path>
      </g>
    </mask>
    <path
      fill="currentColor"
      d="M0 0h48v48H0z"
      mask="url(#ipSApplication0)"
    ></path>
  </svg>
);

export const CloseFilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.0833 4.23949L10.2608 3.41699L6.99996 6.67783L3.73913 3.41699L2.91663 4.23949L6.17746 7.50033L2.91663 10.7612L3.73913 11.5837L6.99996 8.32283L10.2608 11.5837L11.0833 10.7612L7.82246 7.50033L11.0833 4.23949Z"
      fill="#c7222a"
    />
  </svg>
);

export const SortUpDownArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="currentColor"
    className="bi bi-arrow-down-up"
    viewBox="0 0 16 16"
  >
    <path
      fill-rule="evenodd"
      d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"
    />
  </svg>
);

export const SortUpArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="14"
    height="14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <polyline points="19 12 12 5 5 12"></polyline>
  </svg>
);

export const SortDownArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="14"
    height="14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="19" x2="12" y2="5"></line>
    <polyline points="5 12 12 19 19 12"></polyline>
  </svg>
);

export const TableDragIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="tabler-icon tabler-icon-grip-horizontal"
  >
    <path d="M5 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
    <path d="M5 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
    <path d="M12 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
    <path d="M12 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
    <path d="M19 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
    <path d="M19 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
  </svg>
);

export const TableThreeDots = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="currentColor"
    className="bi bi-three-dots-vertical"
    viewBox="0 0 16 16"
  >
    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
  </svg>
);

export const TeamIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
  >
    <path
      d="M0.799988 9.1751C0.799988 8.85285 0.878113 8.55666 1.03436 8.28654C1.19061 8.01641 1.40624 7.8001 1.68124 7.6376C2.35624 7.2376 3.07186 6.93135 3.82811 6.71885C4.58436 6.50635 5.37499 6.4001 6.19999 6.4001C7.02499 6.4001 7.81561 6.50635 8.57186 6.71885C9.32811 6.93135 10.0437 7.2376 10.7187 7.6376C10.9937 7.8001 11.2094 8.01641 11.3656 8.28654C11.5219 8.55666 11.6 8.85285 11.6 9.1751V9.5501C11.6 9.92135 11.4677 10.2392 11.2032 10.5035C10.9387 10.7679 10.6207 10.9001 10.2492 10.9001H2.14474C1.77324 10.9001 1.45624 10.7679 1.19374 10.5035C0.931238 10.2392 0.799988 9.92135 0.799988 9.5501V9.1751ZM13.85 10.9001H12.5937C12.7062 10.6876 12.7937 10.4677 12.8562 10.2403C12.9187 10.013 12.95 9.78297 12.95 9.5501V9.1751C12.95 8.6501 12.8281 8.1626 12.5844 7.7126C12.3406 7.2626 12.0125 6.89385 11.6 6.60635C12.0875 6.70635 12.5594 6.84072 13.0156 7.00947C13.4719 7.17822 13.9062 7.3876 14.3187 7.6376C14.5937 7.8001 14.8094 8.01679 14.9656 8.28766C15.1219 8.55866 15.2 8.85447 15.2 9.1751V9.5501C15.2 9.92135 15.0678 10.2392 14.8034 10.5035C14.5391 10.7679 14.2212 10.9001 13.85 10.9001ZM6.19999 5.5001C5.44999 5.5001 4.81249 5.2376 4.28749 4.7126C3.76249 4.1876 3.49999 3.5501 3.49999 2.8001C3.49999 2.0501 3.76249 1.4126 4.28749 0.887598C4.81249 0.362598 5.44999 0.100098 6.19999 0.100098C6.94999 0.100098 7.58749 0.362598 8.11249 0.887598C8.63749 1.4126 8.89999 2.0501 8.89999 2.8001C8.89999 3.5501 8.63749 4.1876 8.11249 4.7126C7.58749 5.2376 6.94999 5.5001 6.19999 5.5001ZM12.5 2.8001C12.5 3.5501 12.2375 4.1876 11.7125 4.7126C11.1875 5.2376 10.55 5.5001 9.79999 5.5001C9.69999 5.5001 9.60624 5.49697 9.51874 5.49072C9.43124 5.48447 9.33749 5.46885 9.23749 5.44385C9.54999 5.08135 9.79686 4.67822 9.97811 4.23447C10.1594 3.79072 10.25 3.3126 10.25 2.8001C10.25 2.2876 10.1594 1.80947 9.97811 1.36572C9.79686 0.921973 9.54999 0.518848 9.23749 0.156348C9.33749 0.131348 9.43124 0.115723 9.51874 0.109473C9.60624 0.103223 9.69999 0.100098 9.79999 0.100098C10.55 0.100098 11.1875 0.362598 11.7125 0.887598C12.2375 1.4126 12.5 2.0501 12.5 2.8001ZM2.14999 9.5501H10.25V9.1751C10.25 9.09422 10.231 9.02072 10.1932 8.9546C10.1554 8.88835 10.1056 8.83685 10.0437 8.8001C9.45624 8.4626 8.83749 8.20322 8.18749 8.02197C7.53749 7.84072 6.87499 7.7501 6.19999 7.7501C5.52499 7.7501 4.86249 7.8376 4.21249 8.0126C3.56249 8.1876 2.94374 8.4501 2.35624 8.8001C2.29436 8.83547 2.24449 8.88491 2.20661 8.94841C2.16886 9.01204 2.14999 9.08704 2.14999 9.17341V9.5501ZM6.20393 4.1501C6.5763 4.1501 6.89374 4.01753 7.15624 3.75241C7.41874 3.48728 7.54999 3.16853 7.54999 2.79616C7.54999 2.42378 7.41743 2.10635 7.1523 1.84385C6.88718 1.58135 6.56843 1.4501 6.19605 1.4501C5.82368 1.4501 5.50624 1.58266 5.24374 1.84779C4.98124 2.11291 4.84999 2.43166 4.84999 2.80404C4.84999 3.17641 4.98255 3.49385 5.24767 3.75635C5.5128 4.01885 5.83155 4.1501 6.20393 4.1501Z"
      fill="#ABB9E8"
    />
  </svg>
);

export const PSPIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M3.5 6.75L7.625 0L11.75 6.75H3.5ZM11.75 15C10.8125 15 10.0156 14.6719 9.35938 14.0156C8.70312 13.3594 8.375 12.5625 8.375 11.625C8.375 10.6875 8.70312 9.89062 9.35938 9.23438C10.0156 8.57812 10.8125 8.25 11.75 8.25C12.6875 8.25 13.4844 8.57812 14.1406 9.23438C14.7969 9.89062 15.125 10.6875 15.125 11.625C15.125 12.5625 14.7969 13.3594 14.1406 14.0156C13.4844 14.6719 12.6875 15 11.75 15ZM0.875 14.625V8.625H6.875V14.625H0.875ZM11.75 13.5C12.275 13.5 12.7188 13.3187 13.0812 12.9562C13.4437 12.5938 13.625 12.15 13.625 11.625C13.625 11.1 13.4437 10.6562 13.0812 10.2938C12.7188 9.93125 12.275 9.75 11.75 9.75C11.225 9.75 10.7812 9.93125 10.4188 10.2938C10.0563 10.6562 9.875 11.1 9.875 11.625C9.875 12.15 10.0563 12.5938 10.4188 12.9562C10.7812 13.3187 11.225 13.5 11.75 13.5ZM2.375 13.125H5.375V10.125H2.375V13.125ZM6.1625 5.25H9.0875L7.625 2.8875L6.1625 5.25Z"
      fill="#ABB9E8"
    />
  </svg>
);

export const FillPSPIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M3.5 6.75L7.625 0L11.75 6.75H3.5ZM11.75 15C10.8125 15 10.0156 14.6719 9.35938 14.0156C8.70312 13.3594 8.375 12.5625 8.375 11.625C8.375 10.6875 8.70312 9.89062 9.35938 9.23438C10.0156 8.57812 10.8125 8.25 11.75 8.25C12.6875 8.25 13.4844 8.57812 14.1406 9.23438C14.7969 9.89062 15.125 10.6875 15.125 11.625C15.125 12.5625 14.7969 13.3594 14.1406 14.0156C13.4844 14.6719 12.6875 15 11.75 15ZM0.875 14.625V8.625H6.875V14.625H0.875ZM11.75 13.5C12.275 13.5 12.7188 13.3187 13.0812 12.9562C13.4437 12.5938 13.625 12.15 13.625 11.625C13.625 11.1 13.4437 10.6562 13.0812 10.2938C12.7188 9.93125 12.275 9.75 11.75 9.75C11.225 9.75 10.7812 9.93125 10.4188 10.2938C10.0563 10.6562 9.875 11.1 9.875 11.625C9.875 12.15 10.0563 12.5938 10.4188 12.9562C10.7812 13.3187 11.225 13.5 11.75 13.5ZM2.375 13.125H5.375V10.125H2.375V13.125ZM6.1625 5.25H9.0875L7.625 2.8875L6.1625 5.25Z"
      fill="#405189"
    />
  </svg>
);

export const AGIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <mask
      id="mask0_83_3108"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="15"
    >
      <rect x="0.5" width="15" height="15" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_83_3108)">
      <path
        d="M6.92188 7.5C6.63021 7.5 6.39062 7.39062 6.20312 7.17188C6.01562 6.95312 5.94792 6.69792 6 6.40625L6.1875 5.28125C6.27083 4.83333 6.48177 4.46615 6.82031 4.17969C7.15885 3.89323 7.55208 3.75 8 3.75C8.45833 3.75 8.85677 3.89323 9.19531 4.17969C9.53385 4.46615 9.74479 4.83333 9.82812 5.28125L10.0156 6.40625C10.0677 6.69792 10 6.95312 9.8125 7.17188C9.625 7.39062 9.38542 7.5 9.09375 7.5H6.92188ZM7.29688 6.25H8.71875L8.59375 5.48438C8.57292 5.33854 8.50521 5.22135 8.39062 5.13281C8.27604 5.04427 8.14583 5 8 5C7.85417 5 7.72656 5.04427 7.61719 5.13281C7.50781 5.22135 7.44271 5.33854 7.42188 5.48438L7.29688 6.25ZM2.4375 8.10938C2.19792 8.11979 1.99219 8.07292 1.82031 7.96875C1.64844 7.86458 1.53646 7.70312 1.48438 7.48438C1.46354 7.39062 1.45833 7.29688 1.46875 7.20312C1.47917 7.10938 1.50521 7.02083 1.54688 6.9375C1.54688 6.94792 1.54167 6.92708 1.53125 6.875C1.51042 6.85417 1.45833 6.72917 1.375 6.5C1.35417 6.375 1.36979 6.25521 1.42188 6.14062C1.47396 6.02604 1.54167 5.92708 1.625 5.84375L1.65625 5.8125C1.67708 5.61458 1.75781 5.44792 1.89844 5.3125C2.03906 5.17708 2.21354 5.10938 2.42188 5.10938C2.45312 5.10938 2.55208 5.13021 2.71875 5.17188L2.76562 5.15625C2.81771 5.10417 2.88542 5.0651 2.96875 5.03906C3.05208 5.01302 3.14062 5 3.23438 5C3.34896 5 3.45052 5.01823 3.53906 5.05469C3.6276 5.09115 3.69792 5.14583 3.75 5.21875C3.76042 5.21875 3.76823 5.22135 3.77344 5.22656C3.77865 5.23177 3.78646 5.23438 3.79688 5.23438C3.94271 5.24479 4.07031 5.28906 4.17969 5.36719C4.28906 5.44531 4.36979 5.55208 4.42188 5.6875C4.44271 5.76042 4.45052 5.83073 4.44531 5.89844C4.4401 5.96615 4.42708 6.03125 4.40625 6.09375C4.40625 6.10417 4.41146 6.125 4.42188 6.15625C4.49479 6.22917 4.55208 6.3099 4.59375 6.39844C4.63542 6.48698 4.65625 6.57812 4.65625 6.67188C4.65625 6.71354 4.625 6.82292 4.5625 7C4.55208 7.02083 4.55208 7.04167 4.5625 7.0625L4.59375 7.3125C4.59375 7.53125 4.5026 7.71875 4.32031 7.875C4.13802 8.03125 3.91667 8.10938 3.65625 8.10938H2.4375ZM13 8.125C12.6562 8.125 12.362 8.0026 12.1172 7.75781C11.8724 7.51302 11.75 7.21875 11.75 6.875C11.75 6.75 11.7682 6.63281 11.8047 6.52344C11.8411 6.41406 11.8906 6.30729 11.9531 6.20312L11.5156 5.8125C11.4115 5.72917 11.3932 5.625 11.4609 5.5C11.5286 5.375 11.625 5.3125 11.75 5.3125H13C13.3438 5.3125 13.638 5.4349 13.8828 5.67969C14.1276 5.92448 14.25 6.21875 14.25 6.5625V6.875C14.25 7.21875 14.1276 7.51302 13.8828 7.75781C13.638 8.0026 13.3438 8.125 13 8.125ZM0.5 11.25V10.2656C0.5 9.80729 0.731771 9.4401 1.19531 9.16406C1.65885 8.88802 2.26042 8.75 3 8.75C3.13542 8.75 3.26562 8.7526 3.39062 8.75781C3.51562 8.76302 3.63542 8.77604 3.75 8.79688C3.60417 9.00521 3.49479 9.22917 3.42188 9.46875C3.34896 9.70833 3.3125 9.96354 3.3125 10.2344V11.25H0.5ZM4.25 11.25V10.2344C4.25 9.55729 4.59635 9.01042 5.28906 8.59375C5.98177 8.17708 6.88542 7.96875 8 7.96875C9.125 7.96875 10.0312 8.17708 10.7188 8.59375C11.4062 9.01042 11.75 9.55729 11.75 10.2344V11.25H4.25ZM13 8.75C13.75 8.75 14.3542 8.88802 14.8125 9.16406C15.2708 9.4401 15.5 9.80729 15.5 10.2656V11.25H12.6875V10.2344C12.6875 9.96354 12.6536 9.70833 12.5859 9.46875C12.5182 9.22917 12.4167 9.00521 12.2812 8.79688C12.3958 8.77604 12.513 8.76302 12.6328 8.75781C12.7526 8.7526 12.875 8.75 13 8.75ZM8 9.21875C7.40625 9.21875 6.875 9.29688 6.40625 9.45312C5.9375 9.60938 5.66146 9.79167 5.57812 10H10.4375C10.3438 9.79167 10.0651 9.60938 9.60156 9.45312C9.13802 9.29688 8.60417 9.21875 8 9.21875Z"
        fill="#ABB9E8"
      />
    </g>
  </svg>
);

export const DownCarrot = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.18436 0.00112915L4.39998 3.21484L7.61561 0.00112915L8.59998 0.984918L4.39998 5.18242L0.199982 0.984918L1.18436 0.00112915Z"
      fill="#405189"
    />
  </svg>
);

export const UpCarrot = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.18436 5.99887L4.39998 2.78516L7.61561 5.99887L8.59998 5.01508L4.39998 0.817578L0.199982 5.01508L1.18436 5.99887Z"
      fill="#405189"
    />
  </svg>
);

export const RedBall = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="10"
      height="10"
      rx="5"
      fill="#EE5E99"
      stroke="white"
      stroke-width="2"
    />
  </svg>
);

export const DashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2"
    height="38"
    viewBox="0 0 2 38"
    fill="none"
  >
    <path d="M0.700012 0V38" stroke="#D9D9D9" />
  </svg>
);

export const TimeLineIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.64 2.30001C9.94 2.30001 11.15 2.63001 12.27 3.29001C13.36 3.92001 14.22 4.78001 14.85 5.87001C15.51 6.99001 15.84 8.20001 15.84 9.50001C15.84 10.8 15.51 12.01 14.85 13.13C14.22 14.22 13.36 15.08 12.27 15.71C11.15 16.37 9.94 16.7 8.64 16.7C7.34 16.7 6.13 16.37 5.01 15.71C3.92 15.08 3.06 14.22 2.43 13.13C1.77 12.01 1.44 10.8 1.44 9.50001C1.44 8.20001 1.77 6.99001 2.43 5.87001C3.06 4.78001 3.92 3.92001 5.01 3.29001C6.13 2.63001 7.34 2.30001 8.64 2.30001ZM8.64 3.74001C7.6 3.74001 6.63 4.00001 5.73 4.52001C4.86 5.03001 4.17 5.72001 3.66 6.59001C3.14 7.49001 2.88 8.46001 2.88 9.50001C2.88 10.54 3.14 11.51 3.66 12.41C4.17 13.28 4.86 13.97 5.73 14.48C6.63 15 7.6 15.26 8.64 15.26C9.68 15.26 10.65 15 11.55 14.48C12.42 13.97 13.11 13.28 13.62 12.41C14.14 11.51 14.4 10.54 14.4 9.50001C14.4 8.46001 14.14 7.49001 13.62 6.59001C13.11 5.72001 12.42 5.03001 11.55 4.52001C10.65 4.00001 9.68 3.74001 8.64 3.74001ZM8.64 4.46001C9.36 4.46001 10.045 4.60501 10.695 4.89501L9.57 6.02001C9.27 5.94001 8.96 5.90001 8.64 5.90001C7.99 5.90001 7.39 6.06251 6.84 6.38751C6.29 6.71251 5.8525 7.15001 5.5275 7.70001C5.2025 8.25001 5.04 8.85001 5.04 9.50001C5.04 9.99001 5.1325 10.4525 5.3175 10.8875C5.5025 11.3225 5.76 11.71 6.09 12.05L5.07 13.07L4.965 12.95C4.535 12.49 4.2 11.97 3.96 11.39C3.72 10.79 3.6 10.16 3.6 9.50001C3.6 8.59001 3.83 7.74001 4.29 6.95001C4.73 6.19001 5.33 5.59001 6.09 5.15001C6.88 4.69001 7.73 4.46001 8.64 4.46001ZM13.245 7.44501C13.535 8.09501 13.68 8.78001 13.68 9.50001C13.68 10.18 13.55 10.835 13.29 11.465C13.03 12.065 12.67 12.6 12.21 13.07L11.19 12.05C11.52 11.71 11.7775 11.3225 11.9625 10.8875C12.1475 10.4525 12.24 9.99001 12.24 9.50001C12.24 9.18001 12.2 8.87001 12.12 8.57001L13.245 7.44501ZM11.7 5.42001L12.72 6.44001L10.035 9.12501C10.065 9.24501 10.08 9.37001 10.08 9.50001C10.08 9.90001 9.94 10.24 9.66 10.52C9.38 10.8 9.04 10.94 8.64 10.94C8.24 10.94 7.9 10.8 7.62 10.52C7.34 10.24 7.2 9.90001 7.2 9.50001C7.2 9.10001 7.34 8.76001 7.62 8.48001C7.9 8.20001 8.24 8.06001 8.64 8.06001C8.77 8.06001 8.895 8.07501 9.015 8.10501L11.7 5.42001Z"
      fill="#405189"
    />
  </svg>
);

export const GreyTimeLineIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.64 0.299997C8.94 0.299997 10.15 0.629997 11.27 1.29C12.36 1.92 13.22 2.78 13.85 3.87C14.51 4.99 14.84 6.2 14.84 7.5C14.84 8.8 14.51 10.01 13.85 11.13C13.22 12.22 12.36 13.08 11.27 13.71C10.15 14.37 8.94 14.7 7.64 14.7C6.34 14.7 5.13 14.37 4.01 13.71C2.92 13.08 2.06 12.22 1.43 11.13C0.770002 10.01 0.440002 8.8 0.440002 7.5C0.440002 6.2 0.770002 4.99 1.43 3.87C2.06 2.78 2.92 1.92 4.01 1.29C5.13 0.629997 6.34 0.299997 7.64 0.299997ZM7.64 1.74C6.6 1.74 5.63 2 4.73 2.52C3.86 3.03 3.17 3.72 2.66 4.59C2.14 5.49 1.88 6.46 1.88 7.5C1.88 8.54 2.14 9.51 2.66 10.41C3.17 11.28 3.86 11.97 4.73 12.48C5.63 13 6.6 13.26 7.64 13.26C8.68 13.26 9.65 13 10.55 12.48C11.42 11.97 12.11 11.28 12.62 10.41C13.14 9.51 13.4 8.54 13.4 7.5C13.4 6.46 13.14 5.49 12.62 4.59C12.11 3.72 11.42 3.03 10.55 2.52C9.65 2 8.68 1.74 7.64 1.74ZM7.64 2.46C8.36 2.46 9.045 2.605 9.695 2.895L8.57 4.02C8.27 3.94 7.96 3.9 7.64 3.9C6.99 3.9 6.39 4.0625 5.84 4.3875C5.29 4.7125 4.8525 5.15 4.5275 5.7C4.2025 6.25 4.04 6.85 4.04 7.5C4.04 7.99 4.1325 8.4525 4.3175 8.8875C4.5025 9.3225 4.76 9.71 5.09 10.05L4.07 11.07L3.965 10.95C3.535 10.49 3.2 9.97 2.96 9.39C2.72 8.79 2.6 8.16 2.6 7.5C2.6 6.59 2.83 5.74 3.29 4.95C3.73 4.19 4.33 3.59 5.09 3.15C5.88 2.69 6.73 2.46 7.64 2.46ZM12.245 5.445C12.535 6.095 12.68 6.78 12.68 7.5C12.68 8.18 12.55 8.835 12.29 9.465C12.03 10.065 11.67 10.6 11.21 11.07L10.19 10.05C10.52 9.71 10.7775 9.3225 10.9625 8.8875C11.1475 8.4525 11.24 7.99 11.24 7.5C11.24 7.18 11.2 6.87 11.12 6.57L12.245 5.445ZM10.7 3.42L11.72 4.44L9.035 7.125C9.065 7.245 9.08 7.37 9.08 7.5C9.08 7.9 8.94 8.24 8.66 8.52C8.38 8.8 8.04 8.94 7.64 8.94C7.24 8.94 6.9 8.8 6.62 8.52C6.34 8.24 6.2 7.9 6.2 7.5C6.2 7.1 6.34 6.76 6.62 6.48C6.9 6.2 7.24 6.06 7.64 6.06C7.77 6.06 7.895 6.075 8.015 6.105L10.7 3.42Z"
      fill="#ABB9E8"
    />
  </svg>
);

export const FillTeamIcon = () => (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.799988 9.17498C0.799988 8.85273 0.878113 8.55654 1.03436 8.28641C1.19061 8.01629 1.40624 7.79998 1.68124 7.63748C2.35624 7.23748 3.07186 6.93123 3.82811 6.71873C4.58436 6.50623 5.37499 6.39998 6.19999 6.39998C7.02499 6.39998 7.81561 6.50623 8.57186 6.71873C9.32811 6.93123 10.0437 7.23748 10.7187 7.63748C10.9937 7.79998 11.2094 8.01629 11.3656 8.28641C11.5219 8.55654 11.6 8.85273 11.6 9.17498V9.54998C11.6 9.92123 11.4677 10.239 11.2032 10.5034C10.9387 10.7678 10.6207 10.9 10.2492 10.9H2.14474C1.77324 10.9 1.45624 10.7678 1.19374 10.5034C0.931238 10.239 0.799988 9.92123 0.799988 9.54998V9.17498ZM13.85 10.9H12.5937C12.7062 10.6875 12.7937 10.4675 12.8562 10.2402C12.9187 10.0129 12.95 9.78285 12.95 9.54998V9.17498C12.95 8.64998 12.8281 8.16248 12.5844 7.71248C12.3406 7.26248 12.0125 6.89373 11.6 6.60623C12.0875 6.70623 12.5594 6.8406 13.0156 7.00935C13.4719 7.1781 13.9062 7.38748 14.3187 7.63748C14.5937 7.79998 14.8094 8.01666 14.9656 8.28754C15.1219 8.55854 15.2 8.85435 15.2 9.17498V9.54998C15.2 9.92123 15.0678 10.239 14.8034 10.5034C14.5391 10.7678 14.2212 10.9 13.85 10.9ZM6.19999 5.49998C5.44999 5.49998 4.81249 5.23748 4.28749 4.71248C3.76249 4.18748 3.49999 3.54998 3.49999 2.79998C3.49999 2.04998 3.76249 1.41248 4.28749 0.887476C4.81249 0.362476 5.44999 0.0999756 6.19999 0.0999756C6.94999 0.0999756 7.58749 0.362476 8.11249 0.887476C8.63749 1.41248 8.89999 2.04998 8.89999 2.79998C8.89999 3.54998 8.63749 4.18748 8.11249 4.71248C7.58749 5.23748 6.94999 5.49998 6.19999 5.49998ZM12.5 2.79998C12.5 3.54998 12.2375 4.18748 11.7125 4.71248C11.1875 5.23748 10.55 5.49998 9.79999 5.49998C9.69999 5.49998 9.60624 5.49685 9.51874 5.4906C9.43124 5.48435 9.33749 5.46873 9.23749 5.44373C9.54999 5.08123 9.79686 4.6781 9.97811 4.23435C10.1594 3.7906 10.25 3.31248 10.25 2.79998C10.25 2.28748 10.1594 1.80935 9.97811 1.3656C9.79686 0.921851 9.54999 0.518726 9.23749 0.156226C9.33749 0.131226 9.43124 0.115601 9.51874 0.109351C9.60624 0.103101 9.69999 0.0999756 9.79999 0.0999756C10.55 0.0999756 11.1875 0.362476 11.7125 0.887476C12.2375 1.41248 12.5 2.04998 12.5 2.79998ZM2.14999 9.54998H10.25V9.17498C10.25 9.0941 10.231 9.0206 10.1932 8.95448C10.1554 8.88823 10.1056 8.83673 10.0437 8.79998C9.45624 8.46248 8.83749 8.2031 8.18749 8.02185C7.53749 7.8406 6.87499 7.74998 6.19999 7.74998C5.52499 7.74998 4.86249 7.83748 4.21249 8.01248C3.56249 8.18748 2.94374 8.44998 2.35624 8.79998C2.29436 8.83535 2.24449 8.88479 2.20661 8.94829C2.16886 9.01191 2.14999 9.08691 2.14999 9.17329V9.54998ZM6.20393 4.14998C6.5763 4.14998 6.89374 4.01741 7.15624 3.75229C7.41874 3.48716 7.54999 3.16841 7.54999 2.79604C7.54999 2.42366 7.41743 2.10623 7.1523 1.84373C6.88718 1.58123 6.56843 1.44998 6.19605 1.44998C5.82368 1.44998 5.50624 1.58254 5.24374 1.84766C4.98124 2.11279 4.84999 2.43154 4.84999 2.80391C4.84999 3.17629 4.98255 3.49373 5.24767 3.75623C5.5128 4.01873 5.83155 4.14998 6.20393 4.14998Z"
      fill="#405189"
    />
  </svg>
);

export const FillAGIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <mask
      id="mask0_198_864"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="15"
    >
      <rect x="0.5" width="15" height="15" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_198_864)">
      <path
        d="M6.92188 7.5C6.63021 7.5 6.39062 7.39062 6.20312 7.17188C6.01562 6.95312 5.94792 6.69792 6 6.40625L6.1875 5.28125C6.27083 4.83333 6.48177 4.46615 6.82031 4.17969C7.15885 3.89323 7.55208 3.75 8 3.75C8.45833 3.75 8.85677 3.89323 9.19531 4.17969C9.53385 4.46615 9.74479 4.83333 9.82812 5.28125L10.0156 6.40625C10.0677 6.69792 10 6.95312 9.8125 7.17188C9.625 7.39062 9.38542 7.5 9.09375 7.5H6.92188ZM7.29688 6.25H8.71875L8.59375 5.48438C8.57292 5.33854 8.50521 5.22135 8.39062 5.13281C8.27604 5.04427 8.14583 5 8 5C7.85417 5 7.72656 5.04427 7.61719 5.13281C7.50781 5.22135 7.44271 5.33854 7.42188 5.48438L7.29688 6.25ZM2.4375 8.10938C2.19792 8.11979 1.99219 8.07292 1.82031 7.96875C1.64844 7.86458 1.53646 7.70312 1.48438 7.48438C1.46354 7.39062 1.45833 7.29688 1.46875 7.20312C1.47917 7.10938 1.50521 7.02083 1.54688 6.9375C1.54688 6.94792 1.54167 6.92708 1.53125 6.875C1.51042 6.85417 1.45833 6.72917 1.375 6.5C1.35417 6.375 1.36979 6.25521 1.42188 6.14062C1.47396 6.02604 1.54167 5.92708 1.625 5.84375L1.65625 5.8125C1.67708 5.61458 1.75781 5.44792 1.89844 5.3125C2.03906 5.17708 2.21354 5.10938 2.42188 5.10938C2.45312 5.10938 2.55208 5.13021 2.71875 5.17188L2.76562 5.15625C2.81771 5.10417 2.88542 5.0651 2.96875 5.03906C3.05208 5.01302 3.14062 5 3.23438 5C3.34896 5 3.45052 5.01823 3.53906 5.05469C3.6276 5.09115 3.69792 5.14583 3.75 5.21875C3.76042 5.21875 3.76823 5.22135 3.77344 5.22656C3.77865 5.23177 3.78646 5.23438 3.79688 5.23438C3.94271 5.24479 4.07031 5.28906 4.17969 5.36719C4.28906 5.44531 4.36979 5.55208 4.42188 5.6875C4.44271 5.76042 4.45052 5.83073 4.44531 5.89844C4.4401 5.96615 4.42708 6.03125 4.40625 6.09375C4.40625 6.10417 4.41146 6.125 4.42188 6.15625C4.49479 6.22917 4.55208 6.3099 4.59375 6.39844C4.63542 6.48698 4.65625 6.57812 4.65625 6.67188C4.65625 6.71354 4.625 6.82292 4.5625 7C4.55208 7.02083 4.55208 7.04167 4.5625 7.0625L4.59375 7.3125C4.59375 7.53125 4.5026 7.71875 4.32031 7.875C4.13802 8.03125 3.91667 8.10938 3.65625 8.10938H2.4375ZM13 8.125C12.6562 8.125 12.362 8.0026 12.1172 7.75781C11.8724 7.51302 11.75 7.21875 11.75 6.875C11.75 6.75 11.7682 6.63281 11.8047 6.52344C11.8411 6.41406 11.8906 6.30729 11.9531 6.20312L11.5156 5.8125C11.4115 5.72917 11.3932 5.625 11.4609 5.5C11.5286 5.375 11.625 5.3125 11.75 5.3125H13C13.3438 5.3125 13.638 5.4349 13.8828 5.67969C14.1276 5.92448 14.25 6.21875 14.25 6.5625V6.875C14.25 7.21875 14.1276 7.51302 13.8828 7.75781C13.638 8.0026 13.3438 8.125 13 8.125ZM0.5 11.25V10.2656C0.5 9.80729 0.731771 9.4401 1.19531 9.16406C1.65885 8.88802 2.26042 8.75 3 8.75C3.13542 8.75 3.26562 8.7526 3.39062 8.75781C3.51562 8.76302 3.63542 8.77604 3.75 8.79688C3.60417 9.00521 3.49479 9.22917 3.42188 9.46875C3.34896 9.70833 3.3125 9.96354 3.3125 10.2344V11.25H0.5ZM4.25 11.25V10.2344C4.25 9.55729 4.59635 9.01042 5.28906 8.59375C5.98177 8.17708 6.88542 7.96875 8 7.96875C9.125 7.96875 10.0312 8.17708 10.7188 8.59375C11.4062 9.01042 11.75 9.55729 11.75 10.2344V11.25H4.25ZM13 8.75C13.75 8.75 14.3542 8.88802 14.8125 9.16406C15.2708 9.4401 15.5 9.80729 15.5 10.2656V11.25H12.6875V10.2344C12.6875 9.96354 12.6536 9.70833 12.5859 9.46875C12.5182 9.22917 12.4167 9.00521 12.2812 8.79688C12.3958 8.77604 12.513 8.76302 12.6328 8.75781C12.7526 8.7526 12.875 8.75 13 8.75ZM8 9.21875C7.40625 9.21875 6.875 9.29688 6.40625 9.45312C5.9375 9.60938 5.66146 9.79167 5.57812 10H10.4375C10.3438 9.79167 10.0651 9.60938 9.60156 9.45312C9.13802 9.29688 8.60417 9.21875 8 9.21875Z"
        fill="#405189"
      />
    </g>
  </svg>
);

export const HubIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M5.39997 9.13984C4.80997 9.13984 4.26747 8.99484 3.77247 8.70484C3.27747 8.41484 2.88497 8.02234 2.59497 7.52734C2.30497 7.03234 2.15997 6.48984 2.15997 5.89984C2.15997 5.30984 2.30497 4.76734 2.59497 4.27234C2.88497 3.77734 3.27747 3.38484 3.77247 3.09484C4.26747 2.80484 4.80997 2.65984 5.39997 2.65984C5.98997 2.65984 6.53247 2.80484 7.02747 3.09484C7.52247 3.38484 7.91497 3.77734 8.20497 4.27234C8.49497 4.76734 8.63997 5.30984 8.63997 5.89984C8.63997 6.48984 8.49497 7.03234 8.20497 7.52734C7.91497 8.02234 7.52247 8.41484 7.02747 8.70484C6.53247 8.99484 5.98997 9.13984 5.39997 9.13984ZM5.39997 16.3398C4.80997 16.3398 4.26747 16.1948 3.77247 15.9048C3.27747 15.6148 2.88497 15.2223 2.59497 14.7273C2.30497 14.2323 2.15997 13.6898 2.15997 13.0998C2.15997 12.5098 2.30497 11.9673 2.59497 11.4723C2.88497 10.9773 3.27747 10.5848 3.77247 10.2948C4.26747 10.0048 4.80997 9.85984 5.39997 9.85984C5.98997 9.85984 6.53247 10.0048 7.02747 10.2948C7.52247 10.5848 7.91497 10.9773 8.20497 11.4723C8.49497 11.9673 8.63997 12.5098 8.63997 13.0998C8.63997 13.6898 8.49497 14.2323 8.20497 14.7273C7.91497 15.2223 7.52247 15.6148 7.02747 15.9048C6.53247 16.1948 5.98997 16.3398 5.39997 16.3398ZM12.6 9.13984C12.01 9.13984 11.4675 8.99484 10.9725 8.70484C10.4775 8.41484 10.085 8.02234 9.79497 7.52734C9.50497 7.03234 9.35997 6.48984 9.35997 5.89984C9.35997 5.30984 9.50497 4.76734 9.79497 4.27234C10.085 3.77734 10.4775 3.38484 10.9725 3.09484C11.4675 2.80484 12.01 2.65984 12.6 2.65984C13.19 2.65984 13.7325 2.80484 14.2275 3.09484C14.7225 3.38484 15.115 3.77734 15.405 4.27234C15.695 4.76734 15.84 5.30984 15.84 5.89984C15.84 6.48984 15.695 7.03234 15.405 7.52734C15.115 8.02234 14.7225 8.41484 14.2275 8.70484C13.7325 8.99484 13.19 9.13984 12.6 9.13984ZM12.6 16.3398C12.01 16.3398 11.4675 16.1948 10.9725 15.9048C10.4775 15.6148 10.085 15.2223 9.79497 14.7273C9.50497 14.2323 9.35997 13.6898 9.35997 13.0998C9.35997 12.5098 9.50497 11.9673 9.79497 11.4723C10.085 10.9773 10.4775 10.5848 10.9725 10.2948C11.4675 10.0048 12.01 9.85984 12.6 9.85984C13.19 9.85984 13.7325 10.0048 14.2275 10.2948C14.7225 10.5848 15.115 10.9773 15.405 11.4723C15.695 11.9673 15.84 12.5098 15.84 13.0998C15.84 13.6898 15.695 14.2323 15.405 14.7273C15.115 15.2223 14.7225 15.6148 14.2275 15.9048C13.7325 16.1948 13.19 16.3398 12.6 16.3398ZM5.39997 7.69984C5.72997 7.69984 6.03247 7.61984 6.30747 7.45984C6.58247 7.29984 6.79997 7.08234 6.95997 6.80734C7.11997 6.53234 7.19997 6.22984 7.19997 5.89984C7.19997 5.56984 7.11997 5.26734 6.95997 4.99234C6.79997 4.71734 6.58247 4.49984 6.30747 4.33984C6.03247 4.17984 5.72997 4.09984 5.39997 4.09984C5.06997 4.09984 4.76747 4.17984 4.49247 4.33984C4.21747 4.49984 3.99997 4.71734 3.83997 4.99234C3.67997 5.26734 3.59997 5.56984 3.59997 5.89984C3.59997 6.22984 3.67997 6.53234 3.83997 6.80734C3.99997 7.08234 4.21747 7.29984 4.49247 7.45984C4.76747 7.61984 5.06997 7.69984 5.39997 7.69984ZM5.39997 14.8998C5.72997 14.8998 6.03247 14.8198 6.30747 14.6598C6.58247 14.4998 6.79997 14.2823 6.95997 14.0073C7.11997 13.7323 7.19997 13.4298 7.19997 13.0998C7.19997 12.7698 7.11997 12.4673 6.95997 12.1923C6.79997 11.9173 6.58247 11.6998 6.30747 11.5398C6.03247 11.3798 5.72997 11.2998 5.39997 11.2998C5.06997 11.2998 4.76747 11.3798 4.49247 11.5398C4.21747 11.6998 3.99997 11.9173 3.83997 12.1923C3.67997 12.4673 3.59997 12.7698 3.59997 13.0998C3.59997 13.4298 3.67997 13.7323 3.83997 14.0073C3.99997 14.2823 4.21747 14.4998 4.49247 14.6598C4.76747 14.8198 5.06997 14.8998 5.39997 14.8998ZM12.6 7.69984C12.93 7.69984 13.2325 7.61984 13.5075 7.45984C13.7825 7.29984 14 7.08234 14.16 6.80734C14.32 6.53234 14.4 6.22984 14.4 5.89984C14.4 5.56984 14.32 5.26734 14.16 4.99234C14 4.71734 13.7825 4.49984 13.5075 4.33984C13.2325 4.17984 12.93 4.09984 12.6 4.09984C12.27 4.09984 11.9675 4.17984 11.6925 4.33984C11.4175 4.49984 11.2 4.71734 11.04 4.99234C10.88 5.26734 10.8 5.56984 10.8 5.89984C10.8 6.22984 10.88 6.53234 11.04 6.80734C11.2 7.08234 11.4175 7.29984 11.6925 7.45984C11.9675 7.61984 12.27 7.69984 12.6 7.69984ZM12.6 14.8998C12.93 14.8998 13.2325 14.8198 13.5075 14.6598C13.7825 14.4998 14 14.2823 14.16 14.0073C14.32 13.7323 14.4 13.4298 14.4 13.0998C14.4 12.7698 14.32 12.4673 14.16 12.1923C14 11.9173 13.7825 11.6998 13.5075 11.5398C13.2325 11.3798 12.93 11.2998 12.6 11.2998C12.27 11.2998 11.9675 11.3798 11.6925 11.5398C11.4175 11.6998 11.2 11.9173 11.04 12.1923C10.88 12.4673 10.8 12.7698 10.8 13.0998C10.8 13.4298 10.88 13.7323 11.04 14.0073C11.2 14.2823 11.4175 14.4998 11.6925 14.6598C11.9675 14.8198 12.27 14.8998 12.6 14.8998Z"
      fill="#ABB9E8"
    />
  </svg>
);

export const FillHubIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M5.39997 9.13984C4.80997 9.13984 4.26747 8.99484 3.77247 8.70484C3.27747 8.41484 2.88497 8.02234 2.59497 7.52734C2.30497 7.03234 2.15997 6.48984 2.15997 5.89984C2.15997 5.30984 2.30497 4.76734 2.59497 4.27234C2.88497 3.77734 3.27747 3.38484 3.77247 3.09484C4.26747 2.80484 4.80997 2.65984 5.39997 2.65984C5.98997 2.65984 6.53247 2.80484 7.02747 3.09484C7.52247 3.38484 7.91497 3.77734 8.20497 4.27234C8.49497 4.76734 8.63997 5.30984 8.63997 5.89984C8.63997 6.48984 8.49497 7.03234 8.20497 7.52734C7.91497 8.02234 7.52247 8.41484 7.02747 8.70484C6.53247 8.99484 5.98997 9.13984 5.39997 9.13984ZM5.39997 16.3398C4.80997 16.3398 4.26747 16.1948 3.77247 15.9048C3.27747 15.6148 2.88497 15.2223 2.59497 14.7273C2.30497 14.2323 2.15997 13.6898 2.15997 13.0998C2.15997 12.5098 2.30497 11.9673 2.59497 11.4723C2.88497 10.9773 3.27747 10.5848 3.77247 10.2948C4.26747 10.0048 4.80997 9.85984 5.39997 9.85984C5.98997 9.85984 6.53247 10.0048 7.02747 10.2948C7.52247 10.5848 7.91497 10.9773 8.20497 11.4723C8.49497 11.9673 8.63997 12.5098 8.63997 13.0998C8.63997 13.6898 8.49497 14.2323 8.20497 14.7273C7.91497 15.2223 7.52247 15.6148 7.02747 15.9048C6.53247 16.1948 5.98997 16.3398 5.39997 16.3398ZM12.6 9.13984C12.01 9.13984 11.4675 8.99484 10.9725 8.70484C10.4775 8.41484 10.085 8.02234 9.79497 7.52734C9.50497 7.03234 9.35997 6.48984 9.35997 5.89984C9.35997 5.30984 9.50497 4.76734 9.79497 4.27234C10.085 3.77734 10.4775 3.38484 10.9725 3.09484C11.4675 2.80484 12.01 2.65984 12.6 2.65984C13.19 2.65984 13.7325 2.80484 14.2275 3.09484C14.7225 3.38484 15.115 3.77734 15.405 4.27234C15.695 4.76734 15.84 5.30984 15.84 5.89984C15.84 6.48984 15.695 7.03234 15.405 7.52734C15.115 8.02234 14.7225 8.41484 14.2275 8.70484C13.7325 8.99484 13.19 9.13984 12.6 9.13984ZM12.6 16.3398C12.01 16.3398 11.4675 16.1948 10.9725 15.9048C10.4775 15.6148 10.085 15.2223 9.79497 14.7273C9.50497 14.2323 9.35997 13.6898 9.35997 13.0998C9.35997 12.5098 9.50497 11.9673 9.79497 11.4723C10.085 10.9773 10.4775 10.5848 10.9725 10.2948C11.4675 10.0048 12.01 9.85984 12.6 9.85984C13.19 9.85984 13.7325 10.0048 14.2275 10.2948C14.7225 10.5848 15.115 10.9773 15.405 11.4723C15.695 11.9673 15.84 12.5098 15.84 13.0998C15.84 13.6898 15.695 14.2323 15.405 14.7273C15.115 15.2223 14.7225 15.6148 14.2275 15.9048C13.7325 16.1948 13.19 16.3398 12.6 16.3398ZM5.39997 7.69984C5.72997 7.69984 6.03247 7.61984 6.30747 7.45984C6.58247 7.29984 6.79997 7.08234 6.95997 6.80734C7.11997 6.53234 7.19997 6.22984 7.19997 5.89984C7.19997 5.56984 7.11997 5.26734 6.95997 4.99234C6.79997 4.71734 6.58247 4.49984 6.30747 4.33984C6.03247 4.17984 5.72997 4.09984 5.39997 4.09984C5.06997 4.09984 4.76747 4.17984 4.49247 4.33984C4.21747 4.49984 3.99997 4.71734 3.83997 4.99234C3.67997 5.26734 3.59997 5.56984 3.59997 5.89984C3.59997 6.22984 3.67997 6.53234 3.83997 6.80734C3.99997 7.08234 4.21747 7.29984 4.49247 7.45984C4.76747 7.61984 5.06997 7.69984 5.39997 7.69984ZM5.39997 14.8998C5.72997 14.8998 6.03247 14.8198 6.30747 14.6598C6.58247 14.4998 6.79997 14.2823 6.95997 14.0073C7.11997 13.7323 7.19997 13.4298 7.19997 13.0998C7.19997 12.7698 7.11997 12.4673 6.95997 12.1923C6.79997 11.9173 6.58247 11.6998 6.30747 11.5398C6.03247 11.3798 5.72997 11.2998 5.39997 11.2998C5.06997 11.2998 4.76747 11.3798 4.49247 11.5398C4.21747 11.6998 3.99997 11.9173 3.83997 12.1923C3.67997 12.4673 3.59997 12.7698 3.59997 13.0998C3.59997 13.4298 3.67997 13.7323 3.83997 14.0073C3.99997 14.2823 4.21747 14.4998 4.49247 14.6598C4.76747 14.8198 5.06997 14.8998 5.39997 14.8998ZM12.6 7.69984C12.93 7.69984 13.2325 7.61984 13.5075 7.45984C13.7825 7.29984 14 7.08234 14.16 6.80734C14.32 6.53234 14.4 6.22984 14.4 5.89984C14.4 5.56984 14.32 5.26734 14.16 4.99234C14 4.71734 13.7825 4.49984 13.5075 4.33984C13.2325 4.17984 12.93 4.09984 12.6 4.09984C12.27 4.09984 11.9675 4.17984 11.6925 4.33984C11.4175 4.49984 11.2 4.71734 11.04 4.99234C10.88 5.26734 10.8 5.56984 10.8 5.89984C10.8 6.22984 10.88 6.53234 11.04 6.80734C11.2 7.08234 11.4175 7.29984 11.6925 7.45984C11.9675 7.61984 12.27 7.69984 12.6 7.69984ZM12.6 14.8998C12.93 14.8998 13.2325 14.8198 13.5075 14.6598C13.7825 14.4998 14 14.2823 14.16 14.0073C14.32 13.7323 14.4 13.4298 14.4 13.0998C14.4 12.7698 14.32 12.4673 14.16 12.1923C14 11.9173 13.7825 11.6998 13.5075 11.5398C13.2325 11.3798 12.93 11.2998 12.6 11.2998C12.27 11.2998 11.9675 11.3798 11.6925 11.5398C11.4175 11.6998 11.2 11.9173 11.04 12.1923C10.88 12.4673 10.8 12.7698 10.8 13.0998C10.8 13.4298 10.88 13.7323 11.04 14.0073C11.2 14.2823 11.4175 14.4998 11.6925 14.6598C11.9675 14.8198 12.27 14.8998 12.6 14.8998Z"
      fill="#405189"
    />
  </svg>
);

export const OrgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <mask
      id="mask0_198_835"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="19"
    >
      <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_198_835)">
      <path
        d="M1.79999 15.8004V3.65039H8.99999V6.35039H16.2V15.8004H1.79999ZM3.14999 14.4504H7.64999V13.1004H3.14999V14.4504ZM3.14999 11.7504H7.64999V10.4004H3.14999V11.7504ZM3.14999 9.05039H7.64999V7.70039H3.14999V9.05039ZM3.14999 6.35039H7.64999V5.00039H3.14999V6.35039ZM8.99999 14.4504H14.85V7.70039H8.99999V14.4504ZM10.35 10.4004V9.05039H13.5V10.4004H10.35ZM10.35 13.1004V11.7504H13.5V13.1004H10.35Z"
        fill="#ABB9E8"
      />
    </g>
  </svg>
);

export const FillOrgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <mask
      id="mask0_198_835"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="19"
    >
      <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_198_835)">
      <path
        d="M1.79999 15.8004V3.65039H8.99999V6.35039H16.2V15.8004H1.79999ZM3.14999 14.4504H7.64999V13.1004H3.14999V14.4504ZM3.14999 11.7504H7.64999V10.4004H3.14999V11.7504ZM3.14999 9.05039H7.64999V7.70039H3.14999V9.05039ZM3.14999 6.35039H7.64999V5.00039H3.14999V6.35039ZM8.99999 14.4504H14.85V7.70039H8.99999V14.4504ZM10.35 10.4004V9.05039H13.5V10.4004H10.35ZM10.35 13.1004V11.7504H13.5V13.1004H10.35Z"
        fill="#405189"
      />
    </g>
  </svg>
);

export const ProdIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M3.04999 14.6998C2.67874 14.6998 2.36093 14.5676 2.09655 14.3032C1.83218 14.0389 1.69999 13.7211 1.69999 13.3498V5.6248C1.43749 5.5248 1.22186 5.35918 1.05311 5.12793C0.884363 4.89668 0.799988 4.6373 0.799988 4.3498V1.6498C0.799988 1.27855 0.932175 0.960743 1.19655 0.696368C1.46093 0.431993 1.77874 0.299805 2.14999 0.299805H13.85C14.2212 0.299805 14.5391 0.431993 14.8034 0.696368C15.0678 0.960743 15.2 1.27855 15.2 1.6498V4.3498C15.2 4.6373 15.1156 4.89668 14.9469 5.12793C14.7781 5.35918 14.5625 5.5248 14.3 5.6248V13.3472C14.3 13.7239 14.1678 14.0436 13.9034 14.3061C13.639 14.5686 13.3212 14.6998 12.95 14.6998H3.04999ZM3.04999 5.6998V13.3498H12.95V5.6998H3.04999ZM2.14999 4.3498H13.85V1.6498H2.14999V4.3498ZM6.19999 8.8498H9.79999V7.4998H6.19999V8.8498Z"
      fill="#ABB9E8"
    />
  </svg>
);

export const FillProdIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M3.04999 14.6998C2.67874 14.6998 2.36093 14.5676 2.09655 14.3032C1.83218 14.0389 1.69999 13.7211 1.69999 13.3498V5.6248C1.43749 5.5248 1.22186 5.35918 1.05311 5.12793C0.884363 4.89668 0.799988 4.6373 0.799988 4.3498V1.6498C0.799988 1.27855 0.932175 0.960743 1.19655 0.696368C1.46093 0.431993 1.77874 0.299805 2.14999 0.299805H13.85C14.2212 0.299805 14.5391 0.431993 14.8034 0.696368C15.0678 0.960743 15.2 1.27855 15.2 1.6498V4.3498C15.2 4.6373 15.1156 4.89668 14.9469 5.12793C14.7781 5.35918 14.5625 5.5248 14.3 5.6248V13.3472C14.3 13.7239 14.1678 14.0436 13.9034 14.3061C13.639 14.5686 13.3212 14.6998 12.95 14.6998H3.04999ZM3.04999 5.6998V13.3498H12.95V5.6998H3.04999ZM2.14999 4.3498H13.85V1.6498H2.14999V4.3498ZM6.19999 8.8498H9.79999V7.4998H6.19999V8.8498Z"
      fill="#405189"
    />
  </svg>
);

export const PGIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
  >
    <path
      d="M10.7187 11.1251L10.1187 11.3126C9.98124 11.3501 9.85143 11.3435 9.7293 11.2929C9.6073 11.2423 9.51211 11.1613 9.44374 11.0501L9.31249 10.8063C9.24999 10.6938 9.22499 10.5751 9.23749 10.4501C9.24999 10.3251 9.30624 10.2126 9.40624 10.1126L9.85624 9.6626C9.81874 9.4876 9.79999 9.30635 9.79999 9.11885C9.79999 8.93135 9.81874 8.7501 9.85624 8.5751L9.40624 8.1626C9.30624 8.0626 9.24999 7.9501 9.23749 7.8251C9.22499 7.7001 9.25105 7.57247 9.31568 7.44222L9.44055 7.19791C9.50518 7.07854 9.59999 6.99697 9.72499 6.95322C9.84999 6.90947 9.98124 6.90635 10.1187 6.94385L10.7 7.09385C10.8375 6.95635 10.9875 6.84385 11.15 6.75635C11.3125 6.66885 11.4812 6.6001 11.6562 6.5501L11.7875 5.96885C11.8171 5.82772 11.8837 5.71429 11.9874 5.62854C12.091 5.54291 12.2119 5.5001 12.35 5.5001H12.6312C12.7694 5.5001 12.8902 5.54404 12.9939 5.63191C13.0975 5.71979 13.1641 5.8321 13.1937 5.96885L13.3437 6.5501C13.5187 6.6126 13.6906 6.68447 13.8594 6.76572C14.0281 6.84697 14.175 6.95635 14.3 7.09385L14.8812 6.94385C15.0187 6.90635 15.1436 6.91291 15.2559 6.96354C15.3682 7.01416 15.4559 7.0951 15.5187 7.20635L15.6687 7.4501C15.7312 7.5626 15.7562 7.68447 15.7437 7.81572C15.7312 7.94697 15.675 8.0626 15.575 8.1626L15.1625 8.55635C15.2 8.73135 15.2156 8.91572 15.2094 9.10947C15.2031 9.30322 15.1812 9.4876 15.1437 9.6626L15.575 10.0938C15.675 10.1938 15.7312 10.3095 15.7437 10.4407C15.7562 10.572 15.7312 10.6938 15.6687 10.8063L15.5422 11.0443C15.4766 11.1607 15.3812 11.2438 15.2562 11.2938C15.1312 11.3438 15 11.3501 14.8625 11.3126L14.2812 11.1251C14.1437 11.2501 13.9969 11.3532 13.8406 11.4345C13.6844 11.5157 13.5187 11.5876 13.3437 11.6501L13.175 12.2688C13.15 12.4063 13.0844 12.5126 12.9781 12.5876C12.8719 12.6626 12.7472 12.7001 12.6041 12.7001H12.3584C12.2153 12.7001 12.0875 12.6595 11.975 12.5782C11.8625 12.497 11.7937 12.3876 11.7687 12.2501L11.6562 11.6501C11.4812 11.5876 11.3156 11.5157 11.1594 11.4345C11.0031 11.3532 10.8562 11.2501 10.7187 11.1251ZM12.5039 10.4501C12.8763 10.4501 13.1937 10.3175 13.4562 10.0524C13.7187 9.78728 13.85 9.46854 13.85 9.09616C13.85 8.72379 13.7174 8.40635 13.4523 8.14385C13.1872 7.88135 12.8684 7.7501 12.496 7.7501C12.1237 7.7501 11.8062 7.88266 11.5437 8.14779C11.2812 8.41291 11.15 8.73166 11.15 9.10404C11.15 9.47641 11.2826 9.79385 11.5477 10.0563C11.8128 10.3188 12.1316 10.4501 12.5039 10.4501ZM2.14999 9.5501V4.1501V4.3376V1.4501V9.5501ZM2.14999 2.8001H13.85V1.4501H2.14999V2.8001ZM2.14999 10.9001C1.78749 10.9001 1.47186 10.7657 1.20311 10.497C0.934363 10.2282 0.799988 9.9126 0.799988 9.5501V1.4501C0.799988 1.0876 0.934363 0.771973 1.20311 0.503223C1.47186 0.234473 1.78749 0.100098 2.14999 0.100098H13.85C14.2212 0.100098 14.5391 0.234473 14.8034 0.503223C15.0678 0.771973 15.2 1.08791 15.2 1.45104V4.05916C15.2 4.25729 15.1125 4.40947 14.9375 4.51572C14.7625 4.62197 14.5786 4.6326 14.3859 4.5476C14.0911 4.4201 13.7839 4.32197 13.4643 4.25322C13.1448 4.18447 12.8171 4.1501 12.4812 4.1501C11.8229 4.1501 11.202 4.26885 10.6186 4.50635C10.0354 4.74385 9.52499 5.0751 9.08749 5.5001H2.14999V9.5501H7.19374C7.38499 9.5501 7.5453 9.61441 7.67468 9.74304C7.80405 9.87166 7.86874 10.031 7.86874 10.2212C7.86874 10.4113 7.80405 10.572 7.67468 10.7032C7.5453 10.8345 7.38499 10.9001 7.19374 10.9001H2.14999Z"
      fill="#ABB9E8"
    />
  </svg>
);

export const FillPGIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
  >
    <path
      d="M10.7187 11.1251L10.1187 11.3126C9.98124 11.3501 9.85143 11.3435 9.7293 11.2929C9.6073 11.2423 9.51211 11.1613 9.44374 11.0501L9.31249 10.8063C9.24999 10.6938 9.22499 10.5751 9.23749 10.4501C9.24999 10.3251 9.30624 10.2126 9.40624 10.1126L9.85624 9.6626C9.81874 9.4876 9.79999 9.30635 9.79999 9.11885C9.79999 8.93135 9.81874 8.7501 9.85624 8.5751L9.40624 8.1626C9.30624 8.0626 9.24999 7.9501 9.23749 7.8251C9.22499 7.7001 9.25105 7.57247 9.31568 7.44222L9.44055 7.19791C9.50518 7.07854 9.59999 6.99697 9.72499 6.95322C9.84999 6.90947 9.98124 6.90635 10.1187 6.94385L10.7 7.09385C10.8375 6.95635 10.9875 6.84385 11.15 6.75635C11.3125 6.66885 11.4812 6.6001 11.6562 6.5501L11.7875 5.96885C11.8171 5.82772 11.8837 5.71429 11.9874 5.62854C12.091 5.54291 12.2119 5.5001 12.35 5.5001H12.6312C12.7694 5.5001 12.8902 5.54404 12.9939 5.63191C13.0975 5.71979 13.1641 5.8321 13.1937 5.96885L13.3437 6.5501C13.5187 6.6126 13.6906 6.68447 13.8594 6.76572C14.0281 6.84697 14.175 6.95635 14.3 7.09385L14.8812 6.94385C15.0187 6.90635 15.1436 6.91291 15.2559 6.96354C15.3682 7.01416 15.4559 7.0951 15.5187 7.20635L15.6687 7.4501C15.7312 7.5626 15.7562 7.68447 15.7437 7.81572C15.7312 7.94697 15.675 8.0626 15.575 8.1626L15.1625 8.55635C15.2 8.73135 15.2156 8.91572 15.2094 9.10947C15.2031 9.30322 15.1812 9.4876 15.1437 9.6626L15.575 10.0938C15.675 10.1938 15.7312 10.3095 15.7437 10.4407C15.7562 10.572 15.7312 10.6938 15.6687 10.8063L15.5422 11.0443C15.4766 11.1607 15.3812 11.2438 15.2562 11.2938C15.1312 11.3438 15 11.3501 14.8625 11.3126L14.2812 11.1251C14.1437 11.2501 13.9969 11.3532 13.8406 11.4345C13.6844 11.5157 13.5187 11.5876 13.3437 11.6501L13.175 12.2688C13.15 12.4063 13.0844 12.5126 12.9781 12.5876C12.8719 12.6626 12.7472 12.7001 12.6041 12.7001H12.3584C12.2153 12.7001 12.0875 12.6595 11.975 12.5782C11.8625 12.497 11.7937 12.3876 11.7687 12.2501L11.6562 11.6501C11.4812 11.5876 11.3156 11.5157 11.1594 11.4345C11.0031 11.3532 10.8562 11.2501 10.7187 11.1251ZM12.5039 10.4501C12.8763 10.4501 13.1937 10.3175 13.4562 10.0524C13.7187 9.78728 13.85 9.46854 13.85 9.09616C13.85 8.72379 13.7174 8.40635 13.4523 8.14385C13.1872 7.88135 12.8684 7.7501 12.496 7.7501C12.1237 7.7501 11.8062 7.88266 11.5437 8.14779C11.2812 8.41291 11.15 8.73166 11.15 9.10404C11.15 9.47641 11.2826 9.79385 11.5477 10.0563C11.8128 10.3188 12.1316 10.4501 12.5039 10.4501ZM2.14999 9.5501V4.1501V4.3376V1.4501V9.5501ZM2.14999 2.8001H13.85V1.4501H2.14999V2.8001ZM2.14999 10.9001C1.78749 10.9001 1.47186 10.7657 1.20311 10.497C0.934363 10.2282 0.799988 9.9126 0.799988 9.5501V1.4501C0.799988 1.0876 0.934363 0.771973 1.20311 0.503223C1.47186 0.234473 1.78749 0.100098 2.14999 0.100098H13.85C14.2212 0.100098 14.5391 0.234473 14.8034 0.503223C15.0678 0.771973 15.2 1.08791 15.2 1.45104V4.05916C15.2 4.25729 15.1125 4.40947 14.9375 4.51572C14.7625 4.62197 14.5786 4.6326 14.3859 4.5476C14.0911 4.4201 13.7839 4.32197 13.4643 4.25322C13.1448 4.18447 12.8171 4.1501 12.4812 4.1501C11.8229 4.1501 11.202 4.26885 10.6186 4.50635C10.0354 4.74385 9.52499 5.0751 9.08749 5.5001H2.14999V9.5501H7.19374C7.38499 9.5501 7.5453 9.61441 7.67468 9.74304C7.80405 9.87166 7.86874 10.031 7.86874 10.2212C7.86874 10.4113 7.80405 10.572 7.67468 10.7032C7.5453 10.8345 7.38499 10.9001 7.19374 10.9001H2.14999Z"
      fill="#405189"
    />
  </svg>
);

export const OrderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <mask
      id="mask0_113_52"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="19"
    >
      <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_113_52)">
      <path
        d="M6.07107 13.1002C6.2612 13.1002 6.42189 13.0359 6.55314 12.9073C6.68439 12.7786 6.75001 12.6193 6.75001 12.4291C6.75001 12.239 6.6857 12.0783 6.55707 11.9471C6.42845 11.8158 6.26907 11.7502 6.07895 11.7502C5.88882 11.7502 5.72814 11.8145 5.59689 11.9431C5.46564 12.0718 5.40001 12.2311 5.40001 12.4213C5.40001 12.6114 5.46432 12.7721 5.59295 12.9033C5.72158 13.0346 5.88095 13.1002 6.07107 13.1002ZM6.07107 10.1752C6.2612 10.1752 6.42189 10.1109 6.55314 9.98226C6.68439 9.85363 6.75001 9.69426 6.75001 9.50413C6.75001 9.31401 6.6857 9.15332 6.55707 9.02207C6.42845 8.89082 6.26907 8.8252 6.07895 8.8252C5.88882 8.8252 5.72814 8.88951 5.59689 9.01813C5.46564 9.14676 5.40001 9.30613 5.40001 9.49626C5.40001 9.68638 5.46432 9.84707 5.59295 9.97832C5.72158 10.1096 5.88095 10.1752 6.07107 10.1752ZM6.07107 7.2502C6.2612 7.2502 6.42189 7.18588 6.55314 7.05726C6.68439 6.92863 6.75001 6.76926 6.75001 6.57913C6.75001 6.38901 6.6857 6.22832 6.55707 6.09707C6.42845 5.96582 6.26907 5.9002 6.07895 5.9002C5.88882 5.9002 5.72814 5.96451 5.59689 6.09313C5.46564 6.22176 5.40001 6.38113 5.40001 6.57126C5.40001 6.76138 5.46432 6.92207 5.59295 7.05332C5.72158 7.18457 5.88095 7.2502 6.07107 7.2502ZM8.77501 13.1002H11.925C12.1163 13.1002 12.2766 13.0359 12.406 12.9073C12.5353 12.7786 12.6 12.6193 12.6 12.4291C12.6 12.239 12.5353 12.0783 12.406 11.9471C12.2766 11.8158 12.1163 11.7502 11.925 11.7502H8.77501C8.58376 11.7502 8.42345 11.8145 8.29408 11.9431C8.1647 12.0718 8.10001 12.2311 8.10001 12.4213C8.10001 12.6114 8.1647 12.7721 8.29408 12.9033C8.42345 13.0346 8.58376 13.1002 8.77501 13.1002ZM8.77501 10.1752H11.925C12.1163 10.1752 12.2766 10.1109 12.406 9.98226C12.5353 9.85363 12.6 9.69426 12.6 9.50413C12.6 9.31401 12.5353 9.15332 12.406 9.02207C12.2766 8.89082 12.1163 8.8252 11.925 8.8252H8.77501C8.58376 8.8252 8.42345 8.88951 8.29408 9.01813C8.1647 9.14676 8.10001 9.30613 8.10001 9.49626C8.10001 9.68638 8.1647 9.84707 8.29408 9.97832C8.42345 10.1096 8.58376 10.1752 8.77501 10.1752ZM8.77501 7.2502H11.925C12.1163 7.2502 12.2766 7.18588 12.406 7.05726C12.5353 6.92863 12.6 6.76926 12.6 6.57913C12.6 6.38901 12.5353 6.22832 12.406 6.09707C12.2766 5.96582 12.1163 5.9002 11.925 5.9002H8.77501C8.58376 5.9002 8.42345 5.96451 8.29408 6.09313C8.1647 6.22176 8.10001 6.38113 8.10001 6.57126C8.10001 6.76138 8.1647 6.92207 8.29408 7.05332C8.42345 7.18457 8.58376 7.2502 8.77501 7.2502ZM4.05001 15.8002C3.67876 15.8002 3.36095 15.668 3.09657 15.4036C2.8322 15.1393 2.70001 14.8214 2.70001 14.4502V4.5502C2.70001 4.17895 2.8322 3.86113 3.09657 3.59676C3.36095 3.33238 3.67876 3.2002 4.05001 3.2002H13.95C14.3213 3.2002 14.6391 3.33238 14.9035 3.59676C15.1678 3.86113 15.3 4.17895 15.3 4.5502V14.4502C15.3 14.8214 15.1678 15.1393 14.9035 15.4036C14.6391 15.668 14.3213 15.8002 13.95 15.8002H4.05001ZM4.05001 14.4502H13.95V4.5502H4.05001V14.4502Z"
        fill="#ABB9E8"
      />
    </g>
  </svg>
);

export const FillOrderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <mask
      id="mask0_113_52"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="19"
    >
      <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_113_52)">
      <path
        d="M6.07107 13.1002C6.2612 13.1002 6.42189 13.0359 6.55314 12.9073C6.68439 12.7786 6.75001 12.6193 6.75001 12.4291C6.75001 12.239 6.6857 12.0783 6.55707 11.9471C6.42845 11.8158 6.26907 11.7502 6.07895 11.7502C5.88882 11.7502 5.72814 11.8145 5.59689 11.9431C5.46564 12.0718 5.40001 12.2311 5.40001 12.4213C5.40001 12.6114 5.46432 12.7721 5.59295 12.9033C5.72158 13.0346 5.88095 13.1002 6.07107 13.1002ZM6.07107 10.1752C6.2612 10.1752 6.42189 10.1109 6.55314 9.98226C6.68439 9.85363 6.75001 9.69426 6.75001 9.50413C6.75001 9.31401 6.6857 9.15332 6.55707 9.02207C6.42845 8.89082 6.26907 8.8252 6.07895 8.8252C5.88882 8.8252 5.72814 8.88951 5.59689 9.01813C5.46564 9.14676 5.40001 9.30613 5.40001 9.49626C5.40001 9.68638 5.46432 9.84707 5.59295 9.97832C5.72158 10.1096 5.88095 10.1752 6.07107 10.1752ZM6.07107 7.2502C6.2612 7.2502 6.42189 7.18588 6.55314 7.05726C6.68439 6.92863 6.75001 6.76926 6.75001 6.57913C6.75001 6.38901 6.6857 6.22832 6.55707 6.09707C6.42845 5.96582 6.26907 5.9002 6.07895 5.9002C5.88882 5.9002 5.72814 5.96451 5.59689 6.09313C5.46564 6.22176 5.40001 6.38113 5.40001 6.57126C5.40001 6.76138 5.46432 6.92207 5.59295 7.05332C5.72158 7.18457 5.88095 7.2502 6.07107 7.2502ZM8.77501 13.1002H11.925C12.1163 13.1002 12.2766 13.0359 12.406 12.9073C12.5353 12.7786 12.6 12.6193 12.6 12.4291C12.6 12.239 12.5353 12.0783 12.406 11.9471C12.2766 11.8158 12.1163 11.7502 11.925 11.7502H8.77501C8.58376 11.7502 8.42345 11.8145 8.29408 11.9431C8.1647 12.0718 8.10001 12.2311 8.10001 12.4213C8.10001 12.6114 8.1647 12.7721 8.29408 12.9033C8.42345 13.0346 8.58376 13.1002 8.77501 13.1002ZM8.77501 10.1752H11.925C12.1163 10.1752 12.2766 10.1109 12.406 9.98226C12.5353 9.85363 12.6 9.69426 12.6 9.50413C12.6 9.31401 12.5353 9.15332 12.406 9.02207C12.2766 8.89082 12.1163 8.8252 11.925 8.8252H8.77501C8.58376 8.8252 8.42345 8.88951 8.29408 9.01813C8.1647 9.14676 8.10001 9.30613 8.10001 9.49626C8.10001 9.68638 8.1647 9.84707 8.29408 9.97832C8.42345 10.1096 8.58376 10.1752 8.77501 10.1752ZM8.77501 7.2502H11.925C12.1163 7.2502 12.2766 7.18588 12.406 7.05726C12.5353 6.92863 12.6 6.76926 12.6 6.57913C12.6 6.38901 12.5353 6.22832 12.406 6.09707C12.2766 5.96582 12.1163 5.9002 11.925 5.9002H8.77501C8.58376 5.9002 8.42345 5.96451 8.29408 6.09313C8.1647 6.22176 8.10001 6.38113 8.10001 6.57126C8.10001 6.76138 8.1647 6.92207 8.29408 7.05332C8.42345 7.18457 8.58376 7.2502 8.77501 7.2502ZM4.05001 15.8002C3.67876 15.8002 3.36095 15.668 3.09657 15.4036C2.8322 15.1393 2.70001 14.8214 2.70001 14.4502V4.5502C2.70001 4.17895 2.8322 3.86113 3.09657 3.59676C3.36095 3.33238 3.67876 3.2002 4.05001 3.2002H13.95C14.3213 3.2002 14.6391 3.33238 14.9035 3.59676C15.1678 3.86113 15.3 4.17895 15.3 4.5502V14.4502C15.3 14.8214 15.1678 15.1393 14.9035 15.4036C14.6391 15.668 14.3213 15.8002 13.95 15.8002H4.05001ZM4.05001 14.4502H13.95V4.5502H4.05001V14.4502Z"
        fill="#405189"
      />
    </g>
  </svg>
);

export const AgMemberIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <mask
      id="mask0_444_97"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="15"
    >
      <rect x="0.5" width="15" height="15" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_444_97)">
      <path
        d="M6.92188 7.5C6.63021 7.5 6.39062 7.39062 6.20312 7.17188C6.01562 6.95312 5.94792 6.69792 6 6.40625L6.1875 5.28125C6.27083 4.83333 6.48177 4.46615 6.82031 4.17969C7.15885 3.89323 7.55208 3.75 8 3.75C8.45833 3.75 8.85677 3.89323 9.19531 4.17969C9.53385 4.46615 9.74479 4.83333 9.82812 5.28125L10.0156 6.40625C10.0677 6.69792 10 6.95312 9.8125 7.17188C9.625 7.39062 9.38542 7.5 9.09375 7.5H6.92188ZM7.29688 6.25H8.71875L8.59375 5.48438C8.57292 5.33854 8.50521 5.22135 8.39062 5.13281C8.27604 5.04427 8.14583 5 8 5C7.85417 5 7.72656 5.04427 7.61719 5.13281C7.50781 5.22135 7.44271 5.33854 7.42188 5.48438L7.29688 6.25ZM2.4375 8.10938C2.19792 8.11979 1.99219 8.07292 1.82031 7.96875C1.64844 7.86458 1.53646 7.70312 1.48438 7.48438C1.46354 7.39062 1.45833 7.29688 1.46875 7.20312C1.47917 7.10938 1.50521 7.02083 1.54688 6.9375C1.54688 6.94792 1.54167 6.92708 1.53125 6.875C1.51042 6.85417 1.45833 6.72917 1.375 6.5C1.35417 6.375 1.36979 6.25521 1.42188 6.14062C1.47396 6.02604 1.54167 5.92708 1.625 5.84375L1.65625 5.8125C1.67708 5.61458 1.75781 5.44792 1.89844 5.3125C2.03906 5.17708 2.21354 5.10938 2.42188 5.10938C2.45312 5.10938 2.55208 5.13021 2.71875 5.17188L2.76562 5.15625C2.81771 5.10417 2.88542 5.0651 2.96875 5.03906C3.05208 5.01302 3.14062 5 3.23438 5C3.34896 5 3.45052 5.01823 3.53906 5.05469C3.6276 5.09115 3.69792 5.14583 3.75 5.21875C3.76042 5.21875 3.76823 5.22135 3.77344 5.22656C3.77865 5.23177 3.78646 5.23438 3.79688 5.23438C3.94271 5.24479 4.07031 5.28906 4.17969 5.36719C4.28906 5.44531 4.36979 5.55208 4.42188 5.6875C4.44271 5.76042 4.45052 5.83073 4.44531 5.89844C4.4401 5.96615 4.42708 6.03125 4.40625 6.09375C4.40625 6.10417 4.41146 6.125 4.42188 6.15625C4.49479 6.22917 4.55208 6.3099 4.59375 6.39844C4.63542 6.48698 4.65625 6.57812 4.65625 6.67188C4.65625 6.71354 4.625 6.82292 4.5625 7C4.55208 7.02083 4.55208 7.04167 4.5625 7.0625L4.59375 7.3125C4.59375 7.53125 4.5026 7.71875 4.32031 7.875C4.13802 8.03125 3.91667 8.10938 3.65625 8.10938H2.4375ZM13 8.125C12.6562 8.125 12.362 8.0026 12.1172 7.75781C11.8724 7.51302 11.75 7.21875 11.75 6.875C11.75 6.75 11.7682 6.63281 11.8047 6.52344C11.8411 6.41406 11.8906 6.30729 11.9531 6.20312L11.5156 5.8125C11.4115 5.72917 11.3932 5.625 11.4609 5.5C11.5286 5.375 11.625 5.3125 11.75 5.3125H13C13.3438 5.3125 13.638 5.4349 13.8828 5.67969C14.1276 5.92448 14.25 6.21875 14.25 6.5625V6.875C14.25 7.21875 14.1276 7.51302 13.8828 7.75781C13.638 8.0026 13.3438 8.125 13 8.125ZM0.5 11.25V10.2656C0.5 9.80729 0.731771 9.4401 1.19531 9.16406C1.65885 8.88802 2.26042 8.75 3 8.75C3.13542 8.75 3.26562 8.7526 3.39062 8.75781C3.51562 8.76302 3.63542 8.77604 3.75 8.79688C3.60417 9.00521 3.49479 9.22917 3.42188 9.46875C3.34896 9.70833 3.3125 9.96354 3.3125 10.2344V11.25H0.5ZM4.25 11.25V10.2344C4.25 9.55729 4.59635 9.01042 5.28906 8.59375C5.98177 8.17708 6.88542 7.96875 8 7.96875C9.125 7.96875 10.0312 8.17708 10.7188 8.59375C11.4062 9.01042 11.75 9.55729 11.75 10.2344V11.25H4.25ZM13 8.75C13.75 8.75 14.3542 8.88802 14.8125 9.16406C15.2708 9.4401 15.5 9.80729 15.5 10.2656V11.25H12.6875V10.2344C12.6875 9.96354 12.6536 9.70833 12.5859 9.46875C12.5182 9.22917 12.4167 9.00521 12.2812 8.79688C12.3958 8.77604 12.513 8.76302 12.6328 8.75781C12.7526 8.7526 12.875 8.75 13 8.75ZM8 9.21875C7.40625 9.21875 6.875 9.29688 6.40625 9.45312C5.9375 9.60938 5.66146 9.79167 5.57812 10H10.4375C10.3438 9.79167 10.0651 9.60938 9.60156 9.45312C9.13802 9.29688 8.60417 9.21875 8 9.21875Z"
        fill="#ABB9E8"
      />
    </g>
  </svg>
);

export const FillAgMemberIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <mask
      id="mask0_444_97"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="15"
    >
      <rect x="0.5" width="15" height="15" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_444_97)">
      <path
        d="M6.92188 7.5C6.63021 7.5 6.39062 7.39062 6.20312 7.17188C6.01562 6.95312 5.94792 6.69792 6 6.40625L6.1875 5.28125C6.27083 4.83333 6.48177 4.46615 6.82031 4.17969C7.15885 3.89323 7.55208 3.75 8 3.75C8.45833 3.75 8.85677 3.89323 9.19531 4.17969C9.53385 4.46615 9.74479 4.83333 9.82812 5.28125L10.0156 6.40625C10.0677 6.69792 10 6.95312 9.8125 7.17188C9.625 7.39062 9.38542 7.5 9.09375 7.5H6.92188ZM7.29688 6.25H8.71875L8.59375 5.48438C8.57292 5.33854 8.50521 5.22135 8.39062 5.13281C8.27604 5.04427 8.14583 5 8 5C7.85417 5 7.72656 5.04427 7.61719 5.13281C7.50781 5.22135 7.44271 5.33854 7.42188 5.48438L7.29688 6.25ZM2.4375 8.10938C2.19792 8.11979 1.99219 8.07292 1.82031 7.96875C1.64844 7.86458 1.53646 7.70312 1.48438 7.48438C1.46354 7.39062 1.45833 7.29688 1.46875 7.20312C1.47917 7.10938 1.50521 7.02083 1.54688 6.9375C1.54688 6.94792 1.54167 6.92708 1.53125 6.875C1.51042 6.85417 1.45833 6.72917 1.375 6.5C1.35417 6.375 1.36979 6.25521 1.42188 6.14062C1.47396 6.02604 1.54167 5.92708 1.625 5.84375L1.65625 5.8125C1.67708 5.61458 1.75781 5.44792 1.89844 5.3125C2.03906 5.17708 2.21354 5.10938 2.42188 5.10938C2.45312 5.10938 2.55208 5.13021 2.71875 5.17188L2.76562 5.15625C2.81771 5.10417 2.88542 5.0651 2.96875 5.03906C3.05208 5.01302 3.14062 5 3.23438 5C3.34896 5 3.45052 5.01823 3.53906 5.05469C3.6276 5.09115 3.69792 5.14583 3.75 5.21875C3.76042 5.21875 3.76823 5.22135 3.77344 5.22656C3.77865 5.23177 3.78646 5.23438 3.79688 5.23438C3.94271 5.24479 4.07031 5.28906 4.17969 5.36719C4.28906 5.44531 4.36979 5.55208 4.42188 5.6875C4.44271 5.76042 4.45052 5.83073 4.44531 5.89844C4.4401 5.96615 4.42708 6.03125 4.40625 6.09375C4.40625 6.10417 4.41146 6.125 4.42188 6.15625C4.49479 6.22917 4.55208 6.3099 4.59375 6.39844C4.63542 6.48698 4.65625 6.57812 4.65625 6.67188C4.65625 6.71354 4.625 6.82292 4.5625 7C4.55208 7.02083 4.55208 7.04167 4.5625 7.0625L4.59375 7.3125C4.59375 7.53125 4.5026 7.71875 4.32031 7.875C4.13802 8.03125 3.91667 8.10938 3.65625 8.10938H2.4375ZM13 8.125C12.6562 8.125 12.362 8.0026 12.1172 7.75781C11.8724 7.51302 11.75 7.21875 11.75 6.875C11.75 6.75 11.7682 6.63281 11.8047 6.52344C11.8411 6.41406 11.8906 6.30729 11.9531 6.20312L11.5156 5.8125C11.4115 5.72917 11.3932 5.625 11.4609 5.5C11.5286 5.375 11.625 5.3125 11.75 5.3125H13C13.3438 5.3125 13.638 5.4349 13.8828 5.67969C14.1276 5.92448 14.25 6.21875 14.25 6.5625V6.875C14.25 7.21875 14.1276 7.51302 13.8828 7.75781C13.638 8.0026 13.3438 8.125 13 8.125ZM0.5 11.25V10.2656C0.5 9.80729 0.731771 9.4401 1.19531 9.16406C1.65885 8.88802 2.26042 8.75 3 8.75C3.13542 8.75 3.26562 8.7526 3.39062 8.75781C3.51562 8.76302 3.63542 8.77604 3.75 8.79688C3.60417 9.00521 3.49479 9.22917 3.42188 9.46875C3.34896 9.70833 3.3125 9.96354 3.3125 10.2344V11.25H0.5ZM4.25 11.25V10.2344C4.25 9.55729 4.59635 9.01042 5.28906 8.59375C5.98177 8.17708 6.88542 7.96875 8 7.96875C9.125 7.96875 10.0312 8.17708 10.7188 8.59375C11.4062 9.01042 11.75 9.55729 11.75 10.2344V11.25H4.25ZM13 8.75C13.75 8.75 14.3542 8.88802 14.8125 9.16406C15.2708 9.4401 15.5 9.80729 15.5 10.2656V11.25H12.6875V10.2344C12.6875 9.96354 12.6536 9.70833 12.5859 9.46875C12.5182 9.22917 12.4167 9.00521 12.2812 8.79688C12.3958 8.77604 12.513 8.76302 12.6328 8.75781C12.7526 8.7526 12.875 8.75 13 8.75ZM8 9.21875C7.40625 9.21875 6.875 9.29688 6.40625 9.45312C5.9375 9.60938 5.66146 9.79167 5.57812 10H10.4375C10.3438 9.79167 10.0651 9.60938 9.60156 9.45312C9.13802 9.29688 8.60417 9.21875 8 9.21875Z"
        fill="#405189"
      />
    </g>
  </svg>
);

export const AddIconBlue = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.66659 5.66683H5.66659V9.66683H4.33325V5.66683H0.333252V4.3335H4.33325V0.333496H5.66659V4.3335H9.66659V5.66683Z"
      fill="#026AFA"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66659 4V10.6667H2.33325V4H7.66659ZM6.66659 0H3.33325L2.66659 0.666667H0.333252V2H9.66659V0.666667H7.33325L6.66659 0ZM8.99992 2.66667H0.999919V10.6667C0.999919 11.4 1.59992 12 2.33325 12H7.66659C8.39992 12 8.99992 11.4 8.99992 10.6667V2.66667Z"
      fill="#026AFA"
    />
  </svg>
);

export const UpCarrotIcon = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.18436 5.99887L4.39998 2.78516L7.61561 5.99887L8.59998 5.01508L4.39998 0.817578L0.199982 5.01508L1.18436 5.99887Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const DownCarrotIcon = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.18436 0.00112915L4.39998 3.21484L7.61561 0.00112915L8.59998 0.984918L4.39998 5.18242L0.199982 0.984918L1.18436 0.00112915Z"
      fill="#FFFFFF"
    />
  </svg>
);
export const DragableIcon = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33341 9.99984C3.33341 10.7332 2.73341 11.3332 2.00008 11.3332C1.26675 11.3332 0.666748 10.7332 0.666748 9.99984C0.666748 9.2665 1.26675 8.6665 2.00008 8.6665C2.73341 8.6665 3.33341 9.2665 3.33341 9.99984ZM2.00008 4.6665C1.26675 4.6665 0.666748 5.2665 0.666748 5.99984C0.666748 6.73317 1.26675 7.33317 2.00008 7.33317C2.73341 7.33317 3.33341 6.73317 3.33341 5.99984C3.33341 5.2665 2.73341 4.6665 2.00008 4.6665ZM2.00008 0.666504C1.26675 0.666504 0.666748 1.2665 0.666748 1.99984C0.666748 2.73317 1.26675 3.33317 2.00008 3.33317C2.73341 3.33317 3.33341 2.73317 3.33341 1.99984C3.33341 1.2665 2.73341 0.666504 2.00008 0.666504ZM6.00008 3.33317C6.73341 3.33317 7.33341 2.73317 7.33341 1.99984C7.33341 1.2665 6.73341 0.666504 6.00008 0.666504C5.26675 0.666504 4.66675 1.2665 4.66675 1.99984C4.66675 2.73317 5.26675 3.33317 6.00008 3.33317ZM6.00008 4.6665C5.26675 4.6665 4.66675 5.2665 4.66675 5.99984C4.66675 6.73317 5.26675 7.33317 6.00008 7.33317C6.73341 7.33317 7.33341 6.73317 7.33341 5.99984C7.33341 5.2665 6.73341 4.6665 6.00008 4.6665ZM6.00008 8.6665C5.26675 8.6665 4.66675 9.2665 4.66675 9.99984C4.66675 10.7332 5.26675 11.3332 6.00008 11.3332C6.73341 11.3332 7.33341 10.7332 7.33341 9.99984C7.33341 9.2665 6.73341 8.6665 6.00008 8.6665Z"
      fill="#878A99"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.16675 13.4165H9.83341V8.4165H8.16675V13.4165ZM9.00008 6.74984C9.23619 6.74984 9.43411 6.66998 9.59383 6.51025C9.75355 6.35053 9.83341 6.15262 9.83341 5.9165C9.83341 5.68039 9.75355 5.48248 9.59383 5.32275C9.43411 5.16303 9.23619 5.08317 9.00008 5.08317C8.76397 5.08317 8.56605 5.16303 8.40633 5.32275C8.24661 5.48248 8.16675 5.68039 8.16675 5.9165C8.16675 6.15262 8.24661 6.35053 8.40633 6.51025C8.56605 6.66998 8.76397 6.74984 9.00008 6.74984ZM9.00008 17.5832C7.8473 17.5832 6.76397 17.3644 5.75008 16.9269C4.73619 16.4894 3.85425 15.8957 3.10425 15.1457C2.35425 14.3957 1.7605 13.5137 1.323 12.4998C0.885498 11.4859 0.666748 10.4026 0.666748 9.24984C0.666748 8.09706 0.885498 7.01373 1.323 5.99984C1.7605 4.98595 2.35425 4.104 3.10425 3.354C3.85425 2.604 4.73619 2.01025 5.75008 1.57275C6.76397 1.13525 7.8473 0.916504 9.00008 0.916504C10.1529 0.916504 11.2362 1.13525 12.2501 1.57275C13.264 2.01025 14.1459 2.604 14.8959 3.354C15.6459 4.104 16.2397 4.98595 16.6772 5.99984C17.1147 7.01373 17.3334 8.09706 17.3334 9.24984C17.3334 10.4026 17.1147 11.4859 16.6772 12.4998C16.2397 13.5137 15.6459 14.3957 14.8959 15.1457C14.1459 15.8957 13.264 16.4894 12.2501 16.9269C11.2362 17.3644 10.1529 17.5832 9.00008 17.5832ZM9.00008 15.9165C10.8612 15.9165 12.4376 15.2707 13.7292 13.979C15.0209 12.6873 15.6667 11.1109 15.6667 9.24984C15.6667 7.38873 15.0209 5.81234 13.7292 4.52067C12.4376 3.229 10.8612 2.58317 9.00008 2.58317C7.13897 2.58317 5.56258 3.229 4.27091 4.52067C2.97925 5.81234 2.33341 7.38873 2.33341 9.24984C2.33341 11.1109 2.97925 12.6873 4.27091 13.979C5.56258 15.2707 7.13897 15.9165 9.00008 15.9165Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const CrossIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="black" // Change color here
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="grey"
    width="24px"
    height="24px"
  >
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
  </svg>
);

export const PenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M1.75 12.25H2.69613L10.3735 4.57262L9.42738 3.6265L1.75 11.3039V12.25ZM1.303 13.375C1.11088 13.375 0.949875 13.31 0.82 13.18C0.69 13.0501 0.625 12.8891 0.625 12.697V11.3976C0.625 11.2147 0.660125 11.0404 0.730375 10.8747C0.8005 10.7089 0.897125 10.5645 1.02025 10.4414L10.5179 0.948062C10.6313 0.845062 10.7564 0.7655 10.8934 0.709375C11.0306 0.653125 11.1743 0.625 11.3247 0.625C11.4751 0.625 11.6207 0.651688 11.7616 0.705063C11.9026 0.758438 12.0274 0.843312 12.136 0.959687L13.0519 1.88706C13.1683 1.99569 13.2512 2.12069 13.3007 2.26206C13.3502 2.40344 13.375 2.54481 13.375 2.68619C13.375 2.83706 13.3493 2.981 13.2978 3.118C13.2463 3.25513 13.1643 3.38038 13.0519 3.49375L3.55862 12.9797C3.4355 13.1029 3.29106 13.1995 3.12531 13.2696C2.95956 13.3399 2.78525 13.375 2.60238 13.375H1.303ZM9.89219 4.10781L9.42738 3.6265L10.3735 4.57262L9.89219 4.10781Z"
      fill="#026AFA"
    />
  </svg>
);

export const AdvancedFilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M2.92692 9.1202C3.03525 8.80964 3.22484 8.55867 3.49567 8.36728C3.7665 8.17589 4.06803 8.0802 4.40025 8.0802C4.73248 8.0802 5.034 8.17589 5.30484 8.36728C5.57567 8.55867 5.76525 8.80964 5.87359 9.1202H11.1603V10.1602H5.87359C5.76525 10.4708 5.57567 10.7217 5.30484 10.9131C5.034 11.1045 4.73248 11.2002 4.40025 11.2002C4.06803 11.2002 3.7665 11.1045 3.49567 10.9131C3.22484 10.7217 3.03525 10.4708 2.92692 10.1602H0.760254V9.1202H2.92692ZM6.04692 5.4802C6.15525 5.16964 6.34484 4.91867 6.61567 4.72728C6.8865 4.53589 7.18803 4.4402 7.52025 4.4402C7.85248 4.4402 8.154 4.53589 8.42484 4.72728C8.69567 4.91867 8.88525 5.16964 8.99359 5.4802H11.1603V6.5202H8.99359C8.88525 6.83075 8.69567 7.08172 8.42484 7.27311C8.154 7.4645 7.85248 7.5602 7.52025 7.5602C7.18803 7.5602 6.8865 7.4645 6.61567 7.27311C6.34484 7.08172 6.15525 6.83075 6.04692 6.5202H0.760254V5.4802H6.04692ZM2.92692 1.8402C3.03525 1.52964 3.22484 1.27867 3.49567 1.08728C3.7665 0.89589 4.06803 0.800196 4.40025 0.800196C4.73248 0.800196 5.034 0.89589 5.30484 1.08728C5.57567 1.27867 5.76525 1.52964 5.87359 1.8402H11.1603V2.8802H5.87359C5.76525 3.19075 5.57567 3.44172 5.30484 3.63311C5.034 3.8245 4.73248 3.9202 4.40025 3.9202C4.06803 3.9202 3.7665 3.8245 3.49567 3.63311C3.22484 3.44172 3.03525 3.19075 2.92692 2.8802H0.760254V1.8402H2.92692Z"
      fill="#026AFA"
    />
  </svg>
);

export const ReportsIcon = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66626 10.8341V6.16748H11.3329V10.8341H8.66626ZM4.66626 10.8341V0.16748H7.33293V10.8341H4.66626ZM0.66626 10.8341V3.50081H3.33293V10.8341H0.66626Z"
      fill="#ABB9E8"
    />
  </svg>
);

export const ReportsFillIcon = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66626 10.8341V6.16748H11.3329V10.8341H8.66626ZM4.66626 10.8341V0.16748H7.33293V10.8341H4.66626ZM0.66626 10.8341V3.50081H3.33293V10.8341H0.66626Z"
      fill="#405189"
    />
  </svg>
);
